webpackJsonp([0],Array(43).concat([
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCatatan_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95a52592_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCatatan_vue__ = __webpack_require__(339);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCatatan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95a52592_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCatatan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_account_ChangePass__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Register__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Login__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_ResetPassword__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_UpdatePassword__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_account_Profile_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Pengajuan_AddHeader__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Pengajuan_DetilHeader__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Pengajuan_Pengajuan__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Pengajuan_Upload__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Brows_ListBrowsV2__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Brows_DetilBrows__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Brows_browseupload__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Brows_browseftz__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Pengajuan_PengajuanFtz__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Pengajuan_AddHeaderFtz__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Pengajuan_DetilHeaderFtz__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Brows_DetilBrowsFtz__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_SPPBMCP_listsppbmcp__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_RekonManifes_addbl__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_RekonManifes_browsebl__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_page404__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_ppftz_MenuAju__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_ppftz_Perekaman__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_ppftz_Browse__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_ppftz_browse_DetilPpftz__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_transit_FormTransitNew__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_transit_FormTransitA__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_transit_ResultTransit__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_transit_MenuTransit__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_pengumuman__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Tfasetup__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Tfaverify__ = __webpack_require__(408);


















































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_25__views_page404__["a" /* default */]
  }, {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y', 'M']
      }
    }, {
      path: 'changepass',
      name: 'Change Password',
      component: __WEBPACK_IMPORTED_MODULE_4__views_account_ChangePass__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: 'profile',
      name: 'Profile',
      component: __WEBPACK_IMPORTED_MODULE_9__views_account_Profile_vue__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y', 'M']
      }
    }]
  }, {
    path: '/pengajuan',
    redirect: '/pengajuan/listpengajuan',
    name: 'Pengajuan',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'listpengajuan',
      name: 'List',
      component: __WEBPACK_IMPORTED_MODULE_12__views_Pengajuan_Pengajuan__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: 'header',
      name: 'Header',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Pengajuan_AddHeader__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: 'detilheader/:idmohon',
      name: 'DetilHeader',
      component: __WEBPACK_IMPORTED_MODULE_11__views_Pengajuan_DetilHeader__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: 'dokap',
      name: 'Dokumen Pelengkap',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Pengajuan_AddHeader__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: '/pengajuan/upload',
      name: 'Upload Laporan',
      component: __WEBPACK_IMPORTED_MODULE_13__views_Pengajuan_Upload__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }]
  }, {
    path: '/brows',
    redirect: '/brows/listbrows',
    name: 'Browse',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'listbrows',
      name: 'List Browse',
      component: __WEBPACK_IMPORTED_MODULE_14__views_Brows_ListBrowsV2__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: 'detilbrows/:idmohon',
      name: 'Detil Browse',
      component: __WEBPACK_IMPORTED_MODULE_15__views_Brows_DetilBrows__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: '/pengajuan/browseupload',
      name: ' Browse Upload Laporan',
      component: __WEBPACK_IMPORTED_MODULE_16__views_Brows_browseupload__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }]
  }, {
    path: '/browseftz',
    redirect: '/browseftz/list',
    name: 'Browse PPFTZ',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'list',
      name: 'List Browse',
      component: __WEBPACK_IMPORTED_MODULE_17__views_Brows_browseftz__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: 'list/:idmohon',
      name: 'Detil Browse',
      component: __WEBPACK_IMPORTED_MODULE_21__views_Brows_DetilBrowsFtz__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }]
  }, {
    path: '/pengajuanftz',
    redirect: '/pengajuanftz/list',
    name: 'Pengajuan',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'list',
      name: 'List Pengajuan FTZ',
      component: __WEBPACK_IMPORTED_MODULE_18__views_Pengajuan_PengajuanFtz__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: 'addheader',
      name: 'Tambah Pengajuan FTZ',
      component: __WEBPACK_IMPORTED_MODULE_19__views_Pengajuan_AddHeaderFtz__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: 'detilheader/:idmohon',
      name: 'DetilHeader Gabungan',
      component: __WEBPACK_IMPORTED_MODULE_20__views_Pengajuan_DetilHeaderFtz__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }]
  }, {
    path: '/sppbmcp',
    redirect: '/sppbmcp/listsppbmcp',
    name: 'SPPBMCP',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'listsppbmcp',
      name: 'List SPPBMCP',
      component: __WEBPACK_IMPORTED_MODULE_22__views_SPPBMCP_listsppbmcp__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }]
  }, {
    path: '/rekonmanifes/',
    redirect: '/rekonmanifes/browse',
    name: 'Browse',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: '/rekonmanifes/browse',
      name: 'Browse BL/AWB',
      component: __WEBPACK_IMPORTED_MODULE_24__views_RekonManifes_browsebl__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }, {
      path: '/rekonmanifes/add',
      name: 'Tambah BL/AWB',
      component: __WEBPACK_IMPORTED_MODULE_23__views_RekonManifes_addbl__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['N', 'S', 'Y']
      }
    }]
  }, {
    path: '/register',
    name: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Register__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Login__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/resetpassword',
    name: 'Lupa Password',
    component: __WEBPACK_IMPORTED_MODULE_7__views_ResetPassword__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/updatepassword/:token',
    name: 'Lupa Password',
    component: __WEBPACK_IMPORTED_MODULE_8__views_UpdatePassword__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/ppftz/',
    redirect: '/ppftz/browse',
    name: 'PPFTZ Manual',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: '/ppftz/perekaman',
      name: 'Perekaman',
      component: __WEBPACK_IMPORTED_MODULE_26__views_ppftz_MenuAju__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['M', 'Y']
      }
    }, {
      path: '/ppftz/perekaman/:id',
      name: 'Perekaman',
      component: __WEBPACK_IMPORTED_MODULE_27__views_ppftz_Perekaman__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['M', 'Y']
      }
    }, {
      path: '/ppftz/browse',
      name: 'Browse',
      component: __WEBPACK_IMPORTED_MODULE_28__views_ppftz_Browse__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['M', 'Y']
      }
    }, {
      path: '/ppftz/browse/:id',
      name: 'Browse',
      component: __WEBPACK_IMPORTED_MODULE_29__views_ppftz_browse_DetilPpftz__["a" /* default */],
      meta: {
        forAuth: true,
        access: ['M', 'Y']
      }
    }]
  }, {
    path: '/menutransit',
    name: 'Pemberitahuan Barang Transit',
    component: __WEBPACK_IMPORTED_MODULE_33__views_transit_MenuTransit__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/formtransit',
    name: 'Pemberitahuan Barang Transit',
    component: __WEBPACK_IMPORTED_MODULE_30__views_transit_FormTransitNew__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/formtransitA-aquarayaikn',
    name: 'Pemberitahuan Barang Transit',
    component: __WEBPACK_IMPORTED_MODULE_31__views_transit_FormTransitA__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/resulttransit/:id',
    name: 'Kode Registrasi',
    component: __WEBPACK_IMPORTED_MODULE_32__views_transit_ResultTransit__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/pengumuman',
    name: 'Pengumuman WBBM',
    component: __WEBPACK_IMPORTED_MODULE_34__views_pengumuman__["a" /* default */],
    meta: {
      forVisitors: true
    }
  }, {
    path: '/tfa/setup',
    name: 'TFA Setup',
    component: __WEBPACK_IMPORTED_MODULE_35__views_Tfasetup__["a" /* default */]
  }, {
    path: '/tfa/verify',
    name: 'TFA Verify',
    component: __WEBPACK_IMPORTED_MODULE_36__views_Tfaverify__["a" /* default */]
  }]
}));

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9125bc96_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(155);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9125bc96_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__barpin__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tfa__ = __webpack_require__(441);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */],
    barpin: __WEBPACK_IMPORTED_MODULE_3__barpin__["a" /* default */],
    tfa: __WEBPACK_IMPORTED_MODULE_4__tfa__["a" /* default */]
  }
}));

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_auth_js__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_progressbar__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_instant__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_instant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_instant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_index__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_instant_dist_vue_instant_css__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_instant_dist_vue_instant_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_instant_dist_vue_instant_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jw_vue_pagination__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jw_vue_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_jw_vue_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_numeric__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_search_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay__);



















__webpack_require__(444);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ValidationObserver', __WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* ValidationObserver */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ValidationProvider', __WEBPACK_IMPORTED_MODULE_8_vee_validate__["b" /* ValidationProvider */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('jw-pagination', __WEBPACK_IMPORTED_MODULE_12_jw_vue_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('model-list-select', __WEBPACK_IMPORTED_MODULE_14_vue_search_select__["ModelListSelect"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Loading', __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_numeric___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_instant___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__js_auth_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["d" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_progressbar___default.a, {
  color: 'rgb(43, 140, 255)',
  failedColor: 'red',
  height: '2px'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.base = 'https://bcbatam.com/backper/public';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = 'https://bcbatam.com/backper/public/api';
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.baseURL = 'https://bcbatam.com/backper/public/api';

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  var isAuth = __WEBPACK_IMPORTED_MODULE_10__store_index__["a" /* default */].getters['auth/authenticated'];

  if (to.matched.some(function (record) {
    return record.meta.forAuth;
  })) {
    if (isAuth) {
      var jenisAkun = __WEBPACK_IMPORTED_MODULE_10__store_index__["a" /* default */].getters['auth/user']['ppjk'];
      if (to.meta.access) {
        if (to.meta.access.some(function (akses) {
          return akses === jenisAkun;
        })) {
          next();
        } else {
          next({
            path: '/unauthorize'
          });
        }
      } else {
        next();
      }
    } else {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      });
    }
  } else if (to.matched.some(function (record) {
    return record.meta.forVisitors;
  })) {
    if (isAuth) {
      next({
        path: '/dashboard'
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_10__store_index__["a" /* default */].dispatch('auth/attempt', localStorage.getItem('token')).then(function () {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_10__store_index__["a" /* default */],
    template: '<App/>',
    components: {
      App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
    }
  });
});

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79809149_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(85);
function injectStyle (ssrContext) {
  __webpack_require__(80)
  __webpack_require__(82)
  __webpack_require__(83)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79809149_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18fb6854_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(156);
function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18fb6854"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18fb6854_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components___ = __webpack_require__(121);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_3__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__components___["e" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_3__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_3__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_2__nav__["a" /* default */].itemsIonBeta
    };
  },
  created: function created() {
    this.menu();
  },

  methods: {
    menu: function menu() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var akses;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.getters['auth/user'];

              case 2:
                akses = _context.sent;

                console.log(akses.ppjk);
                if (akses.ppjk === 'M') {
                  _this.nav = __WEBPACK_IMPORTED_MODULE_2__nav__["a" /* default */].itemsBarpin;
                } else if (akses.ppjk === 'Y') {
                  _this.nav.push(__WEBPACK_IMPORTED_MODULE_2__nav__["a" /* default */].barpin);
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var itemsIonBeta = [{
  name: 'Dashboard',
  url: '/dashboard',
  icon: 'icon-speedometer'
}, {
  name: 'Perizinan',
  url: '/perizinan',
  icon: 'icon-docs',
  children: [{
    name: 'Pengajuan',
    url: '/pengajuan',
    icon: 'icon-doc'
  }, {
    name: 'Browse',
    url: '/brows',
    icon: 'icon-magnifier'
  }]
}, {
  name: 'Upload',
  url: '/upload',
  icon: 'icon-arrow-up-circle ',
  children: [{
    name: 'Upload Laporan',
    url: '/pengajuan/upload',
    icon: 'icon-arrow-up-circle '
  }, {
    name: 'Browse Upload Laporan',
    url: '/pengajuan/browseupload',
    icon: 'icon-magnifier'
  }]
}, {
  name: 'Rekonsiliasi Manifes',
  icon: 'icon-size-actual',
  url: '/rekonmanifes',
  children: [{
    name: 'Browse',
    url: '/rekonmanifes/browse',
    icon: 'icon-magnifier'
  }]
}, {
  name: 'SPPBMCP',
  icon: 'icon-docs',
  children: [{
    name: 'Browse SPPBMCP',
    url: '/sppbmcp/listsppbmcp',
    icon: 'icon-magnifier'
  }]
}];

var itemsBarpin = [{
  name: 'Dashboard',
  url: '/dashboard',
  icon: 'icon-speedometer'
}, {
  name: 'PPFTZ Manual',
  url: '/ppftz',
  icon: 'icon-docs',
  children: [{
    name: 'Perekaman',
    url: '/ppftz/perekaman',
    icon: 'icon-plus'
  }, {
    name: 'Browse',
    url: '/ppftz/browse',
    icon: 'icon-magnifier'
  }]
}];

var barpin = {
  name: 'PPFTZ Manual',
  url: '/ppftz',
  icon: 'icon-docs',
  children: [{
    name: 'Perekaman',
    url: '/ppftz/perekaman',
    icon: 'icon-plus'
  }, {
    name: 'Browse',
    url: '/ppftz/browse',
    icon: 'icon-magnifier'
  }]
};
/* harmony default export */ __webpack_exports__["a"] = ({ itemsIonBeta: itemsIonBeta, itemsBarpin: itemsBarpin, barpin: barpin });

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_392248c7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(124);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_392248c7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside'
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside-menu"
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7f702f8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(127);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7f702f8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d8d402_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(130);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d8d402_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classList
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20cc949c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(133);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20cc949c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\logo.png",
      "height": "40px",
      "width": "100px"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://bcbatam.beacukai.go.id/"
    }
  }, [_vm._v("KPU BC Batam")]), _vm._v(" © 2022. Versi 2.1.2\n")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41fef88e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(140);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41fef88e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  data: {},
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    logout: function logout() {
      var _this = this;

      this.signOut().then(function () {
        _this.$router.push({ path: '/login' });
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    signOut: 'auth/logout'
  }), {
    changepw: function changepw() {
      this.$router.push('/changepass');
    },
    profile: function profile() {
      this.$router.push('/profile');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    authenticated: 'auth/authenticated',
    user: 'auth/user'
  }))
});

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "#"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler sidebar-toggler d-md-down-none mr-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('div', {
    staticClass: "d-none d-lg-block",
    staticStyle: {}
  }, [_c('b', [_vm._v("KANTOR PELAYANAN UTAMA BEA DAN CUKAI TIPE B BATAM")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("TELEPON (0778) 458818, 458263; FAKSIMILI (0778) 458149;SURAT ELEKTRONIK kpubcbatam@kemenkeu.go.id")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.user['username']))])]), _vm._v(" "), _c('b-dropdown-header', {
    staticClass: "text-center",
    attrs: {
      "tag": "div"
    }
  }, [_c('strong', [_vm._v("Account")])]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.profile
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Profile\n      ")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.changepw
    }
  }, [_c('i', {
    staticClass: "fa fa-shield"
  }), _vm._v(" Change Password\n      ")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout\n      ")])], 2), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler aside-menu-toggler d-md-down-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.asideToggle
    }
  }, [_vm._v("☰")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd1f09aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(153);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd1f09aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarNavDropdown__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavLink__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavTitle__ = __webpack_require__(150);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_0__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_1__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_2__SidebarNavTitle__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615a674e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(146);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615a674e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": _vm.url,
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.name))]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c32987c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(149);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c32987c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      default: ''
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": _vm.url
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.name) + "\n  "), _c('b-badge', {
    attrs: {
      "variant": _vm.badge.variant
    }
  }, [_vm._v(_vm._s(_vm.badge.text))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2713d0c0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(152);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2713d0c0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('div', {
    slot: "header"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(item.title) ? [_c('SidebarNavTitle', {
      attrs: {
        "name": item.name
      }
    })] : (item.divider) ? [_c('li', {
      staticClass: "divider"
    })] : [(item.children) ? [_c('SidebarNavDropdown', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon
      }
    }, [_vm._l((item.children), function(child, index) {
      return [(child.children) ? [_c('SidebarNavDropdown', {
        attrs: {
          "name": child.name,
          "url": child.url,
          "icon": child.icon
        }
      }, _vm._l((item.children), function(child, index) {
        return _c('li', {
          staticClass: "nav-item"
        }, [_c('SidebarNavLink', {
          attrs: {
            "name": child.name,
            "url": child.url,
            "icon": child.icon,
            "badge": child.badge
          }
        })], 1)
      }))] : [_c('li', {
        staticClass: "nav-item"
      }, [_c('SidebarNavLink', {
        attrs: {
          "name": child.name,
          "url": child.url,
          "icon": child.icon,
          "badge": child.badge
        }
      })], 1)]]
    })], 2)] : [_c('SidebarNavLink', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon,
        "badge": item.badge
      }
    })]]], 2)
  })), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    slot: "footer"
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.classList
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), (_vm.isOn) ? [_c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": _vm.on,
      "data-off": _vm.off
    }
  })] : [_c('span', {
    staticClass: "switch-label"
  })], _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar', {
    attrs: {
      "navItems": _vm.nav
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('AppAside')], 1), _vm._v(" "), _c('AppFooter')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1cdb34a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(159);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1cdb34a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      modalInformasi: true
    };
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> My Dashboard"
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Informasi!!",
      "hide-footer": ""
    },
    model: {
      value: (_vm.modalInformasi),
      callback: function($$v) {
        _vm.modalInformasi = $$v
      },
      expression: "modalInformasi"
    }
  }, [_c('p', [_vm._v("berdasarkan PER-6/PJ/2024 maka per tanggal 01 Januari 2024 diberlakukan ketentuan NPWP 16 digit. Diharapkan anda dapat mengganti NPWP anda secara mandiri dengan cara sebagai berikut:")]), _vm._v(" "), _c('p', [_vm._v("1. Klik Akun anda di pojok kanan atas halaman web ini")]), _vm._v(" "), _c('p', [_vm._v("2. Klik profile")]), _vm._v(" "), _c('p', [_vm._v("3. Pastikan data yang ditampilkan sesuai")]), _vm._v(" "), _c('p', [_vm._v("4. Klik Ubah NPWP")]), _vm._v(" "), _c('p', [_vm._v("5. Masukkan NPWP 16 digit anda")]), _vm._v(" "), _c('p', [_vm._v("6. Klik Simpan")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "to": '/profile'
    }
  }, [_vm._v("Ke Profil "), _c('i', {
    staticClass: "fa fa-arrow"
  })])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePass_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d091068_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePass_vue__ = __webpack_require__(164);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d091068"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d091068_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePass_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'changepass',
  data: function data() {
    return {
      password: '',
      newpass: '',
      retypepass: ''
    };
  },

  methods: {
    change: function change() {
      var _this = this;

      this.$Progress.start();
      var data = {
        user: this.$store.getters['auth/user']['username'],
        password: this.password,
        newpass: this.newpass,
        retypepass: this.retypepass
      };
      if (this.newpass === this.retypepass) {
        this.$http.post('changepw', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this.$router.push('/');
          _this.$Progress.finish();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('', 'New Password not match Re-Type Password', 'error');
      }
    }
  }
});

/***/ }),
/* 163 */,
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Change Password")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Your Password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Enter Password.."
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "New Password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Enter New Password.."
    },
    model: {
      value: (_vm.newpass),
      callback: function($$v) {
        _vm.newpass = $$v
      },
      expression: "newpass"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Re-Type New Password",
      "description": "Please enter your password."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Re-Type New Password.."
    },
    model: {
      value: (_vm.retypepass),
      callback: function($$v) {
        _vm.retypepass = $$v
      },
      expression: "retypepass"
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.change
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfc97aa8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(167);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfc97aa8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a, VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */] },
  data: function data() {
    return {
      form: {
        perkdid: '5',
        perid: '',
        pernama: '',
        peralamat: '',
        pernotelp: '',
        peremail: '',
        perakses: 'N',
        dafkdid: '5',
        dafid: '',
        dafnama: '',
        dafalamat: '',
        dafnotelp: '',
        dafemail: '',
        daffileid: '',
        username: '',
        password: '',
        fileperid: '',
        filedafid: '',
        exfileperid: '',
        exfiledafid: '',
        filesrtkuasa: '',
        exfilesrtkuasa: '',
        filesrtpernyataan: '',
        exfilesrtpernyataan: '',
        recaptchaToken: ''
      },
      isLoading: false,
      sitekey: '6LfnWwIqAAAAANCiVDEj6w0E6IzsYRw7_6Kg3IZd'
    };
  },

  methods: {
    chfileperid: function chfileperid(e) {
      var _this = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      this.form.exfileperid = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      fileReader.readAsDataURL(e.target.files[0]);
      fileReader.onload = function (e) {
        _this.form.fileperid = e.target.result;
      };
      this.$Progress.finish();
    },
    chfiledafid: function chfiledafid(e) {
      var _this2 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      this.form.exfiledafid = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      fileReader.readAsDataURL(e.target.files[0]);
      fileReader.onload = function (e) {
        _this2.form.filedafid = e.target.result;
      };
      this.$Progress.finish();
    },
    chsuratkuasa: function chsuratkuasa(e) {
      var _this3 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      this.form.exfilesrtkuasa = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      fileReader.readAsDataURL(e.target.files[0]);
      fileReader.onload = function (e) {
        _this3.form.filesrtkuasa = e.target.result;
      };
      this.$Progress.finish();
    },
    chsuratpernyataan: function chsuratpernyataan(e) {
      var _this4 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      this.form.exfilesrtpernyataan = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      fileReader.readAsDataURL(e.target.files[0]);
      fileReader.onload = function (e) {
        _this4.form.filesrtpernyataan = e.target.result;
      };
      this.$Progress.finish();
    },
    sendmail: function sendmail() {
      var mail = {
        page: 'register',
        subject: 'Registrasi User',
        data: this.form.pernama,
        email: this.form.peremail,
        nama: this.form.pernama,
        peralamat: this.form.peralamat,
        peremail: this.form.peremail,
        dafnama: this.form.dafnama,
        dafalamat: this.form.dafalamat,
        dafnotelp: this.form.dafnotelp,
        dafemail: this.form.dafemail,
        username: this.form.username,
        password: this.form.password,
        npwp: this.form.perid
      };
      this.$http.post('bc/mail/kir-fidut-telstb1', mail);
    },
    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      this.form.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.form.recaptchaToken = '';
    },
    sendregis: function sendregis() {
      var _this5 = this;

      this.$validator.validateAll().then(function (result) {
        if (result && _this5.form.recaptchaToken) {
          _this5.$Progress.start();
          _this5.isLoading = true;
          _this5.$http.post('reg-madurm171', _this5.form).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()(response.data.status, response.data.message, response.data.status);
            if (response.data.status === 'success') {
              _this5.sendmail();
              _this5.isLoading = false;
              _this5.$router.push('/login');
            }
            _this5.$Progress.finish();
          }).catch(function (error) {
            _this5.isLoading = false;
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()(error.data.status, error.data.message, error.data.status);
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', 'Mohon Isi dengan Lengkap', 'error');
        }
      });
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Identitas Perusahaan")]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Id Perusahaan')),
      expression: " errors.has( 'No Id Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('No Id Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Identitas")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.perkdid),
      expression: " form.perkdid "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "kdid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.perkdid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Paspor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.form.perkdid === '5' ? 'required|min:16' : 'required'),
      expression: "form.perkdid === '5' ? 'required|min:16' : 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.perid),
      expression: " form.perid "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "No Id Perusahaan",
      "type": "text",
      "placeholder": "No Identitas"
    },
    domProps: {
      "value": (_vm.form.perid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.perid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Upload Identitas")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.chfileperid
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Perusahaan')),
      expression: " errors.has( 'Nama Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Nama Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pernama),
      expression: " form.pernama "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Perusahaan",
      "type": "text",
      "placeholder": "Nama Perusahaan"
    },
    domProps: {
      "value": (_vm.form.pernama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.pernama = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat Perusahaan')),
      expression: " errors.has( 'Alamat Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Alamat Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.peralamat),
      expression: " form.peralamat "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Alamat Perusahaan",
      "type": "text",
      "placeholder": "Alamat Perusahaan"
    },
    domProps: {
      "value": (_vm.form.peralamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.peralamat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Telepon Perusahaan')),
      expression: " errors.has( 'No Telepon Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('No Telepon Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15|min:3'),
      expression: " 'required|max:15|min:3' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pernotelp),
      expression: " form.pernotelp "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "No Telepon Perusahaan",
      "type": "text",
      "placeholder": "No Telepon Perusahaan"
    },
    domProps: {
      "value": (_vm.form.pernotelp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.pernotelp = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email Perusahaan')),
      expression: " errors.has( 'Email Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Email Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: " 'required|email' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.peremail),
      expression: " form.peremail "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Email Perusahaan",
      "type": "text",
      "placeholder": "Email Perusahaan"
    },
    domProps: {
      "value": (_vm.form.peremail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.peremail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Akses Kepabeanan")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.perakses),
      expression: " form.perakses "
    }],
    staticClass: "form-control",
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.perakses = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "N",
      "selected": "true"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Y"
    }
  }, [_vm._v("PENGANGKUT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Y"
    }
  }, [_vm._v("PPJK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("IMPORTIR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("EKSPORTIR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("PERORANGAN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "S"
    }
  }, [_vm._v("PENGUSAHA TPS/KP/BKC/")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("PENGUSAHA JASA TITIPAN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("PPFTZ Manual")])])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: " errors.has( 'username' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('username')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.username),
      expression: " form.username "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.form.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: " errors.has( 'password' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('password')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: " form.password "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Identitas Pendaftar")]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Identitas Pendaftar')),
      expression: " errors.has( 'No Identitas Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('No Identitas Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Identitas")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafkdid),
      expression: " form.dafkdid "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "kdid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.dafkdid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Paspor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.form.dafkdid === '5' ? 'required|min:16' : 'required'),
      expression: "form.dafkdid === '5' ? 'required|min:16' : 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafid),
      expression: " form.dafid "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "No Identitas Pendaftar",
      "type": "text",
      "placeholder": "No Identitas Pendaftar"
    },
    domProps: {
      "value": (_vm.form.dafid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Upload Identitas")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.chfiledafid
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Pendaftar')),
      expression: " errors.has( 'Nama Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Nama Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafnama),
      expression: " form.dafnama "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Pendaftar",
      "type": "text",
      "placeholder": "Nama Pendaftar"
    },
    domProps: {
      "value": (_vm.form.dafnama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafnama = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat Pendaftar')),
      expression: " errors.has( 'Alamat Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Alamat Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafalamat),
      expression: " form.dafalamat "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Alamat Pendaftar",
      "type": "text",
      "placeholder": "Alamat Pendaftar"
    },
    domProps: {
      "value": (_vm.form.dafalamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafalamat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Telepon Pendaftar')),
      expression: " errors.has( 'No Telepon Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('No Telepon Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15|min:3'),
      expression: " 'required|max:15|min:3' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafnotelp),
      expression: " form.dafnotelp "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "No Telepon Pendaftar",
      "type": "text",
      "placeholder": "No Telepon Pendaftar (Contoh: 081234567890)"
    },
    domProps: {
      "value": (_vm.form.dafnotelp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafnotelp = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email Pendaftar')),
      expression: " errors.has( 'Email Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Email Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: " 'required|email' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafemail),
      expression: " form.dafemail "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Email Pendaftar",
      "type": "text",
      "placeholder": "Email Pendaftar"
    },
    domProps: {
      "value": (_vm.form.dafemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafemail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('File Surat Pernyataan')),
      expression: " errors.has( 'File Surat Pernyataan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('File Surat Pernyataan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Surat Pernyataan")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "File Surat Pernyataan"
    },
    on: {
      "change": _vm.chsuratpernyataan
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Surat Kuasa")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "File Surat Kuasa"
    },
    on: {
      "change": _vm.chsuratkuasa
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendregis
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Create Account")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('router-link', {
    staticClass: "btn btn-block btn-danger",
    attrs: {
      "to": '/login'
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Cancel\n                    ")])], 1)])])])])], 1)])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', [_vm._v("Register")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6aa830_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(170);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6aa830_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_button_spinner__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_button_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_button_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },

  components: {
    VueButtonSpinner: __WEBPACK_IMPORTED_MODULE_1_vue_button_spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    authenticated: 'auth/authenticated',
    user: 'auth/user'
  }), {
    loading: function loading() {
      return this.$store.getters['auth/isLoading'];
    },
    alert: function alert() {
      return this.$store.getters['auth/loginAlert'];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    login: 'auth/login'
  }), {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var data = {
            USER_NAME: _this.username,
            password: _this.password
          };

          _this.login(data).then(function (response) {
            _this.$store.commit('auth/SET_LOADING', false);
            if (response.data.tfa_required) {
              localStorage.setItem('USER_NAME', data.USER_NAME);
              localStorage.setItem('password', data.password);
              _this.$router.push({ path: '/tfa/setup' });
            } else if (response.data.tfa_verification_needed) {
              localStorage.setItem('USER_NAME', data.USER_NAME);
              localStorage.setItem('password', data.password);

              _this.$router.push({ path: '/tfa/verify' });
            } else {
              _this.$router.push({ path: '/dashboard' });
            }
          });
        }
      });
    }
  })
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Sign In to your account")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#/login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('vue-button-spinner', {
    staticStyle: {
      "background-color": "#20a8d8",
      "color": "white"
    },
    attrs: {
      "is-loading": _vm.loading,
      "disabled": _vm.loading,
      "type": "submit"
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('span', [_vm._v("Login")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link px-0",
    attrs: {
      "to": '/resetpassword'
    }
  }, [_vm._v("Forgot password?")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card d-md-down"
  }, [_c('div', {
    staticClass: "card-body text-center text-white bg-primary"
  }, [_c('div', [_c('h2', [_vm._v("Sign up")]), _vm._v(" "), _c('p', [_vm._v("Belum Memiliki User??")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary active mt-3",
    attrs: {
      "to": '/register'
    }
  }, [_vm._v("Register Now!")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-center"
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("Lapor Barang Transit")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    attrs: {
      "to": '/menutransit'
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-truck"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Klik Disini!")])])], 1)])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\icon.jpeg",
      "width": "100%"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e45e51_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(173);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e45e51_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_button_spinner__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_button_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_button_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      isLoading: false
    };
  },

  components: {
    VueButtonSpinner: __WEBPACK_IMPORTED_MODULE_0_vue_button_spinner___default.a
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.isLoading = true;
          var data = {
            email: _this.email
          };
          _this.$http.post('sendPasswordResetLink', data).then(function () {
            _this.isLoading = false;
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('success', 'Berhasil mengirim email!', 'success');
          }).catch(function () {
            _this.isLoading = false;
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', 'Email tidak ditemukan', 'error');
          });
        }
        _this.isLoading = true;
      });
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit()
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "description": "Please enter your email",
      "label": "Reset Password",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Enter your email",
      "name": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('email')) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-left": "2rem"
    }
  }, [_c('vue-button-spinner', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#20a8d8",
      "color": "white",
      "border-radius": "6px",
      "width": "150px"
    },
    attrs: {
      "is-loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "type": "submit"
    }
  }, [_c('span', [_vm._v("Kirim")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger",
    attrs: {
      "to": '/login'
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Cancel")])], 1)], 1)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\icon.jpeg",
      "width": "100%"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdatePassword_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e90014d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UpdatePassword_vue__ = __webpack_require__(176);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdatePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e90014d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UpdatePassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_button_spinner__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_button_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_button_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: this.$route.params.token,
      isLoading: false,
      password: '',
      confirm: ''
    };
  },

  components: {
    VueButtonSpinner: __WEBPACK_IMPORTED_MODULE_0_vue_button_spinner___default.a
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.isLoading = true;
          var data = {
            token: _this.$route.params.token,
            password: _this.password
          };
          _this.$http.post('resetpassword', data).then(function () {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Success', 'Password berhasil di-update', 'success');
            _this.$router.push({ path: '../login' });
          }).catch(function () {
            _this.isLoading = false;
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Gagal', 'Gagal meng-update password', 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Update Password")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit()
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Password Baru",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "password",
    attrs: {
      "type": "password",
      "placeholder": "New Password",
      "name": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('password')) + "\n                  ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Konfirmasi Password",
      "label-cols": 3,
      "horizontal": true
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Konfirmasi Password",
      "name": "Konfirmasi Password"
    },
    model: {
      value: (_vm.confirm),
      callback: function($$v) {
        _vm.confirm = $$v
      },
      expression: "confirm"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Konfirmasi Password')),
      expression: "errors.has('Konfirmasi Password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('Konfirmasi Password')) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('vue-button-spinner', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#20a8d8",
      "color": "white",
      "border-radius": "6px",
      "width": "150px"
    },
    attrs: {
      "is-loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "type": "submit"
    }
  }, [_c('span', [_vm._v("Update Password")])])], 1)], 1)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\icon.jpeg",
      "width": "100%"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418fbece_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(179);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418fbece_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      modalEditNPWP: false,
      newNpwp: '',
      isLoading: false,
      user: {}
    };
  },
  mounted: function mounted() {
    this.getDataUser();
  },

  methods: {
    openModalEditNPWP: function openModalEditNPWP() {
      this.modalEditNPWP = true;
    },
    updateNPWP: function updateNPWP() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.isLoading = true;
          _this.$http.get('changeNPWP', { params: { npwp: _this.newNpwp } }).then(function (response) {
            if (response.data.success === false) {
              _this.isLoading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', 'NPWP Tidak Ditemukan', 'error');
            } else if (response.data.success === true) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('success', response.data.message, 'success');
              _this.getDataUser();
              _this.modalEditNPWP = false;
            } else {
              _this.isLoading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', 'Terjadi kesalahan saat memeriksa NPWP', 'error');
            }
          }).catch(function (error) {
            console.log(error);
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', 'Terjadi kesalahan saat memeriksa NPWP', 'error');
          }).finally(function () {
            _this.isLoading = false;
          });
        }
      });
    },
    getDataUser: function getDataUser() {
      var _this2 = this;

      this.isLoading = true;
      var data = {
        user: this.$store.getters['auth/user']['username']
      };
      this.$http.post('profile', data).then(function (response) {
        if (response) {
          _this2.user = response.data;
        }
      }).finally(function () {
        _this2.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> My Profile"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 md-12 xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('th', [_vm._v(" " + _vm._s(_vm.user.KD_ID === "5" ? 'NPWP' : _vm.user.KD_ID === "2" ? 'KTP' : _vm.user.KD_ID === "3" ? 'Paspor' : 'Lainnya') + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.ID_USER) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.NM_PERUSAHAAN) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.AL_PERUSAHAAN) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("No Telepon")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.NO_TELP) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.EMAIL) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.user.USER_NAME) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 md-12 xs-12"
  }, [(_vm.user.FL_CHANGE_NPWP === 'N') ? _c('button', {
    staticClass: "btn btn-warning btn-block",
    on: {
      "click": _vm.openModalEditNPWP
    }
  }, [_vm._v("Ubah NPWP "), _c('i', {
    staticClass: "fa fa-edit"
  })]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Ubah NPWP"
    },
    model: {
      value: (_vm.modalEditNPWP),
      callback: function($$v) {
        _vm.modalEditNPWP = $$v
      },
      expression: "modalEditNPWP"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "NPWP"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:16'),
      expression: "'required|min:16'"
    }],
    attrs: {
      "title": "Nomor identitas perusahaan",
      "name": "NPWP",
      "type": "text",
      "placeholder": "Nomor identitas perusahaan"
    },
    model: {
      value: (_vm.newNpwp),
      callback: function($$v) {
        _vm.newNpwp = $$v
      },
      expression: "newNpwp"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('NPWP')),
      expression: "errors.has('NPWP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                            " + _vm._s(_vm.errors.first('NPWP')) + "\n                        ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updateNPWP
    }
  }, [_vm._v("Simpan")])], 1)])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddHeader_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c8c451_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddHeader_vue__ = __webpack_require__(184);
function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27c8c451"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c8c451_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select_dist_VueSearchSelect_css__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select_dist_VueSearchSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select_dist_VueSearchSelect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_search_select__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a,
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_3_vue_search_select__["ModelListSelect"]
  },
  data: function data() {
    return {
      isian: {
        kdkantor: '020400',
        perjnid: '5',
        perid: '',
        pernama: '',
        peralamat: '',
        ppjkjnid: '',
        ppjkid: '',
        ppjknama: '',
        ppjkalamat: '',
        notelp: '',
        email: '',
        nopermohonan: '',
        tglpermohonan: '',
        jnperijinan: '',
        jnsdok: '',
        username: '',
        jnsNppbkc: ''
      },
      disab: false,
      jnijin: [],
      jenisPpftz: [{ value: 23, text: 'PPFTZ-01' }, { value: 24, text: 'PPFTZ-02' }, { value: 25, text: 'PPFTZ-03' }, { value: 209, text: 'PIB' }, { value: 210, text: 'PEB' }],
      jenisManifes: [{ value: 167, text: 'RKSP' }, { value: 2, text: 'Manifes Inward' }, { value: 3, text: 'Manifes Outward' }],
      identitas: [],
      tes: this.$store.getters['auth/user']['ppjk'],
      isLoading: false
    };
  },
  created: function created() {
    this.getJnIjin();
    this.getID();
    this.getPerusahaan();
  },

  methods: {
    getID: function getID() {
      var _this = this;

      this.$http.get('ref/kdid').then(function (response) {
        _this.identitas = response.data;
      });
    },
    getJnIjin: function getJnIjin() {
      var _this2 = this;

      this.$http.get('ref/jnijin').then(function (response) {
        _this2.jnijin = response.data;
      });
    },
    getPerusahaan: function getPerusahaan() {
      var _this3 = this;

      this.isLoading = true;
      var data = {
        user: this.$store.getters['auth/user']['username']
      };
      var ppjk = this.$store.getters['auth/user']['ppjk'];
      if (ppjk === 'Y' || ppjk === 'U') {
        this.disab = false;
      } else {
        this.disab = true;
      }
      this.$http.post('perusahaan', data).then(function (response) {
        _this3.isian.ppjkjnid = response.data.kdid;
        _this3.isian.ppjkid = response.data.idperusahaan;
        _this3.isian.ppjknama = response.data.nmperusahaan;
        _this3.isian.ppjkalamat = response.data.alperusahaan;
        _this3.isian.notelp = response.data.notelp;
        _this3.isian.email = response.data.email;
        _this3.isian.username = response.data.username;

        _this3.isian.perjnid = response.data.kdid;
        _this3.isian.perid = response.data.idperusahaan;
        _this3.isian.pernama = response.data.nmperusahaan;
        _this3.isian.peralamat = response.data.alperusahaan;

        _this3.isLoading = false;
      });
    },
    savePermohonan: function savePermohonan() {
      var _this4 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var npwpRegex = /^[0-9]{16}$/;
          if (_this4.isian.ppjkjnid === '5' && !npwpRegex.test(_this4.isian.ppjkid)) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()({
              title: 'Error',
              text: 'NPWP Pemohon Izin harus terdiri dari 16 angka. kunjungi profil untuk mengubah NPWP',
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'ke Profil',
                  value: true,
                  visible: true,
                  className: 'btn btn-danger',
                  closeModal: true
                }
              },
              closeOnClickOutside: false,
              closeOnEsc: false,
              dangerMode: true
            }).then(function (value) {
              if (value) {
                _this4.$router.push('/profile');
              }
            });
          } else {
            _this4.isLoading = true;
            var permohonan = {
              idijin: _this4.isian.jnperijinan,
              nomohon: _this4.isian.nopermohonan,
              tglmohon: _this4.isian.tglpermohonan,
              kdid: _this4.isian.perjnid,
              idper: _this4.isian.perid,
              pernama: _this4.isian.pernama,
              peralamat: _this4.isian.peralamat,
              nohp: _this4.isian.notelp,
              email: _this4.isian.email,
              idrekam: _this4.isian.username,
              jnsdok: _this4.isian.jnsdok,
              jnsNppbkc: _this4.isian.jnsNppbkc
            };
            _this4.$http.post('savepengajuan', permohonan).then(function (response) {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status).then(function () {
                if (response.data.status === 'success') {
                  _this4.$router.push('detilheader/' + response.data.id_mohon);
                }
              });
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.kdkantor),
      expression: " isian.kdkantor "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.kdkantor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "020400"
    }
  }, [_vm._v("020400 - KPU BC Tipe B Batam")])])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> Pengajuan Izin"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Form Header Perijinan")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Identitas Perijinan")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.perjnid),
      expression: " isian.perjnid "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disab,
      "title": "Identitas perusahaan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.perjnid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.identitas), function(id) {
    return _c('option', {
      key: id.kd_id,
      domProps: {
        "value": id.kd_id
      }
    }, [_vm._v("\n                      " + _vm._s(id.URAIAN) + "\n                    ")])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Identitas"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isian.perjnid === '5' ? 'required|min:16' : 'required'),
      expression: " isian.perjnid === '5' ? 'required|min:16' : 'required' "
    }],
    attrs: {
      "title": "Nomor identitas perusahaan",
      "name": "No Identitas",
      "minlength": "16",
      "maxlength": "16",
      "disabled": _vm.disab,
      "type": "text",
      "placeholder": "No Identitas"
    },
    model: {
      value: (_vm.isian.perid),
      callback: function($$v) {
        _vm.isian.perid = $$v
      },
      expression: " isian.perid "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Identitas')),
      expression: " errors.has( 'No Identitas' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('No Identitas')))])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Nama perusahaan",
      "name": "Nama",
      "disabled": _vm.disab,
      "type": "text",
      "placeholder": "Nama"
    },
    model: {
      value: (_vm.isian.pernama),
      callback: function($$v) {
        _vm.isian.pernama = $$v
      },
      expression: " isian.pernama "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama')),
      expression: " errors.has( 'Nama' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nama')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.peralamat),
      expression: " isian.peralamat "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Alamat perusahaan",
      "name": "Alamat",
      "rows": "2",
      "disabled": _vm.disab,
      "placeholder": "Alamat"
    },
    domProps: {
      "value": (_vm.isian.peralamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isian.peralamat = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat')),
      expression: " errors.has( 'Alamat' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Alamat')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Permohonan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Nomor Permohonan Izin",
      "name": "No Permohonan",
      "type": "text",
      "placeholder": "No Permohonan"
    },
    model: {
      value: (_vm.isian.nopermohonan),
      callback: function($$v) {
        _vm.isian.nopermohonan = $$v
      },
      expression: " isian.nopermohonan "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Permohonan')),
      expression: " errors.has( 'No Permohonan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('No Permohonan')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tgl Permohonan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Tanggal Permohonan Izin",
      "name": "Tgl Permohonan",
      "type": "date"
    },
    model: {
      value: (_vm.isian.tglpermohonan),
      callback: function($$v) {
        _vm.isian.tglpermohonan = $$v
      },
      expression: " isian.tglpermohonan "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tgl Permohonan')),
      expression: " errors.has( 'Tgl Permohonan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('Tgl Permohonan')))])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Perijinan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.jnijin,
      "option-value": "id_ijin",
      "option-text": "nama_ijin",
      "name": "Jenis Perizinan",
      "placeholder": "-- Pilih Jenis Perijinan --"
    },
    model: {
      value: (_vm.isian.jnperijinan),
      callback: function($$v) {
        _vm.isian.jnperijinan = $$v
      },
      expression: " isian.jnperijinan "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Perizinan')),
      expression: " errors.has( 'Jenis Perizinan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Perizinan')))])], 1), _vm._v(" "), (_vm.isian.jnperijinan === 5 || _vm.isian.jnperijinan === 4) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsdok),
      expression: " isian.jnsdok "
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen Yang Diajukan",
      "name": "Jenis PPFTZ"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsdok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jenisPpftz), function(ppftz) {
    return _c('option', {
      domProps: {
        "value": ppftz.value
      }
    }, [_vm._v("\n                  " + _vm._s(ppftz.text) + "\n                ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis PPFTZ')),
      expression: " errors.has( 'Jenis PPFTZ' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis PPFTZ')))])]) : _vm._e(), _vm._v(" "), (_vm.isian.jnperijinan === 23) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen yang akan dibatalkan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsdok),
      expression: " isian.jnsdok "
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen Yang Diajukan",
      "name": "Jenis Manifes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsdok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jenisManifes), function(manifes) {
    return _c('option', {
      domProps: {
        "value": manifes.value
      }
    }, [_vm._v("\n                  " + _vm._s(manifes.text) + "\n                ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Manifes')),
      expression: " errors.has( 'Jenis Manifes' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Manifes')))])]) : _vm._e(), _vm._v(" "), (_vm.isian.jnperijinan === 3) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Pembongkaran"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsdok),
      expression: " isian.jnsdok "
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "",
      "name": "Jenis Pembongkaran"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsdok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Pembongkaran")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Non Ship to Ship")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Ship to Ship")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Pembongkaran')),
      expression: " errors.has( 'Jenis Pembongkaran' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Jenis Pembongkaran')) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.isian.jnperijinan === 45) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Usaha"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsNppbkc),
      expression: " isian.jnsNppbkc "
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "",
      "name": "Jenis Usaha"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsNppbkc = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Usaha")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Tempat Penjualan Eceran MMEA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Distributor MMEA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Usaha')),
      expression: " errors.has( 'Jenis Usaha' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Jenis Usaha')) + "\n              ")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Identitas Pemohon Izin")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.ppjkjnid),
      expression: " isian.ppjkjnid "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.ppjkjnid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.identitas), function(id) {
    return _c('option', {
      key: id.kd_id,
      domProps: {
        "value": id.kd_id
      }
    }, [_vm._v("\n                      " + _vm._s(id.URAIAN) + "\n                    ")])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Identitas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true,
      "type": "text",
      "placeholder": "No Identitas",
      "maxlength": "16"
    },
    model: {
      value: (_vm.isian.ppjkid),
      callback: function($$v) {
        _vm.isian.ppjkid = $$v
      },
      expression: " isian.ppjkid "
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true,
      "type": "text"
    },
    model: {
      value: (_vm.isian.ppjknama),
      callback: function($$v) {
        _vm.isian.ppjknama = $$v
      },
      expression: " isian.ppjknama "
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.ppjkalamat),
      expression: " isian.ppjkalamat "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.isian.ppjkalamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isian.ppjkalamat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No HP / Telepon"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15|min:3'),
      expression: " 'required|max:15|min:3' "
    }],
    attrs: {
      "title": "Nomor HP Yang Dapat Dihubungi",
      "name": "No Telepon",
      "type": "text",
      "placeholder": "No HP / Telepon"
    },
    model: {
      value: (_vm.isian.notelp),
      callback: function($$v) {
        _vm.isian.notelp = $$v
      },
      expression: " isian.notelp "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Telepon')),
      expression: " errors.has( 'No Telepon' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('No Telepon')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: " 'required|email' "
    }],
    attrs: {
      "title": "Email Yang Dapat Dihubungi",
      "name": "Email",
      "type": "text",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.isian.email),
      callback: function($$v) {
        _vm.isian.email = $$v
      },
      expression: " isian.email "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email')),
      expression: " errors.has( 'Email' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Email')))])], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "title": "Simpan Header Permohonan Izin",
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": _vm.savePermohonan
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/pengajuan'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" Back\n          ")])], 1)])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilHeader_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2181b4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilHeader_vue__ = __webpack_require__(280);
function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a2181b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2181b4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_numeric__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_container_validator__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_container_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_container_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_epic_spinners__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_search_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_search_select__);













__WEBPACK_IMPORTED_MODULE_8_vee_validate__["c" /* Validator */].extend('container', {
  getMessage: function getMessage(field) {
    return field + ' tidak valid.';
  },
  validate: function validate(value) {
    var validasi = new __WEBPACK_IMPORTED_MODULE_6_container_validator___default.a();
    return validasi.isValid(value);
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      Modaledit: false,
      Modaleditdtl: false,
      Modaleditdtl1: false,
      Modaleditdtl2: false,
      ModalDokap: false,
      ModalDisclaimer: false,
      ModalError: false,
      disclaimer: '',
      validasi: [],
      nmTabel: '',
      nmKolom: '',
      nmPar: '',
      uraian: '',
      nocont: '',
      ukcont: '',
      jmlcont: 0,
      jmlck: 0,
      jmlba: 0,
      cont: [],
      isian: '',
      isLoadingEdit: false,
      isLoadingKirim: false,
      fileSize: 0,
      fileExt: '',
      fileName: '',
      fileValid: '',
      DataHeader: null,
      dokap_current: '',
      kd_dokap_current: '',
      listdokap: null,
      dokapdtl: [],
      jndokap: [],
      jnPelln: [],
      jnNegara: [],
      user: [],
      suggestionAttribute: 'original_title',
      isidokap: {
        jndok: '',
        isian1: '',
        isian2: '',
        akhirberlaku: '',
        keterangan: '',
        file: '',
        negara: '-'
      },
      idijin: '',
      field: {
        isi1: '',
        tipe1: '',
        isi2: '',
        tipe2: '',
        expire: '',
        kolom1: '',
        kolom2: '',
        tabel_ref: '',
        fl_file: '',
        maxlength: '',
        maxlength2: ''
      },
      edit: {
        idperdokap: '',
        idpermohonan: '',
        isian1: '',
        isian2: '',
        akhirberlaku: '',
        keterangan: '',
        file: '',
        pelln: '',
        negara: '-',
        fileSize: '',
        fl_file: ''
      },
      pdf: {
        show: true,
        pdfList: ['', 'http://localhost/backper/public/file/dokap/20171212/9oAFswM38T3ZnNW9.pdf'],
        src: '',
        loadedRatio: 0,
        page: 1,
        numPages: 0,
        rotate: 0
      },
      parse_header: [],
      parse_csv: [],
      sortOrders: {},
      sortKey: '',
      dataNoStrip: {
        noPpftz: '',
        tglPpftz: '',
        noBc11: '',
        tglBc11: '',
        pos: '',
        noKontainer: '',
        ukKontainer: ''
      }
    };
  },
  created: function created() {
    this.getHeader();
    this.getDokap();
    this.getJnDokap();
    this.getNegara();
    this.edit.negara = '-';
  },

  methods: {
    addRow: function addRow() {
      if (this.cont.length >= this.jmlcont) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('error', 'isian tidak boleh lebih dari ' + this.jmlcont, 'error');
      } else {
        this.cont.push({
          isian1: this.nocont,
          isian2: this.ukcont
        });
        this.cont = this.cont;
      }
    },
    hapusrow: function hapusrow(index) {
      this.cont.splice(index, 1);
      this.cont = this.cont;
    },
    cekkirim: function cekkirim() {
      this.ModalDisclaimer = true;
    },
    kirim: function kirim() {
      var _this = this;

      if (this.disclaimer === 'Y') {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()({
          title: 'Kirim data',
          text: 'Anda yakin akan mengirim data ini?',
          icon: 'warning',
          buttons: {
            cancel: 'Cancel',
            Yes: 'Yes'
          }
        }).then(function (value) {
          switch (value) {
            case 'Yes':
              _this.isLoadingKirim = true;
              var data = {
                user: _this.$store.getters['auth/user']['username'],
                idmohon: _this.$route.params.idmohon
              };
              _this.$http.post('kirim', data).then(function (response) {
                if (response.data.hasil) {
                  var mail = {
                    page: 'kirim',
                    idmohon: _this.$route.params.idmohon
                  };
                  _this.$http.post('bc/mail/sendmail', mail);
                  var mail1 = {
                    page: 'petugas',
                    idmohon: _this.$route.params.idmohon
                  };
                  _this.$http.post('bc/mail/sendmail', mail1);
                }
                __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status).then(function () {
                  _this.$router.push('/pengajuan');
                });
                _this.isLoadingKirim = false;
              }).catch(function (error) {
                console.log(error);
                if (error.status === 422) {
                  _this.ModalDisclaimer = false;
                  _this.validasi = error.body;
                  _this.ModalError = true;
                } else {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('error', JSON.parse(error.bodyText).message, 'error');
                }
                _this.isLoadingKirim = false;
              });
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Kirim Data', 'Pengiriman data tidak berhasil, disclaimer belum diisi...!!!', 'error');
      }
    },
    savedokapdtl: function savedokapdtl() {
      var _this2 = this;

      this.isLoadingEdit = true;
      if (this.jmlcont <= this.cont.length) {
        var data = {
          idrekam: this.$store.getters['auth/user']['username'],
          id_permohonan_dokap: this.dokap_current,
          cont: this.cont
        };
        this.$http.post('savedokapdtl', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this2.Modaleditdtl = false;
          _this2.isLoadingEdit = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('error', 'isian tidak sama dengan jumlah', 'error');
        this.isLoadingEdit = false;
      }
    },
    savedokapdtl1: function savedokapdtl1() {
      var _this3 = this;

      if (this.cekFile()) {
        var data = {
          id_dokap: this.dokap_current,
          kd_dokap: this.kd_dokap_current,
          isian1: this.nocont,
          isian2: this.ukcont,
          file: this.isidokap.file,
          idrekam: this.user.user,
          ext: this.fileExt
        };
        this.$http.post('savedokapdtl1', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this3.ResetField();
          _this3.Reset();
          _this3.getDokapdtl();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Gagal simpan data', this.fileValid, 'error');
      }
    },
    fileChanged: function fileChanged(e) {
      var _this4 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      this.fileSize = e.target.files[0].size / 1024;
      this.fileExt = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      this.fileName = e.target.files[0].name;
      fileReader.onload = function (e) {
        _this4.isidokap.file = e.target.result;
        _this4.edit.file = e.target.result;
        _this4.$Progress.finish();
      };
    },
    fileChangeddtl: function fileChangeddtl(e) {
      var _this5 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      this.fileSize = e.target.files[0].size / 1024;
      this.fileExt = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      this.fileName = e.target.files[0].name;
      fileReader.onload = function (e) {
        _this5.isidokap.file = e.target.result;
        _this5.edit.file = e.target.result;
        _this5.$Progress.finish();
      };
    },
    cekFile: function cekFile() {
      var hasil = true;
      if (this.fileSize > 0) {
        this.fileValid = 'File ' + this.fileName;
        if (this.fileSize > 2100) {
          this.fileValid = this.fileValid + ' berukuran ' + Math.round(this.fileSize * 100) / 100 + ' Kb, max. 2000 Kb. ' + '\n\r';
          hasil = false;
        }
      }
      return hasil;
    },
    getDtlDokap: function getDtlDokap(iddokap) {
      var _this6 = this;

      this.$http.get('ref/jndokap/' + iddokap).then(function (response) {
        _this6.field.isi1 = response.data.isian1;
        _this6.field.tipe1 = response.data.tipe1;
        _this6.field.maxlength = response.data.maxlength;
        _this6.field.isi2 = response.data.isian2;
        _this6.field.maxlength2 = response.data.maxlength2;
        _this6.field.tipe2 = response.data.tipe2;
        _this6.field.expire = response.data.expire;
        _this6.field.tabel_ref = response.data.tabel_ref;
        _this6.field.kolom1 = response.data.kolom1;
        _this6.field.kolom2 = response.data.kolom2;
        _this6.field.fl_file = response.data.fl_file;
        if (_this6.field.tabel_ref === 'referensi.tr_pelln' || _this6.field.tabel_ref === 'referensi.tr_pelabuhan') {} else {
          _this6.referensiDokap();
        }
      });
    },
    getJnDokap: function getJnDokap() {
      var _this7 = this;

      this.$http.get('ref/jndokap').then(function (response) {
        _this7.jndokap = response.data;
      });
    },
    getHeader: function getHeader() {
      var _this8 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        idmohon: this.$route.params.idmohon
      };
      this.user = data;
      this.$http.post('dtlheader', data).then(function (response) {
        _this8.DataHeader = response.data;
        _this8.idijin = response.data.id_ijin;
      });
    },
    getDokap: function getDokap() {
      var _this9 = this;

      this.isLoadingEdit = true;
      var idijinn = {
        user: this.$store.getters['auth/user']['username'],
        idijin: this.$route.params.idmohon
      };
      this.$http.post('dokap', idijinn).then(function (response) {
        _this9.listdokap = response.data;
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].kd_dokap === 151) {
            _this9.jmlcont = response.data[i].isian1;
          } else if (response.data[i].kd_dokap === 145) {
            _this9.jmlck = response.data[i].isian1;
          } else if (response.data[i].kd_dokap === 146) {
            _this9.jmlba = response.data[i].isian1;
          }
        }
        _this9.isLoadingEdit = false;
      });
    },
    getDokapdtl: function getDokapdtl() {
      var _this10 = this;

      this.isLoadingEdit = true;
      var iddokap = {
        iddokap: this.dokap_current
      };
      this.$http.post('dokapdtl', iddokap).then(function (response) {
        _this10.cont = response.data;
        _this10.isLoadingEdit = false;
      });
    },
    referensiDokap: function referensiDokap() {
      var _this11 = this;

      var neg = '';
      if (this.ModalDokap === true) {
        neg = this.isidokap.negara;
      } else {
        neg = this.edit.negara;
      }
      if (this.field.tabel_ref != null) {
        this.isLoadingEdit = true;
        this.$http.get('ref/referensiDokap/' + this.field.tabel_ref + '/' + this.field.kolom1 + '/' + this.field.kolom2 + '/' + neg).then(function (response) {
          _this11.jnPelln = response.data;
          _this11.isLoadingEdit = false;
        });
      }
    },
    referensiDokapDtl: function referensiDokapDtl(tabel, kolom1, kolom2, par) {
      var _this12 = this;

      if (tabel !== null) {
        this.$http.get('ref/referensiDokapDtl/' + tabel + '/' + kolom1 + '/' + kolom2 + '/' + par).then(function (response) {
          _this12.uraian = response.data.nm_lokasi;
        });
      } else {
        this.uraian = '';
      }
      return this.uraian;
    },
    getNegara: function getNegara() {
      var _this13 = this;

      this.$http.get('ref/referensiDokap/referensi.tr_negara/id_negara/nm_negara/-').then(function (response) {
        _this13.jnNegara = response.data;
      });
    },
    addModal: function addModal() {
      this.ModalDokap = true;
      this.Reset();
    },
    opendtl: function opendtl(id, kd) {
      if (kd === 151) {
        this.Modaleditdtl = true;
        this.dokap_current = id;
        this.getDokapdtl();
        this.$refs.fileupload.value = null;
      } else if (kd === 145 || kd === 146) {
        this.Modaleditdtl1 = true;
        this.dokap_current = id;
        this.kd_dokap_current = kd;
        this.getDokapdtl();
        this.getDtlDokap(kd);
      } else if (kd === 256) {
        this.Modaleditdtl2 = true;
        this.dokap_current = id;
        this.getDokapdtl();
      }
    },
    editDokap: function editDokap(id) {
      var _this14 = this;

      this.ResetField();
      this.isLoadingEdit = true;
      this.Modaledit = true;
      var iddokap = {
        id: id
      };
      this.$http.post('geteditDokap', iddokap).then(function (response) {
        _this14.edit.idperdokap = response.data.id_permohonan_dokap;
        _this14.edit.idpermohonan = response.data.id_permohonan;
        _this14.edit.jndok = response.data.kd_dokap;
        _this14.edit.isian1 = response.data.isian1;
        _this14.edit.isian2 = response.data.isian2;
        _this14.edit.akhirberlaku = response.data.akhir_berlaku;
        _this14.edit.keterangan = response.data.keterangan;
        _this14.edit.fl_file = response.data.fl_file;
        _this14.getDtlDokap(response.data.kd_dokap);
        _this14.Reset();
        _this14.isLoadingEdit = false;
      });
    },
    Reset: function Reset() {
      this.isidokap.jndok = null;
      this.isidokap.isian1 = null;
      this.isidokap.isian2 = null;
      this.isidokap.akhirberlaku = null;
      this.isidokap.keterangan = null;
      this.isidokap.file = null;
      this.field.isi1 = null;
      this.field.tipe1 = null;
      this.field.isi2 = null;
      this.field.tipe2 = null;
      this.field.expire = null;
      this.field.tabel_ref = null;
      this.field.kolom1 = null;
      this.field.kolom2 = null;
      this.field.fl_file = null;
      this.jnPelln = [];
      this.nocont = null;
      this.ukcont = null;
    },
    ResetField: function ResetField() {
      this.field.isi1 = null;
      this.field.tipe1 = null;
      this.field.isi2 = null;
      this.field.tipe2 = null;
      this.field.expire = null;
      this.field.tabel_ref = null;
      this.field.kolom1 = null;
      this.field.kolom2 = null;
      this.field.fl_file = null;
      this.isidokap.negara = '-';
      this.isidokap.file = null;
      this.edit.negara = '-';
      this.jnPelln = [];
      this.cont = null;
      this.ukuran = null;
      this.dataNoStrip.noPpftz = null;
      this.dataNoStrip.tglPpftz = null;
      this.dataNoStrip.noBc11 = null;
      this.dataNoStrip.tglBc11 = null;
      this.dataNoStrip.pos = null;
      this.dataNoStrip.noKontainer = null;
      this.dataNoStrip.ukKontainer = null;
    },
    updateDokap: function updateDokap() {
      var _this15 = this;

      this.isLoadingEdit = true;
      this.$Progress.start();
      if (this.cekFile()) {
        if (this.edit.isian1 === null) {
          this.edit.isian1 = this.edit.negara;
        }
        var data = {
          id_permohonan_dokap: this.edit.idperdokap,
          id_permohonan: this.edit.idpermohonan,
          kd_dokap: this.edit.jndok,
          isian1: this.edit.isian1,
          isian2: this.edit.isian2,
          akhirberlaku: this.edit.akhirberlaku,
          keterangan: this.edit.keterangan,
          file: this.edit.fl_file === 'Y' ? this.edit.file : null,
          idrekam: this.user.user,
          ext: this.fileExt
        };
        this.$http.post('updateDokap', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this15.$Progress.finish();
          _this15.getDokap();
          _this15.getHeader();
          _this15.saveDokapMasterEdit();
          _this15.ResetField();
          _this15.Modaledit = false;
          _this15.isLoadingEdit = false;
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(error.data.status, error.data.message, error.data.status);
          _this15.isLoadingEdit = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Gagal simpan data', this.fileValid, 'error');
        this.isLoadingEdit = false;
      }
    },
    saveDokap: function saveDokap() {
      var _this16 = this;

      if (this.cekFile()) {
        if (this.isidokap.isian1 === null) {
          this.isidokap.isian1 = this.isidokap.negara;
        }
        var data = {
          id_permohonan: this.DataHeader.id_permohonan,
          kd_dokap: this.isidokap.jndok,
          isian1: this.isidokap.isian1,
          isian2: this.isidokap.isian2,
          akhirberlaku: this.isidokap.akhirberlaku,
          keterangan: this.isidokap.keterangan,
          file: this.field.fl_file === 'Y' ? this.isidokap.file : null,
          idrekam: this.user.user,
          ext: this.fileExt
        };
        this.$http.post('savedokap', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this16.getDokap();
          _this16.saveDokapMasterAdd();
          _this16.ResetField();
          _this16.ModalDokap = false;
          _this16.onReset();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Gagal simpan data', this.fileValid, 'error');
      }
    },
    saveDokapMasterAdd: function saveDokapMasterAdd() {
      if (this.isidokap.isian1 === null) {
        this.isidokap.isian1 = this.isidokap.negara;
      }
      var data = {
        kd_dokap: this.isidokap.jndok,
        nomor: this.isidokap.isian1,
        tanggal: this.isidokap.isian2,
        akhirberlaku: this.isidokap.akhirberlaku,
        keterangan: this.isidokap.keterangan,
        file: this.isidokap.file,
        idrekam: this.user.user,
        ext: this.fileExt
      };
      this.$http.post('saveDokapMaster', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
      });
    },
    saveDokapMasterEdit: function saveDokapMasterEdit() {
      if (this.edit.isian1 === null) {
        this.edit.isian1 = this.edit.negara;
      }
      var data = {
        kd_dokap: this.edit.jndok,
        nomor: this.edit.isian1,
        tanggal: this.edit.isian2,
        akhirberlaku: this.edit.akhirberlaku,
        keterangan: this.edit.keterangan,
        file: this.edit.file,
        idrekam: this.user.user,
        ext: this.fileExt
      };
      this.$http.post('saveDokapMaster', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
      });
    },
    confir: function confir(iddel) {
      var _this17 = this;

      __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()({
        title: 'Hapus dokumen pelengkap',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this17.deleteDokap(iddel);
        }
      });
    },
    confirmdtl: function confirmdtl(iddel) {
      var _this18 = this;

      __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()({
        title: 'Hapus dokumen pelengkap',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this18.deleteDokapdtl(iddel);
        }
      });
    },
    deleteDokap: function deleteDokap(id) {
      var _this19 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      };
      this.$http.post('deleteDokap', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this19.getDokapdtl();
        _this19.getHeader();
        _this19.ResetField();
      });
    },
    deleteDokapdtl: function deleteDokapdtl(id) {
      var _this20 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      };
      this.$http.post('deleteDokapdtl', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this20.getDokapdtl();
        _this20.getHeader();
        _this20.ResetField();
        _this20.Reset();
      });
    },
    csvJSON: function csvJSON(csvText) {
      var lines = [];
      var linesArray = csvText.split('\n');

      linesArray.forEach(function (e) {
        var row = e.replace(/[\s]+[,]+|[,]+[\s]+/g, ',').trim();
        lines.push(row);
      });

      lines.splice(lines.length - 1, 1);
      var result = [];
      var headers = lines[0].split(',');

      for (var i = 1; i < lines.length; i++) {
        var obj = {};
        var currentline = lines[i].split(',');

        for (var j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }
        result.push(obj);
      }

      return result;
    },
    loadCSV: function loadCSV(e) {
      var vm = this;
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(e.target.files[0]);

        reader.onload = function (event) {
          var csv = event.target.result;
          vm.parse_csv = vm.csvJSON(csv);
          vm.cont = vm.csvJSON(csv);
        };
        reader.onerror = function (evt) {
          if (evt.target.error.name === 'NotReadableError') {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Cannot read file !');
          }
        };
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('FileReader are not supported in this browser.');
      }
    },
    savedokapdtl2: function savedokapdtl2() {
      var _this21 = this;

      var data = {
        id_dokap: this.dokap_current,
        idrekam: this.user.user,
        noPpftz: this.dataNoStrip.noPpftz,
        tglPpftz: this.dataNoStrip.tglPpftz,
        noBc11: this.dataNoStrip.noBc11,
        tglBc11: this.dataNoStrip.tglBc11,
        pos: this.dataNoStrip.pos,
        noKontainer: this.dataNoStrip.noKontainer,
        ukKontainer: this.dataNoStrip.ukKontainer
      };
      var fieldsToCheck = {
        noPpftz: 'No PPFTZ',
        tglPpftz: 'Tanggal PPFTZ',
        noBc11: 'No BC11',
        tglBc11: 'Tanggal BC11',
        pos: 'POS',
        noKontainer: 'No Kontainer',
        ukKontainer: 'Ukuran Kontainer'
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(fieldsToCheck)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var label = _ref2[1];

          if (!data[key] || data[key].toString().trim() === '') {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Peringatan', 'Kolom ' + label + ' belum diisi', 'warning');
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$http.post('savedokapdtl2', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this21.getDokapdtl();
        _this21.ResetField();
        _this21.Reset();
      });
    },
    confirmdtl2: function confirmdtl2(id) {
      var _this22 = this;

      __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()({
        title: 'Hapus Data',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this22.deleteDokapdtl2(id);
        }
      });
    },
    deleteDokapdtl2: function deleteDokapdtl2(id) {
      var _this23 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      };
      this.$http.post('deleteDokapdtl2', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this23.getDokapdtl();
        _this23.ResetField();
        _this23.Reset();
      });
    }
  },
  components: {
    VueNumeric: __WEBPACK_IMPORTED_MODULE_4_vue_numeric___default.a,
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_7_epic_spinners__["a" /* HalfCircleSpinner */],
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a,
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_9_vue_search_select__["ModelListSelect"]
  }
});

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4fa2faed_hasScoped_true_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__ = __webpack_require__(203);
function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fa2faed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4fa2faed_hasScoped_true_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hollow-dots-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.dotsStyles), function(ds, index) {
    return _c('div', {
      key: index,
      staticClass: "dot",
      style: (ds)
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1671ea56_hasScoped_true_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__ = __webpack_require__(207);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1671ea56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1671ea56_hasScoped_true_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(42);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationName: 'pixel-spinner-animation-' + Date.now()
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.animationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                      ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                      0 ' + this.pixelSize * -1.5 + 'px 0 0\n                    '
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return '\n      50% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n\n      75% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n      100% {\n        transform: rotate(360deg);\n      }';
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pixel-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "pixel-spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0bf7e3ab_hasScoped_true_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__ = __webpack_require__(211);
function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bf7e3ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0bf7e3ab_hasScoped_true_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(42);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallDotName: 'flower-spinner-small-dot-' + Date.now(),
      bigDotName: 'flower-spinner-big-dot-' + Date.now()
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.smallDotName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.bigDotName
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.smallDotName);
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.bigDotName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.smallDotName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.smallDotName, this.generateSmallDotKeyframes());
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.bigDotName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.bigDotName, this.generateBigDotKeyframes());
    },
    generateSmallDotKeyframes: function generateSmallDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    },
    generateBigDotKeyframes: function generateBigDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                50% {\n                  transform: rotate(180deg);\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  transform: rotate(360deg);\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flower-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "dots-container",
    style: (_vm.dotsContainerStyle)
  }, [_c('div', {
    staticClass: "big-dot",
    style: (_vm.biggerDotStyle)
  }, [_c('div', {
    staticClass: "small-dot",
    style: (_vm.smallerDotStyle)
  })])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_063c9f9c_hasScoped_true_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__(215);
function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-063c9f9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_063c9f9c_hasScoped_true_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cp, _this.circleStyle);
      });
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intersecting-circles-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinnerBlock",
    style: (_vm.spinnerBlockStyle)
  }, _vm._l((_vm.circleStyles), function(cs, index) {
    return _c('span', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27be8bdc_hasScoped_true_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__ = __webpack_require__(219);
function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27be8bdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27be8bdc_hasScoped_true_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orbit-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "orbit one",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit two",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit three",
    style: (_vm.orbitStyle)
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_04760e10_hasScoped_true_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__ = __webpack_require__(223);
function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04760e10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_04760e10_hasScoped_true_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fingerprint-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "spinner-ring",
      style: (rs)
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e7d3ae64_hasScoped_true_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__ = __webpack_require__(227);
function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7d3ae64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e7d3ae64_hasScoped_true_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trinity-rings-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle1",
    style: (_vm.ring1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle2",
    style: (_vm.ring2Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle3",
    style: (_vm.ring3Style)
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f20693b2_hasScoped_true_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__(231);
function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f20693b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f20693b2_hasScoped_true_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-square-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_59027caa_hasScoped_true_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__(235);
function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59027caa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_59027caa_hasScoped_true_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        if (i === 1) {
          style.marginLeft = 0;
        }

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles-to-rhombuses-spinner",
    style: (_vm.spinnertStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_14fe9ee8_hasScoped_true_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__ = __webpack_require__(239);
function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14fe9ee8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_14fe9ee8_hasScoped_true_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "semipolar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "ring",
      style: (rs)
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9cc21304_hasScoped_true_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__(243);
function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9cc21304"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9cc21304_hasScoped_true_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breeding-rhombus-spinner",
    style: (_vm.spinnerStyle)
  }, [_vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "rhombus",
      class: ("child-" + (index + 1)),
      style: (rs)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "rhombus big",
    style: (_vm.bigRhombusStyle)
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_508f9eea_hasScoped_true_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-508f9eea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_508f9eea_hasScoped_true_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swapping-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_11199317_hasScoped_true_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__(251);
function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11199317"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_11199317_hasScoped_true_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scaling-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5acbd2cf_hasScoped_true_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__(255);
function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5acbd2cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5acbd2cf_hasScoped_true_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-bouncing-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle",
    style: (_vm.circleStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit",
    style: (_vm.orbitStyle)
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4cf74c54_hasScoped_true_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__ = __webpack_require__(259);
function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cf74c54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4cf74c54_hasScoped_true_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    }, [_c('div', {
      staticClass: "circle-inner-container",
      style: (_vm.circleInnerContainerStyle)
    }, [_c('div', {
      staticClass: "circle-inner",
      style: (_vm.circleInnerStyle)
    })])])
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_673289e9_hasScoped_true_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__(263);
function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-673289e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_673289e9_hasScoped_true_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self-building-square-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: {
        'clear': index && index % 3 === 0
      },
      style: (ss)
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6c49f8b9_hasScoped_true_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__ = __webpack_require__(267);
function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c49f8b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6c49f8b9_hasScoped_true_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(42);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationName: 'spring-spinner-animation-' + Date.now()
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.animationName
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        0% {\n          border-width: ' + this.size / 7 + 'px;\n        }\n        25% {\n          border-width: ' + this.size / 23.33 + 'px;\n        }\n        50% {\n          transform: rotate(115deg);\n          border-width: ' + this.size / 7 + 'px;\n        }\n        75% {\n          border-width: ' + this.size / 23.33 + 'px;\n         }\n        100% {\n         border-width: ' + this.size / 7 + 'px;\n        }';
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spring-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-part top",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })]), _vm._v(" "), _c('div', {
    staticClass: "spring-spinner-part bottom",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_98457dac_hasScoped_true_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__(271);
function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98457dac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_98457dac_hasScoped_true_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "looping-rhombuses-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      staticClass: "rhombus",
      style: (rs),
      attrs: {
        "ikey": index
      }
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f52be0ba_hasScoped_true_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__ = __webpack_require__(275);
function injectStyle (ssrContext) {
  __webpack_require__(273)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f52be0ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f52be0ba_hasScoped_true_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle-1",
    style: (_vm.circle1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle-2",
    style: (_vm.circle2Style)
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_14003f96_hasScoped_true_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__ = __webpack_require__(279);
function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14003f96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_14003f96_hasScoped_true_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atom-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner"
  }, [_c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-circle",
    style: (_vm.circleStyle)
  }, [_vm._v("\n      ●\n    ")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan"
    }
  }, [(!_vm.DataHeader || !_vm.listdokap) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.DataHeader && _vm.listdokap) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.DataHeader.status === '10') ? _c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cekkirim
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("\n                  Kirim")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Pengajuan Izin"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.DataHeader.URAIAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.npwp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.NM_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.AL_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No HP/Telepon")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_hp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kantor")]), _vm._v(" "), _c('td', [_vm._v("020400 - KPU BC Tipe B Batam")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Tanggal Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Jenis Permohonan Izin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.nama_ijin))])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                    Lampiran Dokumen / Data\n                    "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "title": "Tambah Dokumen/Data Pelengkap",
      "type": "button"
    },
    on: {
      "click": _vm.addModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Dokap")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokap), function(dokap) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dokap.nama_dokap))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokap.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-md-block"
    }, [_vm._v(_vm._s(dokap.keterangan))]), _vm._v(" "), _c('td', [(dokap.url_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": dokap.url_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editDokap(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), (dokap.kd_dokap === 151 || dokap.kd_dokap === 256) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (dokap.kd_dokap === 145 || dokap.kd_dokap === 146) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (dokap.fl_mandatory === null) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Dokumen/Data Pelengkap"
      },
      on: {
        "click": function($event) {
          _vm.confir(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/pengajuan'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v("\n                Back")])], 1)])]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Tambah Dokumen Pelengkap"
    },
    on: {
      "ok": function($event) {
        _vm.ModalDokap = false
      }
    },
    model: {
      value: (_vm.ModalDokap),
      callback: function($$v) {
        _vm.ModalDokap = $$v
      },
      expression: " ModalDokap "
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen Pelengkap"
    }
  }, [_c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "list": _vm.jndokap,
      "option-value": "kd_dokap",
      "option-text": "nama_dokap"
    },
    on: {
      "input": function($event) {
        _vm.getDtlDokap(_vm.isidokap.jndok)
      }
    },
    model: {
      value: (_vm.isidokap.jndok),
      callback: function($$v) {
        _vm.isidokap.jndok = $$v
      },
      expression: "isidokap.jndok"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [(_vm.field.tabel_ref === 'referensi.tr_pelln' || _vm.field.tabel_ref === 'referensi.tr_pelabuhan') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.negara),
      expression: " isidokap.negara "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pilih Negara"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.negara = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Negara")]), _vm._v(" "), _vm._l((_vm.jnNegara), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      },
      on: {
        "click": function($event) {
          _vm.referensiDokap()
        }
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi) + "\n            ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tabel_ref !== null) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: " isidokap.isian1 "
    }],
    attrs: {
      "title": "Pilih Data Pelengkap",
      "lass": "form-control"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.isian1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Data")]), _vm._v(" "), _vm._l((_vm.jnPelln), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'date' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: " isidokap.isian1 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "date"
    },
    domProps: {
      "value": (_vm.isidokap.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'text' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: " isidokap.isian1 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'number' && _vm.field.tabel_ref === null) ? _c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "separator": ".",
      "precision": 2
    },
    model: {
      value: (_vm.isidokap.isian1),
      callback: function($$v) {
        _vm.isidokap.isian1 = $$v
      },
      expression: " isidokap.isian1 "
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('This')),
      expression: " errors.has( 'This' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('This')) + "\n          ")])], 1), _vm._v(" "), (_vm.field.tipe2 === 'text') ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: " 'required|field' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian2),
      expression: " isidokap.isian2 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "Isi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Isi')),
      expression: " errors.has( 'Isi' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Isi')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.tipe2 === 'Date') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: " 'required|field' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian2),
      expression: " isidokap.isian2 "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tanggal",
      "type": "date"
    },
    domProps: {
      "value": (_vm.isidokap.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal')),
      expression: " errors.has( 'Tanggal' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Tanggal')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.expire === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Akhir Berlaku"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: " 'required|field' "
    }],
    attrs: {
      "title": "Akhir Berlaku Dokumen/Data",
      "name": "Akhir Berlaku",
      "type": "date"
    },
    model: {
      value: (_vm.edit.akhirberlaku),
      callback: function($$v) {
        _vm.edit.akhirberlaku = $$v
      },
      expression: " edit.akhirberlaku "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Akhir Berlaku')),
      expression: " errors.has( 'Akhir Berlaku' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Akhir Berlaku')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.keterangan),
      expression: " isidokap.keterangan "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Keterangan Terkait Dokumen/Data",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.keterangan = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.field.fl_file === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Upload File (Max. 800 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDokap()
      }
    }
  }, [_vm._v("Save")])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap"
    },
    on: {
      "ok": function($event) {
        _vm.Modaledit = false
      }
    },
    model: {
      value: (_vm.Modaledit),
      callback: function($$v) {
        _vm.Modaledit = $$v
      },
      expression: " Modaledit "
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingEdit,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Edit Dokumen Pelengkap"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.jndok),
      expression: " edit.jndok "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen/Data",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.edit.jndok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jndokap), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.kd_dokap
      },
      on: {
        "click": function($event) {
          _vm.getDtlDokap(jn.kd_dokap)
        }
      }
    }, [_vm._v(_vm._s(jn.nama_dokap) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [(_vm.field.tabel_ref === 'referensi.tr_pelln' || _vm.field.tabel_ref === 'referensi.tr_pelabuhan') ? _c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "list": _vm.jnNegara,
      "option-value": "id_lokasi",
      "option-text": "nm_lokasi",
      "name": "Nama Negara",
      "placeholder": "-- Pilih Negara --"
    },
    on: {
      "input": function($event) {
        _vm.referensiDokap()
      }
    },
    model: {
      value: (_vm.edit.negara),
      callback: function($$v) {
        _vm.edit.negara = $$v
      },
      expression: " edit.negara "
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tabel_ref !== null) ? _c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "list": _vm.jnPelln,
      "option-value": "id_lokasi",
      "option-text": "nm_lokasi",
      "name": "Nama Pelabuhan",
      "placeholder": "-- Pilihan --"
    },
    model: {
      value: (_vm.edit.isian1),
      callback: function($$v) {
        _vm.edit.isian1 = $$v
      },
      expression: " edit.isian1 "
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'date' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: " edit.isian1 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "This",
      "type": "date"
    },
    domProps: {
      "value": (_vm.edit.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'text' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: " edit.isian1 "
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": _vm.field.maxlength,
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'number' && _vm.field.tabel_ref === null) ? _c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "separator": ".",
      "precision": 2
    },
    model: {
      value: (_vm.edit.isian1),
      callback: function($$v) {
        _vm.edit.isian1 = $$v
      },
      expression: " edit.isian1 "
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('This')),
      expression: " errors.has( 'This' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('This')) + "\n          ")])], 1), _vm._v(" "), (_vm.field.tipe2 === 'text') ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi2
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian2),
      expression: " edit.isian2 "
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": _vm.field.maxlength2,
      "title": "Nomor/Kode Dokumen/Data",
      "name": "Isi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Isi')),
      expression: " errors.has( 'Isi' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Isi')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.tipe2 === 'Date') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian2),
      expression: " edit.isian2 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "Tanggal",
      "type": "date"
    },
    domProps: {
      "value": (_vm.edit.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal')),
      expression: " errors.has( 'Tanggal' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Tanggal')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.expire === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Akhir Berlaku"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Akhir Berlaku Dokumen/Data",
      "name": "Akhir Berlaku",
      "type": "date"
    },
    model: {
      value: (_vm.edit.akhirberlaku),
      callback: function($$v) {
        _vm.edit.akhirberlaku = $$v
      },
      expression: " edit.akhirberlaku "
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.keterangan),
      expression: " edit.keterangan "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Keterangan Dokumen/Data",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.keterangan = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.field.fl_file === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "title": "Upload Dokumen",
      "label": "Upload File (Max. 2000 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "title": "Upload Dokumen",
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateDokap()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "no-close-on-backdrop": "",
      "size": "medium"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl),
      callback: function($$v) {
        _vm.Modaleditdtl = $$v
      },
      expression: " Modaleditdtl "
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingEdit,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingEdit = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addRow($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Peti Kemas"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nocont),
      expression: " nocont "
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "11",
      "title": "Nomor Peti Kemas",
      "name": "petikemas",
      "required": ""
    },
    domProps: {
      "value": (_vm.nocont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nocont = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('petikemas')),
      expression: " errors.has( 'petikemas' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('petikemas')) + "\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Ukuran"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ukcont),
      expression: " ukcont "
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "2",
      "title": "Nomor Peti Kemas",
      "name": "ukuran",
      "required": ""
    },
    domProps: {
      "value": (_vm.ukcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ukcont = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ukuran')),
      expression: " errors.has( 'ukuran' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n              Wajib diisi dan berisi angka\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "<br>"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Tambah",
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n              Tambah")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', [_c('input', {
    ref: "fileupload",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.loadCSV
    }
  }), _vm._v(" "), _c('small', [_vm._v("upload file csv (format csv menggunakan koma (,) bukan titik koma (;))")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('a', {
    attrs: {
      "href": _vm.$http.options.root + '/dllaporan/formatcont'
    }
  }, [_c('button', {
    staticClass: "btn btn-warning"
  }, [_vm._v("Download Format\n            CSV")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor Peti Kemas")]), _vm._v(" "), _c('th', [_vm._v("Ukuran")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', {
      key: peti.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.hapusrow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.Modaleditdtl = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v("  \n      "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.savedokapdtl
    }
  }, [_vm._v("Simpan")])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl1 = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl1),
      callback: function($$v) {
        _vm.Modaleditdtl1 = $$v
      },
      expression: " Modaleditdtl1 "
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nocont),
      expression: " nocont "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor",
      "name": ""
    },
    domProps: {
      "value": (_vm.nocont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nocont = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ukcont),
      expression: " ukcont "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "title": "Nomor Peti Kemas",
      "name": ""
    },
    domProps: {
      "value": (_vm.ukcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ukcont = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload File (Max. 800 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Tambah Dokumen",
      "type": "button"
    },
    on: {
      "click": _vm.savedokapdtl1
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Dokumen")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', {
      key: peti.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))]), _vm._v(" "), _c('td', [(peti.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": _vm.$http.options.base + peti.url_file + '/' + peti.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmdtl(peti.id_permohonan_dokap_dtl)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl2 = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl2),
      callback: function($$v) {
        _vm.Modaleditdtl2 = $$v
      },
      expression: "Modaleditdtl2"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingEdit,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor PPFTZ*"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.noPpftz),
      expression: "dataNoStrip.noPpftz"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "No. PPFTZ",
      "type": "text",
      "placeholder": "No. PPFTZ"
    },
    domProps: {
      "value": (_vm.dataNoStrip.noPpftz)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.noPpftz = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal PPFTZ*"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.tglPpftz),
      expression: "dataNoStrip.tglPpftz"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tgl. PPFTZ",
      "type": "date",
      "placeholder": "Tgl. PPFTZ"
    },
    domProps: {
      "value": (_vm.dataNoStrip.tglPpftz)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.tglPpftz = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor BC 1.1*"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.noBc11),
      expression: "dataNoStrip.noBc11"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "No. BC 1.1",
      "type": "text",
      "placeholder": "No. BC 1.1"
    },
    domProps: {
      "value": (_vm.dataNoStrip.noBc11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.noBc11 = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal BC 1.1*"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.tglBc11),
      expression: "dataNoStrip.tglBc11"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tgl. BC 1.1",
      "type": "date",
      "placeholder": "Tgl. BC 1.1"
    },
    domProps: {
      "value": (_vm.dataNoStrip.tglBc11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.tglBc11 = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.pos),
      expression: "dataNoStrip.pos"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pos",
      "type": "text",
      "placeholder": "Pos*"
    },
    domProps: {
      "value": (_vm.dataNoStrip.pos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.pos = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.noKontainer),
      expression: "dataNoStrip.noKontainer"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "No. Kontainer",
      "type": "text",
      "placeholder": "No. Kontainer*"
    },
    domProps: {
      "value": (_vm.dataNoStrip.noKontainer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.noKontainer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.ukKontainer),
      expression: "dataNoStrip.ukKontainer"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Uk. Kontainer",
      "type": "text",
      "placeholder": "Uk. Kontainer*"
    },
    domProps: {
      "value": (_vm.dataNoStrip.ukKontainer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.ukKontainer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.savedokapdtl2
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("No. / Tgl. PPFTZ")]), _vm._v(" "), _c('th', [_vm._v("No. / Tgl. BC 1.1")]), _vm._v(" "), _c('th', [_vm._v("Pos")]), _vm._v(" "), _c('th', [_vm._v("No. / Uk. Kontainer")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(item, index) {
    return _c('tr', {
      key: item.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isian1 + ' / ' + item.isian2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isian3 + ' / ' + item.isian4))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isian5))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isian6 + ' / ' + item.isian7 + '"LCL') + " "), _c('button', {
      staticClass: "btn btn-danger pull-right"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          _vm.confirmdtl2(item.id_permohonan_dokap_dtl)
        }
      }
    })])])])
  }))])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Persetujuan"
    },
    on: {
      "ok": function($event) {
        _vm.ModalDisclaimer = false
      }
    },
    model: {
      value: (_vm.ModalDisclaimer),
      callback: function($$v) {
        _vm.ModalDisclaimer = $$v
      },
      expression: " ModalDisclaimer "
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingKirim,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingKirim = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', [_c('b-form-checkbox', {
    attrs: {
      "value": "Y",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.disclaimer),
      callback: function($$v) {
        _vm.disclaimer = $$v
      },
      expression: " disclaimer "
    }
  }, [_vm._v("\n            Saya menyatakan bahwa data yang disampaikan adalah benar\n            dan saya bertanggungjawab atas kebenaran data/dokumen yang disampaikan\n          ")]), _vm._v(" "), (_vm.disclaimer === 'Y') ? _c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.kirim
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Kirim")])]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-danger",
    attrs: {
      "title": "Hasil Validasi",
      "ok-variant": "danger"
    },
    model: {
      value: (_vm.ModalError),
      callback: function($$v) {
        _vm.ModalError = $$v
      },
      expression: " ModalError "
    }
  }, [_c('ul', _vm._l((_vm.validasi), function(val) {
    return _c('li', {
      staticClass: "font"
    }, [_vm._v(_vm._s(val))])
  }))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pengajuan_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6112802e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Pengajuan_vue__ = __webpack_require__(284);
function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6112802e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pengajuan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6112802e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Pengajuan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_epic_spinners__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_1_epic_spinners__["a" /* HalfCircleSpinner */] },
  data: function data() {
    return {
      pengajuan: [],
      isLoading: true,
      listBL: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc',
      searchFilter: '',
      pageOfItems: []
    };
  },
  created: function created() {
    this.getPengajuan();
  },

  computed: {
    filteredData: function filteredData() {
      var _this = this;

      return this.pengajuan.sort(function (a, b) {
        var modifier = 1;
        if (_this.currentSortDir === 'desc') modifier = -1;
        if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
        if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (items) {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(_this.searchFilter.toLowerCase()) !== -1) {
            return true;
          }
        }
        return false;
      });
    }
  },
  methods: {
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    onChangePage: function onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    getPengajuan: function getPengajuan(page) {
      var _this2 = this;

      if (typeof page === 'undefined') {
        page = 'pengajuanftz';
      }
      var auth = {
        user: this.$store.getters['auth/user']['username']
      };
      this.$http.post(page, auth).then(function (response) {
        _this2.pengajuan = response.data;
        _this2.isLoading = false;
      });
    },
    confir: function confir(iddel) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()({
        title: 'Hapus data permohonan',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this3.deletePengajuan(iddel);
        }
      });
    },
    deletePengajuan: function deletePengajuan(id) {
      var _this4 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      };
      this.$http.post('delete', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this4.getPengajuan();
      });
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> List Pengajuan Izin"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.isLoading) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success ",
    attrs: {
      "to": '/pengajuan/header',
      "title": "Rekam permohonan izin"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_mohon')
      }
    }
  }, [_vm._v("No Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_mohon')
      }
    }
  }, [_vm._v("Tgl Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('nama_ijin')
      }
    }
  }, [_vm._v("Jenis Izin"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('status')
      }
    }
  }, [_vm._v("Status"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(bl) {
    return _c('tr', {
      key: bl.id_rekon_manifes
    }, [_c('td', [_vm._v(_vm._s(bl.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.nama_ijin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.ur_status))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": '/pengajuan/detilheader/' + bl.id_permohonan,
        "title": "Detil Pengajuan"
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Pengajuan"
      },
      on: {
        "click": function($event) {
          _vm.confir(bl.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)]) : _vm._e()])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441e01ce_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__(288);
function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-441e01ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441e01ce_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      laporan: null,
      isLoading: false,
      loading: true,
      channel_name: '',
      channel_fields: [],
      channel_entries: [],
      file: '',
      fileSize: 0,
      fileExt: '',
      fileName: '',
      fileValid: '',
      jns_laporan: '',
      parse_header: [],
      parse_csv: [],
      sortOrders: {},
      sortKey: '',
      tgl_awal: null,
      tgl_akhir: null,
      tps: this.$store.getters['auth/user']['ppjk']
    };
  },

  filters: {
    capitalize: function capitalize(str) {
      return str.toUpperCase();
    }
  },
  computed: {
    isComplete: function isComplete() {
      return this.laporan && this.tgl_awal && this.jns_laporan && this.loading;
    }
  },
  methods: {
    simpanlaporan: function simpanlaporan() {
      var _this = this;

      this.isLoading = true;
      var datalaporan = {
        user: this.$store.getters['auth/user']['username'],
        npwp: this.$store.getters['auth/user']['npwp'],
        id_gudang: this.laporan[0].id_gudang,
        bulan: '01',
        jns_laporan: this.jns_laporan,
        laporan: this.laporan,
        file: this.file,
        ext: this.fileExt,
        tgl_awal: this.tgl_awal,
        tgl_akhir: this.tgl_akhir
      };
      this.$http.post('laporan', datalaporan).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this.loading = true;
        _this.isLoading = false;
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status).then(function () {
          if (response.data.status === 'success') {
            _this.$router.push('/pengajuan/browseupload');
          }
        });
      });
    },
    swalreport: function swalreport() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()({
        title: 'Kirim Laporan?',
        text: 'Anda yakin mengirimkan laporan?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this2.simpanlaporan();
        }
      });
    },

    sortBy: function sortBy(key) {
      var vm = this;
      vm.sortKey = key;
      vm.sortOrders[key] = vm.sortOrders[key] * -1;
    },
    csvJSON: function csvJSON(csv) {
      var vm = this;
      var lines = csv.split('\n');
      var result = [];
      var headers = lines[0].split(';');
      vm.parse_header = lines[0].split(';');
      lines[0].split(';').forEach(function (key) {
        vm.sortOrders[key] = 1;
      });

      lines.map(function (line, indexLine) {
        if (indexLine < 1) return;

        var obj = {};
        var currentline = line.split(';');

        headers.map(function (header, indexHeader) {
          obj[header] = currentline[indexHeader];
        });

        result.push(obj);
      });

      result.pop();

      return result;
    },
    loadCSV: function loadCSV(e) {
      var vm = this;
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(e.target.files[0]);

        reader.onload = function (event) {
          var csv = event.target.result;
          vm.parse_csv = vm.csvJSON(csv);
          vm.laporan = vm.csvJSON(csv);
        };
        reader.onerror = function (evt) {
          if (evt.target.error.name === 'NotReadableError') {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('Cannot read file !');
          }
        };
      } else {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('FileReader are not supported in this browser.');
      }
    },
    fileChanged: function fileChanged(e) {
      var _this3 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      this.fileSize = e.target.files[0].size / 1024;
      this.fileExt = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      this.fileName = e.target.files[0].name;
      fileReader.onload = function (e) {
        _this3.file = e.target.result;
        _this3.$Progress.finish();
      };
    },
    fileChangeddtl: function fileChangeddtl(e) {
      var _this4 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      this.fileSize = e.target.files[0].size / 1024;
      this.fileExt = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      this.fileName = e.target.files[0].name;
      fileReader.onload = function (e) {
        _this4.file = e.target.result;
        _this4.$Progress.finish();
      };
    },
    cekFile: function cekFile() {
      var hasil = true;
      if (this.fileSize > 0) {
        this.fileValid = 'File ' + this.fileName;
        if (this.fileSize > 800) {
          this.fileValid = this.fileValid + ' berukuran ' + Math.round(this.fileSize * 100) / 100 + ' Kb, max. 800 Kb. ' + '\n\r';
          hasil = false;
        }
      }
      return hasil;
    },
    upload: function upload($event) {
      this.fileChanged($event);
      this.loadCSV($event);
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-sm"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Upload CSV Laporan")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "csv_file",
      "name": "csv_file"
    },
    on: {
      "change": function($event) {
        _vm.upload($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.jns_laporan != '') ? _c('a', {
    attrs: {
      "href": _vm.$http.options.root + '/dllaporan/' + _vm.jns_laporan
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "title": "Format Laporan"
    },
    on: {
      "click": function($event) {}
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download\n              Format")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Laporan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jns_laporan),
      expression: "jns_laporan"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen Yang Diajukan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jns_laporan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Laporan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Laporan Tempat Penimbunan Sementara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Laporan Bongkar Kawasan Pabean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Laporan BKC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Rekonsiliasi Outward Manifes - Barkir")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Awal Laporan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "title": "Tanggal Permohonan Izin",
      "name": "Tgl Akhir",
      "type": "date"
    },
    model: {
      value: (_vm.tgl_awal),
      callback: function($$v) {
        _vm.tgl_awal = $$v
      },
      expression: "tgl_awal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Akhir Laporan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "title": "Tanggal Permohonan Izin",
      "name": "Tgl Akhir",
      "type": "date"
    },
    model: {
      value: (_vm.tgl_akhir),
      callback: function($$v) {
        _vm.tgl_akhir = $$v
      },
      expression: "tgl_akhir"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.jns_laporan == '1' || _vm.jns_laporan == '2') ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "height": "300px",
      "max-width": "1400px",
      "overflow-y": "scroll",
      "overflow-x": "scroll"
    }
  }, [(_vm.parse_csv) ? _c('table', {
    staticClass: "table table-bordered table-hover table-sm",
    attrs: {
      "border": "1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.parse_header), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(key)) + "\n                "), _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
    })])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.parse_csv), function(csv) {
    return _c('tr', _vm._l((_vm.parse_header), function(key) {
      return _c('td', [_vm._v("\n                " + _vm._s(csv[key]) + "\n              ")])
    }))
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('br'), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "title": "Kirim Laporan",
      "disabled": !_vm.isComplete
    },
    on: {
      "click": _vm.swalreport
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Kirim")])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListBrowsV2_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b01828_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListBrowsV2_vue__ = __webpack_require__(291);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListBrowsV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b01828_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListBrowsV2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* HalfCircleSpinner */], ModelListSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelListSelect"]
  },
  data: function data() {
    return {
      searchFilter: '',
      isLoading: true,
      pageOfItems: [],
      ModalCatatan: false,
      jnijin: [],
      jnperijinan: '',
      catatan: [],
      listBrowse: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc',
      user: this.$store.getters['auth/user']['username']
    };
  },

  computed: {
    filteredData: function filteredData() {
      var _this = this;

      return this.listBrowse.sort(function (a, b) {
        var modifier = 1;
        if (_this.currentSortDir === 'desc') modifier = -1;
        if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
        if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (items) {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(_this.searchFilter.toLowerCase()) !== -1) {
            return true;
          }
        }
        return false;
      }).filter(function (items) {
        if (_this.jnperijinan === '') return true;
        if (items.id_ijin === _this.jnperijinan) return true;
        return false;
      });
    }
  },
  mounted: function mounted() {
    this.browse();
    this.getJnIjin();
  },

  methods: {
    getJnIjin: function getJnIjin() {
      var _this2 = this;

      this.$http.get('ref/jnijin').then(function (response) {
        _this2.jnijin = response.data;
      });
    },
    opencatatan: function opencatatan(idPermohonan) {
      this.getCatatan(idPermohonan);
    },
    getCatatan: function getCatatan(idPermohonan) {
      var _this3 = this;

      var idmohon = {
        idijin: idPermohonan
      };
      this.$http.post('bc/petugas/approvecatatanpengguna', idmohon).then(function (response) {
        _this3.catatan = response.data;
        _this3.ModalCatatan = true;
      });
    },

    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    browse: function browse() {
      var _this4 = this;

      var data = {
        user: this.$store.getters['auth/user']['username']
      };
      this.$http.post('brows/listv2', data).then(function (response) {
        _this4.listBrowse = response.data;
        _this4.isLoading = false;
      });
    },
    onChangePage: function onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    tes: function tes(status) {
      var warna;
      if (status === '50') {
        warna = 'limegreen';
      } else if (status === '20' || status === '27' || status === '28' || status === '29') {
        warna = 'Yellow';
      } else if (status === '90') {
        warna = 'tomato';
      } else {
        warna = 'White';
      }
      return warna;
    },
    opennew: function opennew(id) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Ajukan kembali data permohonan',
        text: 'Anda yakin akan kembali mengajukan data permohonan ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this5.isLoading = true;
            _this5.ajukembali(id);
        }
      });
    },
    ajukembali: function ajukembali(id) {
      var _this6 = this;

      var data = {
        id_permohonan: id
      };
      this.$http.post('ajukembali', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this6.$router.push('/pengajuan/detilheader/' + response.data.id);
      });
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-magnifier'></i> Browse"
    }
  }, [_c('div', {
    staticClass: "row d-flex align-items-center mb-3 justify-content-md-between spaced"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-lg-4 mt-2"
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pencarian"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-lg-4 mt-2"
  }, [_c('div', {}, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.jnijin,
      "option-value": "id_ijin",
      "option-text": "nama_ijin",
      "name": "Jenis Perizinan",
      "placeholder": "-- Pilih Jenis Perijinan --"
    },
    model: {
      value: (_vm.jnperijinan),
      callback: function($$v) {
        _vm.jnperijinan = $$v
      },
      expression: "jnperijinan"
    }
  })], 1)])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer",
      "vertical-align": "baseline"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_mohon')
      }
    }
  }, [_vm._v("No Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_setuju')
      }
    }
  }, [_vm._v("No Setuju "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('nama_ijin')
      }
    }
  }, [_vm._v("Jenis Izin"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('status')
      }
    }
  }, [_vm._v("Status"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(brow) {
    return _c('tr', {
      key: brow.id_permohonan
    }, [_c('td', [_vm._v(_vm._s(brow.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.no_mohon) + " "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(brow.tgl_mohon))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.no_setuju) + " "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(brow.tgl_setuju))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.nama_ijin))]), _vm._v(" "), _c('td', {
      style: ('background-color:' + _vm.tes(brow.status))
    }, [_vm._v(_vm._s(brow.ur_status))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": '/brows/detilbrows/' + brow.id_permohonan,
        "title": "Detil Pengajuan"
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Catatan Petugas",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opencatatan(brow.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-list-ul"
    })]), _vm._v(" "), ((brow.status != 99 && !((brow.id_ijin == 31 || brow.id_ijin == 32 || brow.id_ijin == 33 || brow.id_ijin == 34 || brow.id_ijin == 35 || brow.id_ijin == 36 || brow.id_ijin == 37 || brow.id_ijin == 38 || brow.id_ijin == 44 || brow.id_ijin == 13) && brow.fl_setuju == 'Y') && !((brow.id_ijin == 27 || brow.id_ijin == 30 || brow.id_ijin == 46 || brow.id_ijin == 47) && brow.fl_setuju == 'T' || (brow.id_ijin == 45 && brow.status == '91' && brow.fl_setuju == 'R')) && brow.no_setuju !== null && brow.nm_file === null || (brow.id_ijin == 49 && brow.status == '98') || (brow.id_ijin == 50 && brow.status == '98'))) ? _c('a', {
      attrs: {
        "title": "Print Izin",
        "href": _vm.$http.options.base + '/api/pdf/' + _vm.user + '/' + brow.id_permohonan,
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    })])]) : _vm._e(), _vm._v(" "), (brow.no_setuju !== null && brow.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Print Izin",
        "href": _vm.$http.options.base + brow.url_file + '/' + brow.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    })]) : _vm._e(), _vm._v(" "), (brow.status == '90') ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Ajukan Kembali"
      },
      on: {
        "click": function($event) {
          _vm.opennew(brow.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s((brow.id_ijin == 27 || brow.id_ijin == 30) && brow.fl_setuju == 'Y' ? 'Diperiksa' : ((brow.id_ijin == 27 || brow.id_ijin == 30) && brow.fl_setuju == 'T' ? 'Tidak diperiksa' : brow.fl_setuju)))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "fade": "",
      "hide-footer": "",
      "title": "Catatan Petugas",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ModalCatatan = false
      }
    },
    model: {
      value: (_vm.ModalCatatan),
      callback: function($$v) {
        _vm.ModalCatatan = $$v
      },
      expression: "ModalCatatan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', {
    staticClass: "align-middle"
  }, [_c('th', [_vm._v("Nama Pegawai")]), _vm._v(" "), _c('th', [_vm._v("Level Pemeriksa")]), _vm._v(" "), _c('th', [_vm._v("Catatan")]), _vm._v(" "), _c('th', [_vm._v("Wkt Selesai")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.catatan), function(catat) {
    return _c('tr', {
      key: catat.NAMA
    }, [_c('td', [_vm._v(_vm._s(catat.NAMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.ur_pemeriksa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.catatan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.wk_selesai))])])
  }))])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilBrows_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d5043e2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilBrows_vue__ = __webpack_require__(295);
function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d5043e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilBrows_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d5043e2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilBrows_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* HalfCircleSpinner */] },
  data: function data() {
    return {
      Modaleditdtl: false,
      Modaleditdtl2: false,
      DataHeader: null,
      listdokap: null,
      listdokapptg: null,
      idijin: '',
      cont: [],
      dokap_current: ''
    };
  },
  created: function created() {
    this.getHeader();
    this.getDokap();
    this.getDokapptg();
  },

  methods: {
    getHeader: function getHeader() {
      var _this = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        idmohon: this.$route.params.idmohon
      };
      this.$http.post('dtlheader', data).then(function (response) {
        _this.DataHeader = response.data;
        _this.idijin = response.data.id_ijin;
        _this.getDokap(response.data.id_ijin);
      });
    },
    getDokap: function getDokap() {
      var _this2 = this;

      var idijinn = {
        user: this.$store.getters['auth/user']['username'],
        idijin: this.$route.params.idmohon
      };
      this.$http.post('dokap', idijinn).then(function (response) {
        _this2.listdokap = response.data;
      });
    },
    getDokapdtl: function getDokapdtl() {
      var _this3 = this;

      var iddokap = {
        iddokap: this.dokap_current
      };
      this.$http.post('dokapdtl', iddokap).then(function (response) {
        _this3.cont = response.data;
      });
    },
    addModal: function addModal() {
      this.ModalDokap = true;
      this.Reset();
    },
    dlDokap: function dlDokap(id) {
      var dokap = {
        idrekam: this.DataHeader.nip_rekam,
        iddokap: id
      };
      this.$http.post('dlDokap', dokap);
    },
    opendtl: function opendtl(id, kd) {
      if (kd === 256) {
        this.Modaleditdtl2 = true;
        this.dokap_current = id;
        this.getDokapdtl();
      } else {
        this.Modaleditdtl = true;
        this.dokap_current = id;
        this.getDokapdtl();
      }
    },
    getDokapptg: function getDokapptg() {
      var _this4 = this;

      var idijinn = {
        idijin: this.$route.params.idmohon
      };
      this.$http.post('bc/petugas/approvedokapptg', idijinn).then(function (response) {
        _this4.listdokapptg = response.data;
      });
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan"
    }
  }, [(!_vm.DataHeader || !_vm.listdokap) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.DataHeader && _vm.listdokap) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Pengajuan Izin"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.DataHeader.URAIAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.npwp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.NM_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.AL_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No HP/Telepon")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_hp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Jenis Permohonan Izin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.nama_ijin))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.ur_status))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("No Setuju")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_setuju))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tgl Setuju")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_setuju))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kantor")]), _vm._v(" "), _c('td', [_vm._v("020400 - KPU BC Tipe B Batam")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Tanggal Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_mohon))])])])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                    Lampiran Dokumen\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokap), function(dokap) {
    return _c('tr', {
      key: dokap.id_permohonan_dokap
    }, [_c('td', [_vm._v(_vm._s(dokap.nama_dokap))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokap.keterangan))]), _vm._v(" "), _c('td', [(dokap.kd_dokap === 151 || dokap.kd_dokap === 256) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]) : _vm._e(), _vm._v(" "), (dokap.url_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "href": dokap.url_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokapptg), function(dokapptg) {
    return _c('tr', {
      key: dokapptg.id_permohonan_dokap
    }, [_c('td', [_vm._v(_vm._s(dokapptg.nama_dokap))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokapptg.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokapptg.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-md-block"
    }, [_vm._v(_vm._s(dokapptg.keterangan))]), _vm._v(" "), _c('td', [(dokapptg.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": _vm.$http.options.base + dokapptg.url_file + '/' + dokapptg.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), (dokapptg.fl_mandatory === null) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Dokumen/Data Pelengkap"
      },
      on: {
        "click": function($event) {
          _vm.confir(dokapptg.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/brows'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" Back\n              ")])], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Detail Dokumen Pelengkap",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl),
      callback: function($$v) {
        _vm.Modaleditdtl = $$v
      },
      expression: "Modaleditdtl"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "500px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor Peti Kemas")]), _vm._v(" "), _c('th', [_vm._v("Ukuran")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', {
      key: peti.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))])])
  }))])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Detail Dokumen Pelengkap",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl2 = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl2),
      callback: function($$v) {
        _vm.Modaleditdtl2 = $$v
      },
      expression: "Modaleditdtl2"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "500px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("No. / Tgl. PPFTZ")]), _vm._v(" "), _c('th', [_vm._v("No. / Tgl. BC 1.1")]), _vm._v(" "), _c('th', [_vm._v("Pos")]), _vm._v(" "), _c('th', [_vm._v("No. / Uk. Kontainer")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.isian1 + ' / ' + data.isian2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.isian3 + ' / ' + data.isian4))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.isian5))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.isian6 + ' / ' + data.isian7 + '"LCL'))])])
  }))])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_browseupload_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d75ebb0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_browseupload_vue__ = __webpack_require__(299);
function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d75ebb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_browseupload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d75ebb0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_browseupload_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      draft: '',
      brows: [],
      modaldata: false,
      q: '',
      p: '',
      b: '',
      c: 'perijinan.tl_hdr.id_tl_hdr',
      d: 'desc',
      daftar: [],
      jenis: ''

    };
  },
  created: function created() {
    this.getBrows();
  },

  methods: {
    getBrows: function getBrows(page) {
      var _this = this;

      if (typeof page === 'undefined') {
        page = 'laporan/browseupload?page=1';
      }
      var auth = {
        npwp: this.$store.getters['auth/user']['npwp'],
        q: this.q,
        p: this.p,
        b: this.b,
        c: this.c,
        d: this.d
      };
      this.$http.post(page, auth).then(function (response) {
        _this.brows = response.data;
      });
    },
    unduh: function unduh(id) {
      var datalaporan = {
        id: id
      };
      this.$http.post('unduh', datalaporan);
    },
    getData: function getData(id, jn) {
      var _this2 = this;

      var data = {
        id: id,
        jenis: jn
      };
      this.$http.post('laporan/dataupl', data).then(function (response) {
        _this2.daftar = response.data;
        _this2.jenis = jn;
        _this2.modaldata = true;
      });
    },
    setC: function setC(orderBy) {
      if (this.d === 'asc') {
        this.d = 'desc';
      } else {
        this.d = 'asc';
      }
      this.c = orderBy;
      this.getBrows();
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> Browse Upload Laporan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#/pengajuan/browseupload"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "role": "group"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.q),
      expression: "q"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Pencarian",
      "type": "text"
    },
    domProps: {
      "value": (_vm.q)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.q = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.getBrows()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.b),
      expression: "b"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getBrows()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Laporan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Laporan TPS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Laporan Kawasan Pabean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Laporan TPE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Rekonsiliasi Outward Manifes - Barkir")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "align",
      rawName: "v-align",
      value: (_vm.middle),
      expression: "middle"
    }],
    staticClass: "d-none d-sm-block",
    on: {
      "click": function($event) {
        _vm.setC('NM_PERUSAHAAN')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    }
  }, [_vm._v("Nama Perusahaan")])]), _vm._v(" "), _c('th', [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    },
    on: {
      "click": function($event) {
        _vm.setC('perijinan.tl_hdr.wk_kirim')
      }
    }
  }, [_vm._v("Waktu Kirim")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    },
    on: {
      "click": function($event) {
        _vm.setC('perijinan.tl_hdr.tgl_awal')
      }
    }
  }, [_vm._v("Tanggal Awal")])]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    },
    on: {
      "click": function($event) {
        _vm.setC('perijinan.tl_hdr.tgl_akhir')
      }
    }
  }, [_vm._v("Tanggal Akhir")])]), _vm._v(" "), _c('th', [_c('a', {
    attrs: {
      "href": "#/pengajuan/browseupload"
    },
    on: {
      "click": function($event) {
        _vm.setC('perijinan.tl_hdr.jns_laporan')
      }
    }
  }, [_vm._v("Jenis Laporan")])]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.brows.data), function(brow) {
    return _c('tr', [_c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(brow.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.wk_rekam) + " " + _vm._s(brow.wk_kirim))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.tgl_awal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.tgl_akhir))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(brow.jenis))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Download",
        "href": _vm.$http.options.root + '/unduh/' + brow.id_tl_hdr + '/' + brow.nm_file
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.getData(brow.id_tl_hdr, brow.jns_laporan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.first_page_url)
      }
    }
  }, [_vm._v("\n            «\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.prev_page_url)
      }
    }
  }, [_vm._v("\n            ‹\n          ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.p),
      expression: "p"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "placeholder": _vm.brows.current_page + '/' + _vm.brows.last_page,
      "type": "text",
      "size": "2"
    },
    domProps: {
      "value": (_vm.p)
    },
    on: {
      "change": function($event) {
        _vm.getBrows('bc/brows/browslist?page=' + _vm.p)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.p = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.next_page_url)
      }
    }
  }, [_vm._v("\n            ›\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.last_page_url)
      }
    }
  }, [_vm._v("\n            »\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-warning",
    attrs: {
      "hide-footer": "",
      "title": "Laporan",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.modaldata = false
      }
    },
    model: {
      value: (_vm.modaldata),
      callback: function($$v) {
        _vm.modaldata = $$v
      },
      expression: "modaldata"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "height": "500px",
      "max-width": "800px",
      "overflow-y": "scroll",
      "overflow-x": "scroll"
    }
  }, [(_vm.jenis == 1) ? _c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BC 1.0")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("BC 1.1")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("B/L / AWB")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Shipper")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Consignee")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Jumlah")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" Lokasi Timbun (Gudang / Lapangan)")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" No. Kontainer")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" Waktu (Masuk)")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" No. Segel")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" Waktu (Keluar)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dok. Pengeluaran")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Keterangan")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Pos")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Container")]), _vm._v(" "), _c('th', [_vm._v("Kemasan")]), _vm._v(" "), _c('th', [_vm._v("Bruto")]), _vm._v(" "), _c('th', [_vm._v("Volume")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Jam")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Jam")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")])]), _vm._v(" "), _vm._l((_vm.daftar), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_bc10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_bc10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_bc11))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_bc11))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_pos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_bl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_bl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipper))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.consignee))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jml_cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jml_kemasan) + " " + _vm._s(data.kd_kemasan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.brutto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.volume))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.id_gudang))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_masuk))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jam_masuk))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_segel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_keluar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jam_keluar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.no_dok_keluar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tgl_dok_keluar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.keterangan))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.jenis == 2) ? _c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BC 1.0")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Nama Sarana Pengangkut")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("No. Voy")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Bendera")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Pelabuhan")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Waktu Kedatangan / Keberangkatan")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Jumlah")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Agen Pengangkut")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BC 1.1 (Inward)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("BC 1.1 (Outward)")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Keterangan")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Asal")]), _vm._v(" "), _c('th', [_vm._v("Tujuan")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("Jam")]), _vm._v(" "), _c('th', [_vm._v("Kontainer")]), _vm._v(" "), _c('th', [_vm._v("Kemasan")]), _vm._v(" "), _c('th', [_vm._v("Bruto")]), _vm._v(" "), _c('th', [_vm._v("Volume")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")])]), _vm._v(" "), _vm._l((_vm.daftar), function(data2, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.no_bc10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.tgl_bc10))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.nm_sarkut))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.no_voy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.bendera))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.pel_asal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.pel_tujuan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.tgl_tiba))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.jam_tiba))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.jml_cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.jml_kemasan) + " " + _vm._s(data2.kd_kemasan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.bruto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.volume))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.agen_pengangkut))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.no_bc11_in))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.tgl_bc11_in))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.no_bc11_out))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.tgl_bc11_out))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data2.keterangan))])])
  })], 2) : _vm._e()])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_browseftz_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632d6b56_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_browseftz_vue__ = __webpack_require__(302);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_browseftz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632d6b56_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_browseftz_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* HalfCircleSpinner */]
  },
  data: function data() {
    return {
      searchFilter: '',
      isLoading: true,
      pageOfItems: [],
      ModalCatatan: false,
      catatan: [],
      listBL: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc'
    };
  },

  computed: {
    filteredData: function filteredData() {
      var _this = this;

      return this.listBL.sort(function (a, b) {
        var modifier = 1;
        if (_this.currentSortDir === 'desc') modifier = -1;
        if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
        if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (items) {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(_this.searchFilter.toLowerCase()) !== -1) {
            return true;
          }
        }
        return false;
      });
    }
  },
  mounted: function mounted() {
    this.browse();
  },

  methods: {
    opencatatan: function opencatatan(idPermohonan) {
      this.getCatatan(idPermohonan);
    },
    getCatatan: function getCatatan(idPermohonan) {
      var _this2 = this;

      var idmohon = {
        idijin: idPermohonan
      };
      this.$http.post('bc/petugas/approvecatatanpengguna', idmohon).then(function (response) {
        _this2.catatan = response.data;
        _this2.ModalCatatan = true;
      });
    },

    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    browse: function browse() {
      var _this3 = this;

      var data = {
        user: this.$store.getters['auth/user']['username']
      };
      this.$http.post('browseftz', data).then(function (response) {
        _this3.listBL = response.data;
        _this3.isLoading = false;
      });
    },
    onChangePage: function onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    tes: function tes(status) {
      var warna;
      if (status === '50') {
        warna = 'limegreen';
      } else if (status === '20' || status === '27' || status === '28' || status === '29') {
        warna = 'Yellow';
      } else if (status === '90') {
        warna = 'tomato';
      } else {
        warna = 'White';
      }
      return warna;
    },
    opennew: function opennew(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Ajukan kembali data permohonan',
        text: 'Anda yakin akan kembali mengajukan data permohonan ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this4.isLoading = true;
            _this4.ajukembali(id);
        }
      });
    },
    ajukembali: function ajukembali(id) {
      var _this5 = this;

      var data = {
        id_permohonan: id
      };
      this.$http.post('ajukembali', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this5.$router.push('/pengajuanftz/detilheader/' + response.data.id);
      });
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-magnifier'></i> Pengajuan FTZ"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mx-3 my-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pencarian"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto pr-3 pb-3"
  }, [_vm._v("\n         \n      ")])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_mohon')
      }
    }
  }, [_vm._v("No Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_mohon')
      }
    }
  }, [_vm._v("Tgl Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_setuju')
      }
    }
  }, [_vm._v("No Setuju "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_setuju')
      }
    }
  }, [_vm._v("Tgl Setuju "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('nama_ijin')
      }
    }
  }, [_vm._v("Jenis Izin"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('status')
      }
    }
  }, [_vm._v("Status"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(bl) {
    return _c('tr', {
      key: bl.id_rekon_manifes
    }, [_c('td', [_vm._v(_vm._s(bl.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_setuju))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_setuju))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.nama_ijin))]), _vm._v(" "), _c('td', {
      style: ('background-color:' + _vm.tes(bl.status))
    }, [_vm._v(_vm._s(bl.ur_status))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": '/browseftz/list/' + bl.id_permohonan,
        "title": "Detil Pengajuan"
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Catatan Petugas",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opencatatan(bl.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-list-ul"
    })]), _vm._v(" "), (bl.status == '90') ? _c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Ajukan Kembali"
      },
      on: {
        "click": function($event) {
          _vm.opennew(bl.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e()], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "fade": "",
      "hide-footer": "",
      "title": "Catatan Petugas",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ModalCatatan = false
      }
    },
    model: {
      value: (_vm.ModalCatatan),
      callback: function($$v) {
        _vm.ModalCatatan = $$v
      },
      expression: "ModalCatatan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', {
    staticClass: "align-middle"
  }, [_c('th', [_vm._v("Nama Pegawai")]), _vm._v(" "), _c('th', [_vm._v("Level Pemeriksa")]), _vm._v(" "), _c('th', [_vm._v("Catatan")]), _vm._v(" "), _c('th', [_vm._v("Wkt Selesai")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.catatan), function(catat) {
    return _c('tr', {
      key: catat.NAMA
    }, [_c('td', [_vm._v(_vm._s(catat.NAMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.ur_pemeriksa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.catatan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(catat.wk_selesai))])])
  }))])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PengajuanFtz_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4d848e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_PengajuanFtz_vue__ = __webpack_require__(306);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a4d848e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PengajuanFtz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4d848e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_PengajuanFtz_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_epic_spinners__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_1_epic_spinners__["a" /* HalfCircleSpinner */] },
  data: function data() {
    return {
      pengajuan: [],
      isLoading: true,
      listBL: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc',
      searchFilter: '',
      pageOfItems: []
    };
  },
  created: function created() {
    this.getPengajuan();
  },

  computed: {
    filteredData: function filteredData() {
      var _this = this;

      return this.pengajuan.sort(function (a, b) {
        var modifier = 1;
        if (_this.currentSortDir === 'desc') modifier = -1;
        if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
        if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (items) {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(_this.searchFilter.toLowerCase()) !== -1) {
            return true;
          }
        }
        return false;
      });
    }
  },
  methods: {
    onChangePage: function onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    getPengajuan: function getPengajuan(page) {
      var _this2 = this;

      if (typeof page === 'undefined') {
        page = 'pengajuanftz';
      }
      var auth = {
        user: this.$store.getters['auth/user']['username']
      };
      this.$http.post(page, auth).then(function (response) {
        _this2.pengajuan = response.data;
        _this2.isLoading = false;
      });
    },
    confir: function confir(iddel) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()({
        title: 'Hapus data permohonan',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this3.deletePengajuan(iddel);
        }
      });
    },
    deletePengajuan: function deletePengajuan(id) {
      var _this4 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      };
      this.$http.post('delete', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this4.getPengajuan();
      });
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> List Pengajuan Izin"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success ",
    attrs: {
      "to": '/pengajuanftz/addheader',
      "title": "Rekam permohonan izin"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_mohon')
      }
    }
  }, [_vm._v("No Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_mohon')
      }
    }
  }, [_vm._v("Tgl Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('nama_ijin')
      }
    }
  }, [_vm._v("Jenis Izin"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('status')
      }
    }
  }, [_vm._v("Status"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(bl) {
    return _c('tr', {
      key: bl.id_rekon_manifes
    }, [_c('td', [_vm._v(_vm._s(bl.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.nama_ijin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.ur_status))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": '/pengajuanftz/detilheader/' + bl.id_permohonan,
        "title": "Detil Pengajuan"
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Pengajuan"
      },
      on: {
        "click": function($event) {
          _vm.confir(bl.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddHeaderFtz_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a25eacea_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddHeaderFtz_vue__ = __webpack_require__(310);
function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a25eacea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddHeaderFtz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a25eacea_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddHeaderFtz_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isian: {
        kdkantor: '020400',
        perjnid: '5',
        perid: '',
        pernama: '',
        peralamat: '',
        ppjkjnid: '',
        ppjkid: '',
        ppjknama: '',
        ppjkalamat: '',
        notelp: '',
        email: '',
        nopermohonan: '',
        tglpermohonan: '',
        jnperijinan: '',
        jnsdok: '',
        username: ''
      },
      disab: false,
      jnijin: [],
      identitas: [],
      tes: this.$store.getters['auth/user']['ppjk']
    };
  },
  created: function created() {
    this.getJnIjin();
    this.getID();
    this.getPerusahaan();
  },

  methods: {
    getID: function getID() {
      var _this = this;

      this.$http.get('ref/kdid').then(function (response) {
        _this.identitas = response.data;
      });
    },
    getJnIjin: function getJnIjin() {
      var _this2 = this;

      this.$http.get('ref/jnijin').then(function (response) {
        _this2.jnijin = response.data;
      });
    },
    getPerusahaan: function getPerusahaan() {
      var _this3 = this;

      var data = {
        user: this.$store.getters['auth/user']['username']
      };
      var ppjk = this.$store.getters['auth/user']['ppjk'];
      if (ppjk === 'Y' || ppjk === 'U') {
        this.disab = false;
      } else {
        this.disab = true;
      }
      this.$http.post('perusahaan', data).then(function (response) {
        _this3.isian.ppjkjnid = response.data.kdid;
        _this3.isian.ppjkid = response.data.idperusahaan;
        _this3.isian.ppjknama = response.data.nmperusahaan;
        _this3.isian.ppjkalamat = response.data.alperusahaan;
        _this3.isian.notelp = response.data.notelp;
        _this3.isian.email = response.data.email;
        _this3.isian.username = response.data.username;

        _this3.isian.perjnid = response.data.kdid;
        _this3.isian.perid = response.data.idperusahaan;
        _this3.isian.pernama = response.data.nmperusahaan;
        _this3.isian.peralamat = response.data.alperusahaan;
      });
    },
    savePermohonan: function savePermohonan() {
      var _this4 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var permohonan = {
            idijin: _this4.isian.jnperijinan,
            nomohon: _this4.isian.nopermohonan,
            tglmohon: _this4.isian.tglpermohonan,
            kdid: _this4.isian.perjnid,
            idper: _this4.isian.perid,
            pernama: _this4.isian.pernama,
            peralamat: _this4.isian.peralamat,
            nohp: _this4.isian.notelp,
            email: _this4.isian.email,
            idrekam: _this4.isian.username,
            jnsdok: _this4.isian.jnsdok
          };
          _this4.$http.post('savepengajuan', permohonan).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
            if (response.data.status === 'success') {
              _this4.$router.push('/pengajuanftz');
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.kdkantor),
      expression: "isian.kdkantor"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.kdkantor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "020400"
    }
  }, [_vm._v("020400 - KPU BC Tipe B Batam")])])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> Pengajuan Izin"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Form Header Perijinan")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Identitas Perijinan")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.perjnid),
      expression: "isian.perjnid"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disab,
      "title": "Identitas perusahaan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.perjnid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.identitas), function(id) {
    return _c('option', {
      key: id.kd_id,
      domProps: {
        "value": id.kd_id
      }
    }, [_vm._v(_vm._s(id.URAIAN))])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Identitas"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Nomor identitas perusahaan",
      "name": "No Identitas",
      "disabled": _vm.disab,
      "type": "text",
      "placeholder": "No Identitas"
    },
    model: {
      value: (_vm.isian.perid),
      callback: function($$v) {
        _vm.isian.perid = $$v
      },
      expression: "isian.perid"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Identitas')),
      expression: "errors.has('No Identitas')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('No Identitas')) + "\n                  ")])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Nama perusahaan",
      "name": "Nama",
      "disabled": _vm.disab,
      "type": "text",
      "placeholder": "Nama"
    },
    model: {
      value: (_vm.isian.pernama),
      callback: function($$v) {
        _vm.isian.pernama = $$v
      },
      expression: "isian.pernama"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama')),
      expression: "errors.has('Nama')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Nama')) + "\n              ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.peralamat),
      expression: "isian.peralamat"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Alamat perusahaan",
      "name": "Alamat",
      "rows": "2",
      "disabled": _vm.disab,
      "placeholder": "Alamat"
    },
    domProps: {
      "value": (_vm.isian.peralamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isian.peralamat = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat')),
      expression: "errors.has('Alamat')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                 " + _vm._s(_vm.errors.first('Alamat')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Permohonan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Nomor Permohonan Izin",
      "name": "No Permohonan",
      "type": "text",
      "placeholder": "No Permohonan"
    },
    model: {
      value: (_vm.isian.nopermohonan),
      callback: function($$v) {
        _vm.isian.nopermohonan = $$v
      },
      expression: "isian.nopermohonan"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Permohonan')),
      expression: "errors.has('No Permohonan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('No Permohonan')) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tgl Permohonan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Tanggal Permohonan Izin",
      "name": "Tgl Permohonan",
      "type": "date"
    },
    model: {
      value: (_vm.isian.tglpermohonan),
      callback: function($$v) {
        _vm.isian.tglpermohonan = $$v
      },
      expression: "isian.tglpermohonan"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tgl Permohonan')),
      expression: "errors.has('Tgl Permohonan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('Tgl Permohonan')) + "\n                  ")])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Perijinan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnperijinan),
      expression: "isian.jnperijinan"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Permohonan Yang Diajukan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnperijinan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Jenis Perijinan --")]), _vm._v(" "), _vm._l((_vm.jnijin), function(ijin) {
    return _c('option', {
      key: ijin.id_ijin,
      domProps: {
        "value": ijin.id_ijin
      }
    }, [_vm._v(_vm._s(ijin.nama_ijin))])
  })], 2)]), _vm._v(" "), (_vm.isian.jnperijinan === 5) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsdok),
      expression: "isian.jnsdok"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen Yang Diajukan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsdok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Dokumen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "23"
    }
  }, [_vm._v("PPFTZ-01")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("PPFTZ-02")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("PPFTZ-03")])])]) : _vm._e(), _vm._v(" "), (_vm.isian.jnperijinan === 23) ? _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen yang akan dibatalkan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.jnsdok),
      expression: "isian.jnsdok"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen Yang Diajukan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.jnsdok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Jenis Dokumen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "167"
    }
  }, [_vm._v("RKSP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Inward Manifes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Outward Manifes")])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Identitas Pemohon Izin")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.ppjkjnid),
      expression: "isian.ppjkjnid"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isian.ppjkjnid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.identitas), function(id) {
    return _c('option', {
      key: id.id_id,
      domProps: {
        "value": id.kd_id
      }
    }, [_vm._v(_vm._s(id.URAIAN))])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No Identitas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true,
      "type": "text",
      "placeholder": "No Identitas"
    },
    model: {
      value: (_vm.isian.ppjkid),
      callback: function($$v) {
        _vm.isian.ppjkid = $$v
      },
      expression: "isian.ppjkid"
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true,
      "type": "text"
    },
    model: {
      value: (_vm.isian.ppjknama),
      callback: function($$v) {
        _vm.isian.ppjknama = $$v
      },
      expression: "isian.ppjknama"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isian.ppjkalamat),
      expression: "isian.ppjkalamat"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.isian.ppjkalamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isian.ppjkalamat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No HP / Telepon"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15|min:3'),
      expression: "'required|max:15|min:3'"
    }],
    attrs: {
      "title": "Nomor HP Yang Dapat Dihubungi",
      "name": "No Telepon",
      "type": "text",
      "placeholder": "No HP / Telepon"
    },
    model: {
      value: (_vm.isian.notelp),
      callback: function($$v) {
        _vm.isian.notelp = $$v
      },
      expression: "isian.notelp"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Telepon')),
      expression: "errors.has('No Telepon')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('No Telepon')) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "title": "Email Yang Dapat Dihubungi",
      "name": "Email",
      "type": "text",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.isian.email),
      callback: function($$v) {
        _vm.isian.email = $$v
      },
      expression: "isian.email"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email')),
      expression: "errors.has('Email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('Email')) + "\n                  ")])], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "title": "Simpan Header Permohonan Izin",
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.savePermohonan
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/pengajuanftz'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" Back")])], 1)])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilHeaderFtz_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc7e7ad4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilHeaderFtz_vue__ = __webpack_require__(314);
function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc7e7ad4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilHeaderFtz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc7e7ad4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilHeaderFtz_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_numeric__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_epic_spinners__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      Modaledit: false,
      Modaleditdtl: false,
      Modaleditdtl1: false,
      ModalDokap: false,
      ModalDisclaimer: false,
      disclaimer: '',
      nmTabel: '',
      nmKolom: '',
      nmPar: '',
      uraian: '',
      nocont: '',
      ukcont: '',
      jmlcont: 0,
      jmlck: 0,
      jmlba: 0,
      cont: [],
      isian: '',
      fileSize: 0,
      fileExt: '',
      fileName: '',
      fileValid: '',
      DataHeader: null,
      dokap_current: '',
      kd_dokap_current: '',
      listdokap: null,
      dokapdtl: [],
      jndokap: [],
      jnPelln: [],
      jnNegara: [],
      user: [],
      suggestionAttribute: 'original_title',
      isidokap: {
        jndok: '',
        isian1: '',
        isian2: '',
        akhirberlaku: '',
        keterangan: '',
        file: '',
        negara: '-'
      },
      idijin: '',
      field: {
        isi1: '',
        tipe1: '',
        isi2: '',
        tipe2: '',
        expire: '',
        kolom1: '',
        kolom2: '',
        tabel_ref: '',
        fl_file: ''
      },
      edit: {
        idperdokap: '',
        idpermohonan: '',
        isian1: '',
        isian2: '',
        akhirberlaku: '',
        keterangan: '',
        file: '',
        pelln: '',
        negara: '-',
        fileSize: '',
        fl_file: ''
      },
      pdf: {
        show: true,
        pdfList: ['', 'http://localhost/backper/public/file/dokap/20171212/9oAFswM38T3ZnNW9.pdf'],
        src: '',
        loadedRatio: 0,
        page: 1,
        numPages: 0,
        rotate: 0
      }
    };
  },
  created: function created() {
    this.getHeader();
    this.getDokap();
    this.getJnDokap();
    this.getNegara();
    this.edit.negara = '-';
  },

  methods: {
    addRow: function addRow() {
      var _this = this;

      if (this.cont.length >= this.jmlcont) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('error', 'isian tidak boleh lebih dari ' + this.jmlcont, 'error');
      } else {
        this.$validator.validateAll().then(function (result) {
          if (result) {
            _this.cont.push({
              isian1: _this.nocont,
              isian2: _this.ukcont
            });
            _this.cont = _this.cont;
          }
        });
      }
    },
    hapusrow: function hapusrow(index) {
      this.cont.splice(index, 1);
      this.cont = this.cont;
    },
    cekkirim: function cekkirim() {
      this.ModalDisclaimer = true;
    },
    kirim: function kirim() {
      var _this2 = this;

      if (this.disclaimer === 'Y') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()({
          title: 'Kirim data',
          text: 'Anda yakin akan mengirim data ini?',
          icon: 'warning',
          buttons: {
            cancel: 'Cancel',
            Yes: 'Yes'
          }
        }).then(function (value) {
          switch (value) {
            case 'Yes':
              var data = {
                user: _this2.$store.getters['auth/user']['username'],
                idmohon: _this2.$route.params.idmohon
              };
              _this2.$http.post('kirim', data).then(function (response) {
                if (response.data.hasil) {
                  var mail = {
                    page: 'kirim',
                    idmohon: _this2.$route.params.idmohon
                  };
                  _this2.$http.post('bc/mail/sendmail', mail);
                  var mail1 = {
                    page: 'petugas',
                    idmohon: _this2.$route.params.idmohon
                  };
                  _this2.$http.post('bc/mail/sendmail', mail1);
                }
                __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
                _this2.$router.push('/pengajuanftz');
              });
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('Kirim Data', 'Pengiriman data tidak berhasil, disclaimer belum diisi...!!!', 'error');
      }
    },
    savedokapdtl: function savedokapdtl() {
      var _this3 = this;

      if (this.jmlcont <= this.cont.length) {
        var data = {
          idrekam: this.$store.getters['auth/user']['username'],
          id_permohonan_dokap: this.dokap_current,
          cont: this.cont
        };
        this.$http.post('savedokapdtl', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this3.Modaleditdtl = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('error', 'isian tidak sama dengan jumlah', 'error');
      }
    },
    savedokapdtl1: function savedokapdtl1() {
      var _this4 = this;

      if (this.cekFile()) {
        var data = {
          id_dokap: this.dokap_current,
          kd_dokap: this.kd_dokap_current,
          isian1: this.nocont,
          isian2: this.ukcont,
          file: this.isidokap.file,
          idrekam: this.user.user,
          ext: this.fileExt
        };
        this.$http.post('savedokapdtl1', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this4.ResetField();
          _this4.Reset();
          _this4.getDokapdtl();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('Gagal simpan data', this.fileValid, 'error');
      }
    },
    fileChanged: function fileChanged(e) {
      var _this5 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      this.fileSize = e.target.files[0].size / 1024;
      this.fileExt = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      this.fileName = e.target.files[0].name;
      fileReader.onload = function (e) {
        _this5.isidokap.file = e.target.result;
        _this5.edit.file = e.target.result;
        _this5.$Progress.finish();
      };
    },
    fileChangeddtl: function fileChangeddtl(e) {
      var _this6 = this;

      this.$Progress.start();
      var fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      this.fileSize = e.target.files[0].size / 1024;
      this.fileExt = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      this.fileName = e.target.files[0].name;
      fileReader.onload = function (e) {
        _this6.isidokap.file = e.target.result;
        _this6.edit.file = e.target.result;
        _this6.$Progress.finish();
      };
    },
    cekFile: function cekFile() {
      var hasil = true;
      if (this.fileSize > 0) {
        this.fileValid = 'File ' + this.fileName;
        if (this.fileSize > 800) {
          this.fileValid = this.fileValid + ' berukuran ' + Math.round(this.fileSize * 100) / 100 + ' Kb, max. 800 Kb. ' + '\n\r';
          hasil = false;
        }
      }
      return hasil;
    },
    getDtlDokap: function getDtlDokap(iddokap) {
      var _this7 = this;

      this.$http.get('ref/jndokap/' + iddokap).then(function (response) {
        _this7.field.isi1 = response.data.isian1;
        _this7.field.tipe1 = response.data.tipe1;
        _this7.field.maxchar1 = response.data.maxchar1;
        _this7.field.isi2 = response.data.isian2;
        _this7.field.maxchar2 = response.data.maxchar2;
        _this7.field.tipe2 = response.data.tipe2;
        _this7.field.expire = response.data.expire;
        _this7.field.tabel_ref = response.data.tabel_ref;
        _this7.field.kolom1 = response.data.kolom1;
        _this7.field.kolom2 = response.data.kolom2;
        _this7.field.fl_file = response.data.fl_file;
        if (_this7.field.tabel_ref === 'referensi.tr_pelln' || _this7.field.tabel_ref === 'referensi.tr_pelabuhan') {} else {
          _this7.referensiDokap();
        }
      });
    },
    getJnDokap: function getJnDokap() {
      var _this8 = this;

      this.$http.get('ref/jndokap').then(function (response) {
        _this8.jndokap = response.data;
      });
    },
    getHeader: function getHeader() {
      var _this9 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        idmohon: this.$route.params.idmohon
      };
      this.user = data;
      this.$http.post('dtlheader', data).then(function (response) {
        _this9.DataHeader = response.data;
        _this9.idijin = response.data.id_ijin;
      });
    },
    getDokap: function getDokap() {
      var _this10 = this;

      var idijinn = {
        user: this.$store.getters['auth/user']['username'],
        idijin: this.$route.params.idmohon
      };
      this.$http.post('dokap', idijinn).then(function (response) {
        _this10.listdokap = response.data;
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].kd_dokap === 151) {
            _this10.jmlcont = response.data[i].isian1;
          } else if (response.data[i].kd_dokap === 145) {
            _this10.jmlck = response.data[i].isian1;
          } else if (response.data[i].kd_dokap === 146) {
            _this10.jmlba = response.data[i].isian1;
          }
        }
      });
    },
    getDokapdtl: function getDokapdtl() {
      var _this11 = this;

      var iddokap = {
        iddokap: this.dokap_current
      };
      this.$http.post('dokapdtl', iddokap).then(function (response) {
        _this11.cont = response.data;
      });
    },
    referensiDokap: function referensiDokap() {
      var _this12 = this;

      var neg = '';
      if (this.ModalDokap === true) {
        neg = this.isidokap.negara;
      } else {
        neg = this.edit.negara;
      }
      this.$http.get('ref/referensiDokap/' + this.field.tabel_ref + '/' + this.field.kolom1 + '/' + this.field.kolom2 + '/' + neg).then(function (response) {
        _this12.jnPelln = response.data;
      });
    },
    referensiDokapDtl: function referensiDokapDtl(tabel, kolom1, kolom2, par) {
      var _this13 = this;

      if (tabel !== null) {
        this.$http.get('ref/referensiDokapDtl/' + tabel + '/' + kolom1 + '/' + kolom2 + '/' + par).then(function (response) {
          _this13.uraian = response.data.nm_lokasi;
        });
      } else {
        this.uraian = '';
      }
      return this.uraian;
    },
    getNegara: function getNegara() {
      var _this14 = this;

      this.$http.get('ref/referensiDokap/referensi.tr_negara/id_negara/nm_negara/-').then(function (response) {
        _this14.jnNegara = response.data;
      });
    },
    addModal: function addModal() {
      this.ModalDokap = true;
      this.Reset();
    },
    opendtl: function opendtl(id, kd) {
      if (kd === 151) {
        this.Modaleditdtl = true;
        this.dokap_current = id;
        this.getDokapdtl();
      } else if (kd === 145 || kd === 146) {
        this.Modaleditdtl1 = true;
        this.dokap_current = id;
        this.kd_dokap_current = kd;
        this.getDokapdtl();
        this.getDtlDokap(kd);
      }
    },
    editDokap: function editDokap(id) {
      var _this15 = this;

      this.ResetField();
      this.Modaledit = true;
      var iddokap = {
        id: id
      };
      this.$http.post('geteditDokap', iddokap).then(function (response) {
        _this15.edit.idperdokap = response.data.id_permohonan_dokap;
        _this15.edit.idpermohonan = response.data.id_permohonan;
        _this15.edit.jndok = response.data.kd_dokap;
        _this15.edit.isian1 = response.data.isian1;
        _this15.edit.isian2 = response.data.isian2;
        _this15.edit.akhirberlaku = response.data.akhir_berlaku;
        _this15.edit.keterangan = response.data.keterangan;
        _this15.edit.fl_file = response.data.fl_file;
        _this15.getDtlDokap(response.data.kd_dokap);
      });
      this.Reset();
    },
    Reset: function Reset() {
      this.isidokap.jndok = null;
      this.isidokap.isian1 = null;
      this.isidokap.isian2 = null;
      this.isidokap.akhirberlaku = null;
      this.isidokap.keterangan = null;
      this.isidokap.file = null;
      this.field.isi1 = null;
      this.field.tipe1 = null;
      this.field.isi2 = null;
      this.field.tipe2 = null;
      this.field.expire = null;
      this.field.tabel_ref = null;
      this.field.kolom1 = null;
      this.field.kolom2 = null;
      this.field.fl_file = null;
      this.jnPelln = [];
      this.nocont = null;
      this.ukcont = null;
    },
    ResetField: function ResetField() {
      this.field.isi1 = null;
      this.field.tipe1 = null;
      this.field.isi2 = null;
      this.field.tipe2 = null;
      this.field.expire = null;
      this.field.tabel_ref = null;
      this.field.kolom1 = null;
      this.field.kolom2 = null;
      this.field.fl_file = null;
      this.isidokap.negara = '-';
      this.isidokap.file = null;
      this.edit.negara = '-';
      this.jnPelln = [];
      this.cont = null;
      this.ukuran = null;
    },
    updateDokap: function updateDokap() {
      var _this16 = this;

      if (this.cekFile()) {
        if (this.edit.isian1 === null) {
          this.edit.isian1 = this.edit.negara;
        }
        var data = {
          id_permohonan_dokap: this.edit.idperdokap,
          id_permohonan: this.edit.idpermohonan,
          kd_dokap: this.edit.jndok,
          isian1: this.edit.isian1,
          isian2: this.edit.isian2,
          akhirberlaku: this.edit.akhirberlaku,
          keterangan: this.edit.keterangan,
          file: this.edit.fl_file === 'Y' ? this.edit.file : null,
          idrekam: this.user.user,
          ext: this.fileExt
        };
        this.$http.post('updateDokap', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this16.getDokap();
          _this16.getHeader();
          _this16.saveDokapMasterEdit();
          _this16.ResetField();
          _this16.Modaledit = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('Gagal simpan data', this.fileValid, 'error');
      }
    },
    saveDokap: function saveDokap() {
      var _this17 = this;

      if (this.cekFile()) {
        if (this.isidokap.isian1 === null) {
          this.isidokap.isian1 = this.isidokap.negara;
        }
        var data = {
          id_permohonan: this.DataHeader.id_permohonan,
          kd_dokap: this.isidokap.jndok,
          isian1: this.isidokap.isian1,
          isian2: this.isidokap.isian2,
          akhirberlaku: this.isidokap.akhirberlaku,
          keterangan: this.isidokap.keterangan,
          file: this.field.fl_file === 'Y' ? this.isidokap.file : null,
          idrekam: this.user.user,
          ext: this.fileExt
        };
        this.$http.post('savedokap', data).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
          _this17.getDokap();
          _this17.saveDokapMasterAdd();
          _this17.ResetField();
          _this17.ModalDokap = false;
          _this17.onReset();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('Gagal simpan data', this.fileValid, 'error');
      }
    },
    saveDokapMasterAdd: function saveDokapMasterAdd() {
      if (this.isidokap.isian1 === null) {
        this.isidokap.isian1 = this.isidokap.negara;
      }
      var data = {
        kd_dokap: this.isidokap.jndok,
        nomor: this.isidokap.isian1,
        tanggal: this.isidokap.isian2,
        akhirberlaku: this.isidokap.akhirberlaku,
        keterangan: this.isidokap.keterangan,
        file: this.isidokap.file,
        idrekam: this.user.user,
        ext: this.fileExt
      };
      this.$http.post('saveDokapMaster', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
      });
    },
    saveDokapMasterEdit: function saveDokapMasterEdit() {
      if (this.edit.isian1 === null) {
        this.edit.isian1 = this.edit.negara;
      }
      var data = {
        kd_dokap: this.edit.jndok,
        nomor: this.edit.isian1,
        tanggal: this.edit.isian2,
        akhirberlaku: this.edit.akhirberlaku,
        keterangan: this.edit.keterangan,
        file: this.edit.file,
        idrekam: this.user.user,
        ext: this.fileExt
      };
      this.$http.post('saveDokapMaster', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
      });
    },
    confir: function confir(iddel) {
      var _this18 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()({
        title: 'Hapus dokumen pelengkap',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this18.deleteDokap(iddel);
        }
      });
    },
    confirmdtl: function confirmdtl(iddel) {
      var _this19 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()({
        title: 'Hapus dokumen pelengkap',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this19.deleteDokapdtl(iddel);
        }
      });
    },
    deleteDokap: function deleteDokap(id) {
      var _this20 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      };
      this.$http.post('deleteDokap', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this20.getDokapdtl();
        _this20.getHeader();
        _this20.ResetField();
      });
    },
    deleteDokapdtl: function deleteDokapdtl(id) {
      var _this21 = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      };
      this.$http.post('deleteDokapdtl', data).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.status);
        _this21.getDokapdtl();
        _this21.getHeader();
        _this21.ResetField();
        _this21.Reset();
      });
    }
  },
  components: {
    VueNumeric: __WEBPACK_IMPORTED_MODULE_1_vue_numeric___default.a,
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_2_epic_spinners__["a" /* HalfCircleSpinner */]
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan"
    }
  }, [(!_vm.DataHeader || !_vm.listdokap) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.DataHeader && _vm.listdokap) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.DataHeader.status === '10') ? _c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cekkirim
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("\n                Kirim")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Pengajuan Izin"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.DataHeader.URAIAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.npwp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.NM_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.AL_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No HP/Telepon")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_hp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kantor")]), _vm._v(" "), _c('td', [_vm._v("020400 - KPU BC Tipe B Batam")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Tanggal Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Jenis Permohonan Izin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.nama_ijin))])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                  Lampiran Dokumen / Data\n                  "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "title": "Tambah Dokumen/Data Pelengkap",
      "type": "button"
    },
    on: {
      "click": _vm.addModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Dokap")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokap), function(dokap) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dokap.nama_dokap))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokap.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-md-block"
    }, [_vm._v(_vm._s(dokap.keterangan))]), _vm._v(" "), _c('td', [(dokap.url_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": dokap.url_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editDokap(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), (dokap.kd_dokap === 151) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (dokap.kd_dokap === 145 || dokap.kd_dokap === 146) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (dokap.fl_mandatory === null) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Dokumen/Data Pelengkap"
      },
      on: {
        "click": function($event) {
          _vm.confir(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/pengajuanftz'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v("\n              Back")])], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Tambah Dokumen Pelengkap"
    },
    on: {
      "ok": function($event) {
        _vm.ModalDokap = false
      }
    },
    model: {
      value: (_vm.ModalDokap),
      callback: function($$v) {
        _vm.ModalDokap = $$v
      },
      expression: "ModalDokap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen Pelengkap"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.jndok),
      expression: "isidokap.jndok"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pilih Jenis Dokumen/Data Pelengkap"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.jndok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Dokumen/Data")]), _vm._v(" "), _vm._l((_vm.jndokap), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.kd_dokap
      },
      on: {
        "click": function($event) {
          _vm.getDtlDokap(jn.kd_dokap)
        }
      }
    }, [_vm._v(_vm._s(jn.nama_dokap) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [(_vm.field.tabel_ref === 'referensi.tr_pelln' || _vm.field.tabel_ref === 'referensi.tr_pelabuhan') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.negara),
      expression: "isidokap.negara"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pilih Negara"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.negara = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Negara")]), _vm._v(" "), _vm._l((_vm.jnNegara), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      },
      on: {
        "click": function($event) {
          _vm.referensiDokap()
        }
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tabel_ref !== null) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: "isidokap.isian1"
    }],
    attrs: {
      "title": "Pilih Data Pelengkap",
      "lass": "form-control"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.isian1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Data")]), _vm._v(" "), _vm._l((_vm.jnPelln), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'date' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: "isidokap.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "date"
    },
    domProps: {
      "value": (_vm.isidokap.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'text' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: "isidokap.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'number' && _vm.field.tabel_ref === null) ? _c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "separator": ".",
      "precision": 2
    },
    model: {
      value: (_vm.isidokap.isian1),
      callback: function($$v) {
        _vm.isidokap.isian1 = $$v
      },
      expression: "isidokap.isian1"
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('This')),
      expression: "errors.has('This')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('This')) + "\n          ")])], 1), _vm._v(" "), (_vm.field.tipe2 === 'text') ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: "'required|field'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian2),
      expression: "isidokap.isian2"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "Isi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Isi')),
      expression: "errors.has('Isi')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Isi')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.tipe2 === 'Date') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: "'required|field'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian2),
      expression: "isidokap.isian2"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tanggal",
      "type": "date"
    },
    domProps: {
      "value": (_vm.isidokap.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal')),
      expression: "errors.has('Tanggal')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Tanggal')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.expire === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Akhir Berlaku"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: "'required|field'"
    }],
    attrs: {
      "title": "Akhir Berlaku Dokumen/Data",
      "name": "Akhir Berlaku",
      "type": "date"
    },
    model: {
      value: (_vm.edit.akhirberlaku),
      callback: function($$v) {
        _vm.edit.akhirberlaku = $$v
      },
      expression: "edit.akhirberlaku"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Akhir Berlaku')),
      expression: "errors.has('Akhir Berlaku')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Akhir Berlaku')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.keterangan),
      expression: "isidokap.keterangan"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Keterangan Terkait Dokumen/Data",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.keterangan = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.field.fl_file === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Upload File (Max. 800 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDokap()
      }
    }
  }, [_vm._v("Save")])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap"
    },
    on: {
      "ok": function($event) {
        _vm.Modaledit = false
      }
    },
    model: {
      value: (_vm.Modaledit),
      callback: function($$v) {
        _vm.Modaledit = $$v
      },
      expression: "Modaledit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Edit Dokumen Pelengkap"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.jndok),
      expression: "edit.jndok"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen/Data",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.edit.jndok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jndokap), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.kd_dokap
      },
      on: {
        "click": function($event) {
          _vm.getDtlDokap(jn.kd_dokap)
        }
      }
    }, [_vm._v(_vm._s(jn.nama_dokap) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [(_vm.field.tabel_ref === 'referensi.tr_pelln' || _vm.field.tabel_ref === 'referensi.tr_pelabuhan') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.negara),
      expression: "edit.negara"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pilih Kode Negara"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.edit.negara = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Negara")]), _vm._v(" "), _vm._l((_vm.jnNegara), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      },
      on: {
        "click": function($event) {
          _vm.referensiDokap()
        }
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tabel_ref !== null) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: "edit.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.edit.isian1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jnPelln), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      },
      on: {
        "click": function($event) {
          _vm.edit.keterangan = jn.nm_lokasi
        }
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'date' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: "edit.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "This",
      "type": "date"
    },
    domProps: {
      "value": (_vm.edit.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'text' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: "edit.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": _vm.field.maxchar1,
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'number' && _vm.field.tabel_ref === null) ? _c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "separator": ".",
      "precision": 2
    },
    model: {
      value: (_vm.edit.isian1),
      callback: function($$v) {
        _vm.edit.isian1 = $$v
      },
      expression: "edit.isian1"
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('This')),
      expression: "errors.has('This')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('This')) + "\n          ")])], 1), _vm._v(" "), (_vm.field.tipe2 === 'text') ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi2
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian2),
      expression: "edit.isian2"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": _vm.field.maxchar2,
      "title": "Nomor/Kode Dokumen/Data",
      "name": "Isi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Isi')),
      expression: "errors.has('Isi')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Isi')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.tipe2 === 'Date') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian2),
      expression: "edit.isian2"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "Tanggal",
      "type": "date"
    },
    domProps: {
      "value": (_vm.edit.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal')),
      expression: "errors.has('Tanggal')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Tanggal')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.expire === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Akhir Berlaku"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Akhir Berlaku Dokumen/Data",
      "name": "Akhir Berlaku",
      "type": "date"
    },
    model: {
      value: (_vm.edit.akhirberlaku),
      callback: function($$v) {
        _vm.edit.akhirberlaku = $$v
      },
      expression: "edit.akhirberlaku"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.keterangan),
      expression: "edit.keterangan"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Keterangan Dokumen/Data",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.keterangan = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.field.fl_file === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "title": "Upload Dokumen",
      "label": "Upload File (Max. 700 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "title": "Upload Dokumen",
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateDokap()
      }
    }
  }, [_vm._v("Save")])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "size": "medium"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl),
      callback: function($$v) {
        _vm.Modaleditdtl = $$v
      },
      expression: "Modaleditdtl"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Peti Kemas"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nocont),
      expression: "nocont"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "11",
      "title": "Nomor Peti Kemas",
      "name": "petikemas"
    },
    domProps: {
      "value": (_vm.nocont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nocont = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('petikemas')),
      expression: "errors.has('petikemas')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            Nomor Peti Kemas wajib diisi\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Ukuran"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        numeric: true
      }),
      expression: "{ required: true, numeric: true }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ukcont),
      expression: "ukcont"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "2",
      "title": "Nomor Peti Kemas",
      "name": "ukuran"
    },
    domProps: {
      "value": (_vm.ukcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ukcont = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ukuran')),
      expression: "errors.has('ukuran')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            Wajib diisi dan berisi angka\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "<br>"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Tambah",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addRow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n            Tambah")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor Peti Kemas")]), _vm._v(" "), _c('th', [_vm._v("Ukuran")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.hapusrow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.Modaleditdtl = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v("  \n      "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.savedokapdtl
    }
  }, [_vm._v("Simpan")])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl1 = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl1),
      callback: function($$v) {
        _vm.Modaleditdtl1 = $$v
      },
      expression: "Modaleditdtl1"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nocont),
      expression: "nocont"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor",
      "name": ""
    },
    domProps: {
      "value": (_vm.nocont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nocont = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ukcont),
      expression: "ukcont"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "title": "Nomor Peti Kemas",
      "name": ""
    },
    domProps: {
      "value": (_vm.ukcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ukcont = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload File (Max. 800 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Tambah Dokumen",
      "type": "button"
    },
    on: {
      "click": _vm.savedokapdtl1
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Dokumen")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))]), _vm._v(" "), _c('td', [(peti.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": _vm.$http.options.base + peti.url_file + '/' + peti.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmdtl(peti.id_permohonan_dokap_dtl)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Persetujuan"
    },
    on: {
      "ok": function($event) {
        _vm.ModalDisclaimer = false
      }
    },
    model: {
      value: (_vm.ModalDisclaimer),
      callback: function($$v) {
        _vm.ModalDisclaimer = $$v
      },
      expression: "ModalDisclaimer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', [_c('b-form-checkbox', {
    attrs: {
      "value": "Y",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.disclaimer),
      callback: function($$v) {
        _vm.disclaimer = $$v
      },
      expression: "disclaimer"
    }
  }, [_vm._v("\n            Saya menyatakan bahwa data yang disampaikan adalah benar\n            dan saya bertanggungjawab atas kebenaran data/dokumen yang disampaikan\n          ")]), _vm._v(" "), (_vm.disclaimer === 'Y') ? _c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.kirim
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Kirim")])]) : _vm._e()], 1)], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilBrowsFtz_vue__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e6b45a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilBrowsFtz_vue__ = __webpack_require__(318);
function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01e6b45a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilBrowsFtz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e6b45a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilBrowsFtz_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* HalfCircleSpinner */] },
  data: function data() {
    return {
      Modaleditdtl: false,
      DataHeader: null,
      listdokap: null,
      listdokapptg: null,
      idijin: '',
      cont: [],
      dokap_current: ''
    };
  },
  created: function created() {
    this.getHeader();
    this.getDokap();
    this.getDokapptg();
  },

  methods: {
    getHeader: function getHeader() {
      var _this = this;

      var data = {
        user: this.$store.getters['auth/user']['username'],
        idmohon: this.$route.params.idmohon
      };
      this.$http.post('dtlheader', data).then(function (response) {
        _this.DataHeader = response.data;
        _this.idijin = response.data.id_ijin;
        _this.getDokap(response.data.id_ijin);
      });
    },
    getDokap: function getDokap() {
      var _this2 = this;

      var idijinn = {
        user: this.$store.getters['auth/user']['username'],
        idijin: this.$route.params.idmohon
      };
      this.$http.post('dokap', idijinn).then(function (response) {
        _this2.listdokap = response.data;
      });
    },
    getDokapdtl: function getDokapdtl() {
      var _this3 = this;

      var iddokap = {
        iddokap: this.dokap_current
      };
      this.$http.post('dokapdtl', iddokap).then(function (response) {
        _this3.cont = response.data;
      });
    },
    addModal: function addModal() {
      this.ModalDokap = true;
      this.Reset();
    },
    dlDokap: function dlDokap(id) {
      var dokap = {
        idrekam: this.DataHeader.nip_rekam,
        iddokap: id
      };
      this.$http.post('dlDokap', dokap);
    },
    opendtl: function opendtl(id) {
      this.Modaleditdtl = true;
      this.dokap_current = id;
      this.getDokapdtl();
    },
    getDokapptg: function getDokapptg() {
      var _this4 = this;

      var idijinn = {
        idijin: this.$route.params.idmohon
      };
      this.$http.post('bc/petugas/approvedokapptg', idijinn).then(function (response) {
        _this4.listdokapptg = response.data;
      });
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan tes"
    }
  }, [(!_vm.DataHeader || !_vm.listdokap) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.DataHeader && _vm.listdokap) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Pengajuan Izin"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.DataHeader.URAIAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.npwp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.NM_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.AL_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No HP/Telepon")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_hp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Jenis Permohonan Izin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.nama_ijin))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.ur_status))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("No Setuju")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_setuju))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tgl Setuju")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_setuju))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kantor")]), _vm._v(" "), _c('td', [_vm._v("020400 - KPU BC Tipe B Batam")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Tanggal Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_mohon))])])])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                  Lampiran Dokumen\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokap), function(dokap) {
    return _c('tr', {
      key: dokap.id_permohonan_dokap
    }, [_c('td', [_vm._v(_vm._s(dokap.nama_dokap))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokap.keterangan))]), _vm._v(" "), _c('td', [(dokap.kd_dokap === 151) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]) : _vm._e(), _vm._v(" "), (dokap.url_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "href": dokap.url_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokapptg), function(dokapptg) {
    return _c('tr', {
      key: dokapptg.id_permohonan_dokap
    }, [_c('td', [_vm._v(_vm._s(dokapptg.nama_dokap))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokapptg.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokapptg.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-md-block"
    }, [_vm._v(_vm._s(dokapptg.keterangan))]), _vm._v(" "), _c('td', [(dokapptg.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": _vm.$http.options.base + dokapptg.url_file + '/' + dokapptg.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), (dokapptg.fl_mandatory === null) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Dokumen/Data Pelengkap"
      },
      on: {
        "click": function($event) {
          _vm.confir(dokapptg.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/browseftz'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" Back\n            ")])], 1)])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Detail Dokumen Pelengkap",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl),
      callback: function($$v) {
        _vm.Modaleditdtl = $$v
      },
      expression: "Modaleditdtl"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "500px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor Peti Kemas")]), _vm._v(" "), _c('th', [_vm._v("Ukuran")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', {
      key: peti.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))])])
  }))])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listsppbmcp_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bffc070_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_listsppbmcp_vue__ = __webpack_require__(322);
function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bffc070"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listsppbmcp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bffc070_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_listsppbmcp_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ModalCatatan: false,
      user: this.$store.getters['auth/user']['username'],
      npwp: this.$store.getters['auth/user']['npwp'],
      brows: [],
      browsdtl: [],
      catatan: [],
      id_current: '',
      q: '',
      p: '',
      isClicked: '',
      items: [{
        name: 'husni',
        surname: 'muhamad',
        explanation: 'gak ada',
        desc: 'gitu deh'
      }, {
        name: 'husni',
        surname: 'muhamad',
        explanation: 'gak ada',
        desc: 'gitu deh'
      }]
    };
  },
  created: function created() {
    this.getBrows();
  },

  methods: {
    getBrows: function getBrows(page) {
      var _this = this;

      if (typeof page === 'undefined') {
        page = 'sppbmcp/list?page=1';
      }
      var auth = {
        user: this.$store.getters['auth/user']['username'],
        q: this.q,
        p: this.p,
        a: this.a,
        b: this.b,
        npwp: this.npwp
      };
      this.$http.post(page, auth).then(function (response) {
        _this.brows = response.data;
      });
    },
    getDownload: function getDownload(id) {
      var auth = {
        id: id
      };
      this.$http.post('sppbmcp/download', auth, { responseType: 'blob' }).then(function (res) {
        var blob = new Blob([res.data], { type: res.headers['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', 'file.xlsx');

        link.click();
      });
    },
    getBrowsDtl: function getBrowsDtl(id, page) {
      var _this2 = this;

      this.id_current = id;
      if (typeof page === 'undefined') {
        page = 'sppbmcp/listdtl?page=1';
      }
      var auth = {
        id: id
      };
      this.$http.post(page, auth).then(function (response) {
        _this2.browsdtl = response.data;
      });
    },
    setActiveRow: function setActiveRow(index) {
      this.browsdtl = [];
      if (this.isClicked === index) {
        this.isClicked = '';
      } else {
        this.isClicked = index;
        this.getBrowsDtl(index);
      }
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> List Pengajuan Izin"
    }
  }, [_c('form', {
    attrs: {
      "action": "#/sppbmcp/listsppbmcp"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "role": "group"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.q),
      expression: "q"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Pencarian",
      "type": "text"
    },
    domProps: {
      "value": (_vm.q)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.q = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.getBrows()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("NO SPPBMCP Kolektif")]), _vm._v(" "), _c('th', [_vm._v("Tgl. SPPBMCP Kolektif")]), _vm._v(" "), _c('th', [_vm._v("Jumlah CN")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kode Billing")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Tgl. Jatuh Tempo")])])]), _vm._v(" "), _vm._l((_vm.brows.data), function(browse) {
    return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(browse.NO_SPPBMCP_KOL))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.TGL_SPPBMCP_KOL))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.JMLCN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.KD_BILLING))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.TOTAL.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.TGL_JATUH_TEMPO))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline"
    }, [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.getDownload(browse.ID_SPPBMCP)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          _vm.setActiveRow(browse.ID_SPPBMCP)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])])])]), _vm._v(" "), (_vm.isClicked === browse.ID_SPPBMCP) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "7"
      }
    }, [_c('table', {
      attrs: {
        "width": "max"
      }
    }, [_c('tr', [_c('th', [_vm._v("NO Aju")]), _vm._v(" "), _c('th', [_vm._v("NPWP")]), _vm._v(" "), _c('th', [_vm._v("No. SPPBMCP")]), _vm._v(" "), _c('th', [_vm._v("Tgl. SPPBMCP")]), _vm._v(" "), _c('th', [_vm._v("Bea Masuk")]), _vm._v(" "), _c('th', [_vm._v("PPN")]), _vm._v(" "), _c('th', [_vm._v("PPH")]), _vm._v(" "), _c('th', [_vm._v("PPNBM")]), _vm._v(" "), _c('th', [_vm._v("BMTP")]), _vm._v(" "), _c('th', [_vm._v("TOTAL")]), _vm._v(" "), _c('th', [_vm._v("No. Barang")]), _vm._v(" "), _c('th', [_vm._v("Tgl. House BL/AWB")]), _vm._v(" "), _c('th', [_vm._v("Kode Gudang")]), _vm._v(" "), _c('th', [_vm._v("No. Kantong")]), _vm._v(" "), _c('th', [_vm._v("Kode PIBK")])]), _vm._v(" "), _vm._l((_vm.browsdtl.data), function(tes) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(tes.ID_AJU))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.ID_PEMBERITAHU))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.NO_SPPBMCP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TGL_SPPBMCP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_BM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_PPN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_PPH))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_PPNBM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_BMTP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_TAGIHAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.NO_BARANG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TGL_HOUSE_BLAWB))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.KD_GUDANG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.NO_KANTONG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.KD_JNS_PIBK))])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "pagination"
    }, [_c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": !_vm.browsdtl.prev_page_url
      },
      on: {
        "click": function($event) {
          _vm.getBrowsDtl(_vm.id_current, _vm.browsdtl.first_page_url)
        }
      }
    }, [_vm._v("\n                      «\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": !_vm.browsdtl.prev_page_url
      },
      on: {
        "click": function($event) {
          _vm.getBrowsDtl(_vm.id_current, _vm.browsdtl.prev_page_url)
        }
      }
    }, [_vm._v("\n                      ‹\n                    ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.browsdtl.current_page + '/' + _vm.browsdtl.last_page))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": !_vm.browsdtl.next_page_url
      },
      on: {
        "click": function($event) {
          _vm.getBrowsDtl(_vm.id_current, _vm.browsdtl.next_page_url)
        }
      }
    }, [_vm._v("\n                      ›\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": !_vm.browsdtl.next_page_url
      },
      on: {
        "click": function($event) {
          _vm.getBrowsDtl(_vm.id_current, _vm.browsdtl.last_page_url)
        }
      }
    }, [_vm._v("\n                      »\n                    ")])])])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.first_page_url)
      }
    }
  }, [_vm._v("\n            «\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.prev_page_url)
      }
    }
  }, [_vm._v("\n            ‹\n          ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.p),
      expression: "p"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "placeholder": _vm.brows.current_page + '/' + _vm.brows.last_page,
      "type": "text",
      "size": "2"
    },
    domProps: {
      "value": (_vm.p)
    },
    on: {
      "change": function($event) {
        _vm.getBrows('bc/brows/browslist?page=' + _vm.p)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.p = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.next_page_url)
      }
    }
  }, [_vm._v("\n            ›\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.last_page_url)
      }
    }
  }, [_vm._v("\n            »\n          ")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Catatan Petugas",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ModalCatatan = false
      }
    },
    model: {
      value: (_vm.ModalCatatan),
      callback: function($$v) {
        _vm.ModalCatatan = $$v
      },
      expression: "ModalCatatan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead'), _vm._v(" "), _c('tbody')])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addbl_vue__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3d4a5da_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_addbl_vue__ = __webpack_require__(326);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addbl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3d4a5da_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_addbl_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      fullPage: false,
      form: {
        no_bl: '',
        tgl_bl: '',
        npwp: this.$store.getters['auth/user']['npwp'],
        file_bl: '',
        file_ex: '',
        jn_perusahaan: '',
        kd_tujuan: ''
      }
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.isLoading = true;
          _this.$Progress.start();
          _this.$http.post('rekonmanifes/upload', _this.form).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()(response.data.status, response.data.message, response.data.status);
            _this.isLoading = false;
            _this.$Progress.finish();
            _this.$router.push('/rekonmanifes/browse');
          });
        }
      });
    },
    targetFiles: function targetFiles(e) {
      var _this2 = this;

      var fileReader = new FileReader();
      this.form.file_ex = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
      fileReader.readAsDataURL(e.target.files[0]);
      fileReader.onload = function (e) {
        _this2.form.file_bl = e.target.result;
      };
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "vld-parent"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-plus' ></i> Tambah File"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "No. BL/AWB"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'is-invalid': _vm.errors.has('No B/L')
    },
    attrs: {
      "type": "text",
      "name": "No B/L",
      "id": "ccnumber",
      "placeholder": "Nomor BL/AWB"
    },
    model: {
      value: (_vm.form.no_bl),
      callback: function($$v) {
        _vm.form.no_bl = $$v
      },
      expression: "form.no_bl"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No B/L')),
      expression: "errors.has('No B/L')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                      " + _vm._s(_vm.errors.first('No B/L')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal BL/AWB"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'is-invalid': _vm.errors.has('Tanggal B/L')
    },
    attrs: {
      "type": "date",
      "name": "Tanggal B/L",
      "placeholder": "Nomor BL/AWB"
    },
    model: {
      value: (_vm.form.tgl_bl),
      callback: function($$v) {
        _vm.form.tgl_bl = $$v
      },
      expression: "form.tgl_bl"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal B/L')),
      expression: "errors.has('Tanggal B/L')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                      " + _vm._s(_vm.errors.first('Tanggal B/L')) + "\n                    ")])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "file",
      "name": "file"
    },
    on: {
      "change": _vm.targetFiles
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('file')),
      expression: "errors.has('file')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('file')) + "\n              ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": [{
          text: 'Perusahaan Jasa Titipan',
          value: '1'
        },
        {
          text: 'Agen Pengangkut',
          value: '2'
        }
      ],
      "name": "Jenis Perusahaan"
    },
    model: {
      value: (_vm.form.jn_perusahaan),
      callback: function($$v) {
        _vm.form.jn_perusahaan = $$v
      },
      expression: "form.jn_perusahaan"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Perusahaan')),
      expression: "errors.has('Jenis Perusahaan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Jenis Perusahaan')) + "\n              ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": [{
          text: 'Luar Daerah Pabean ke Kawasan Bebas',
          value: '1'
        },
        {
          text: 'Kawasan Bebas ke TLDDP',
          value: '2'
        }
      ],
      "name": "Tujuan"
    },
    model: {
      value: (_vm.form.kd_tujuan),
      callback: function($$v) {
        _vm.form.kd_tujuan = $$v
      },
      expression: "form.kd_tujuan"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tujuan')),
      expression: "errors.has('Tujuan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Tujuan')) + "\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 pl-4"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "md",
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Kirim")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ml-auto pr-4"
  }, [_c('router-link', {
    attrs: {
      "to": "/rekonmanifes/browse"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" Back")])])], 1)])], 1)])]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_browsebl_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7358379c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_browsebl_vue__ = __webpack_require__(329);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_browsebl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7358379c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_browsebl_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchFilter: '',
      pageOfItems: [],
      listBL: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc'
    };
  },

  computed: {
    filteredData: function filteredData() {
      var _this = this;

      return this.listBL.sort(function (a, b) {
        var modifier = 1;
        if (_this.currentSortDir === 'desc') modifier = -1;
        if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
        if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (items) {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(_this.searchFilter.toLowerCase()) !== -1) {
            return true;
          }
        }
        return false;
      });
    }
  },
  mounted: function mounted() {
    this.browse();
  },

  methods: {
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    browse: function browse() {
      var _this2 = this;

      var data = {
        npwp: this.$store.getters['auth/user']['npwp']
      };
      this.$http.post('rekonmanifes/browse', data).then(function (response) {
        _this2.listBL = response.data;
      });
    },
    onChangePage: function onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-magnifier'></i> Browse BL/AWB"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mx-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pencarian"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto pr-3 pb-3"
  }, [_c('router-link', {
    attrs: {
      "to": "/rekonmanifes/add"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button",
      "router": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah File")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_bl')
      }
    }
  }, [_vm._v("Nomor AWB/BL "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_bl')
      }
    }
  }, [_vm._v("Tanggal "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('jn_perusahaan')
      }
    }
  }, [_vm._v("Pengirim "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('jn_perusahaan')
      }
    }
  }, [_vm._v("Jenis Dokumen "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('wk_kirim')
      }
    }
  }, [_vm._v("Waktu Kirim "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(bl) {
    return _c('tr', {
      key: bl.id_rekon_manifes
    }, [_c('td', [_vm._v(_vm._s(bl.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_bl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_bl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.jn_perusahaan == 1 ? 'PJT' : (bl.jn_perusahaan == 2 ? 'Agen Pengangkut' : 'Bea Cukai')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.kd_tujuan == 1 ? 'LDP-KB' : (bl.jn_dokumen == 2 ? 'KB-TLDDP' : '-')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.wk_kirim))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "href": _vm.$http.options.base + bl.file_directory + '/' + bl.file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page404_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727fd970_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_page404_vue__ = __webpack_require__(332);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727fd970_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_page404_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/'
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" Back")])], 1)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('h1', {
    staticClass: "float-left display-3 mr-4"
  }, [_vm._v("404")]), _vm._v(" "), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Oops! You're lost.")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n            The page you are looking for was not found.\n          ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuAju_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f2b59e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MenuAju_vue__ = __webpack_require__(340);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuAju_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f2b59e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MenuAju_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_ModalAju_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_ModalCatatan_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalAju: __WEBPACK_IMPORTED_MODULE_2__modal_ModalAju_vue__["a" /* default */], ModalCatatan: __WEBPACK_IMPORTED_MODULE_3__modal_ModalCatatan_vue__["a" /* default */]
  },
  data: function data() {
    return {
      aju: []
    };
  },
  created: function created() {
    this.getPpftz();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getCatatan: 'barpin/getCatatan',
    removeData: 'barpin/removeData'
  }), {
    getPpftz: function getPpftz() {
      var _this = this;

      this.$store.commit('barpin/SET_LOADING', true);
      this.$http.get('ppftz/perekaman').then(function (response) {
        _this.aju = response.data;
        _this.$store.commit('barpin/SET_LOADING', false);
      });
    },
    removePpftz: function removePpftz(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Hapus aju ini?',
        text: 'Anda yakin akan menghapus nomor aju ini?',
        icon: 'error',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this2.removeData({ id: id }).then(function () {
              __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('success', 'berhasil menghapus dokumen', 'success');
              _this2.getPpftz();
            });
        }
      });
    }
  })
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAju_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edae08a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAju_vue__ = __webpack_require__(337);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAju_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edae08a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAju_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_search_select__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ModelListSelect: __WEBPACK_IMPORTED_MODULE_3_vue_search_select__["ModelListSelect"] },
  data: function data() {
    return {
      jenis_aju: '',
      nama_penerima: this.$store.state.auth.user.NM_PERUSAHAAN,
      jenis_identitas_penerima: this.$store.state.auth.user.kdid,
      no_identitas_penerima: this.$store.state.auth.user.npwp,
      ref_identitas: [{ kd_id: '2', URAIAN: 'KTP' }, { kd_id: '3', URAIAN: 'Paspor' }, { kd_id: '4', URAIAN: 'Lainnya' }, { kd_id: '5', URAIAN: 'NPWP 16 Digit' }]
    };
  },

  methods: {
    addAju: function addAju() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var data = {
            jns_aju: _this.jenis_aju,
            nama_penerima: _this.nama_penerima,
            jenis_identitas_penerima: _this.jenis_identitas_penerima,
            no_identitas_penerima: _this.no_identitas_penerima
          };
          _this.$store.commit('barpin/SET_LOADING_MODAL', true);
          _this.$http.post('ppftz', data).then(function (response) {
            _this.$store.commit('barpin/SET_LOADING_MODAL', false);
            _this.$refs['modalAju'].hide();
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('success', 'Berhasil membuat aju baru', 'success').then(function () {
              _this.$router.push('perekaman/' + response.data);
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', JSON.parse(error.bodyText).message, 'error');
            _this.$store.commit('barpin/SET_LOADING_MODAL', false);
          });
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    authenticated: 'auth/authenticated',
    user: 'auth/user'
  }))
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalAju",
    attrs: {
      "id": "modal-aju",
      "title": "Aju Baru",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addAju($event)
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Aju"
    }
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jenis Aju') ? 'is-invalid' : '',
    attrs: {
      "name": "Jenis Aju",
      "options": [{
          text: 'Jenis Pengajuan',
          value: ''
        },
        {
          text: 'Barang Pindahan',
          value: 1
        },
        {
          text: 'Kendaraan Bermotor',
          value: 2
        }
      ]
    },
    model: {
      value: (_vm.jenis_aju),
      callback: function($$v) {
        _vm.jenis_aju = $$v
      },
      expression: "jenis_aju"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Aju')),
      expression: "errors.has('Jenis Aju')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Aju')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama Pemohon"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Nama Pemohon') ? 'is-invalid' : '',
    attrs: {
      "name": "Nama Pemohon",
      "type": "text"
    },
    model: {
      value: (_vm.nama_penerima),
      callback: function($$v) {
        _vm.nama_penerima = $$v
      },
      expression: "nama_penerima"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Pemohon')),
      expression: "errors.has('Nama Pemohon')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nama Pemohon')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Identitas') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.ref_identitas,
      "option-value": "kd_id",
      "option-text": "URAIAN",
      "name": "Jenis Identitas",
      "placeholder": "Jenis Identitas"
    },
    model: {
      value: (_vm.jenis_identitas_penerima),
      callback: function($$v) {
        _vm.jenis_identitas_penerima = $$v
      },
      expression: "jenis_identitas_penerima"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Identitas')),
      expression: "errors.has('Jenis Identitas')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Identitas')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.jenis_identitas_penerima === '5' ? 'required|min:16' : 'required'),
      expression: " jenis_identitas_penerima === '5' ? 'required|min:16' : 'required' "
    }],
    class: _vm.errors.has('Nomor Identitas') ? 'is-invalid' : '',
    attrs: {
      "name": "Nomor Identitas",
      "type": "text"
    },
    model: {
      value: (_vm.no_identitas_penerima),
      callback: function($$v) {
        _vm.no_identitas_penerima = $$v
      },
      expression: "no_identitas_penerima"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas')),
      expression: "errors.has('Nomor Identitas')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas')))])], 1), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Buat Aju\n      ")])], {
    id: "footer"
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalCatatan",
    attrs: {
      "id": "modal-catatan",
      "title": "History Keputusan",
      "variant": "primary",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-esc": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Petugas")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Keputusan")]), _vm._v(" "), _c('th', [_vm._v("Waktu Mulai")]), _vm._v(" "), _c('th', [_vm._v("Waktu Selesai")]), _vm._v(" "), _c('th', [_vm._v("Catatan")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.state.barpin.catatan), function(listCatatan) {
    return _c('tr', {
      key: listCatatan.WK_MULAI
    }, [_c('td', [_vm._v(_vm._s(listCatatan.nama_petugas == null ? '' : listCatatan.nama_petugas.NAMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.status_name.ur_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.FL_KEPUTUSAN === 'Y' ? 'Setuju' : (listCatatan.FL_KEPUTUSAN === 'T' ? 'Ditolak' : listCatatan.FL_KEPUTUSAN === 'X' ? 'Ditolak' :
      listCatatan.FL_KEPUTUSAN)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.WK_MULAI))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.WK_SELESAI))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.KETERANGAN))])])
  }))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header": "Perekaman Aju"
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-aju",
      modifiers: {
        "modal-aju": true
      }
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Aju Baru\n        ")])])])]), _vm._v(" "), _c('modal-aju', {
    ref: "modalAju"
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No. Aju")]), _vm._v(" "), _c('th', [_vm._v("Nama")]), _vm._v(" "), _c('th', [_vm._v("Jenis Ajuan")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.aju), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.NO_AJU))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NAMA_PENERIMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.JNS_AJU == '1' ? 'Barang Pindahan' : 'Kendaraan Bermotor'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status == null ? '' : data.status.ur_status))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "40"
      }
    }, [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": ("perekaman/" + (data.NO_AJU))
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-catatan",
        modifiers: {
          "modal-catatan": true
        }
      }],
      attrs: {
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.getCatatan(data.ID_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bars"
    })]), _vm._v(" "), (data.KD_STATUS == '100') ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removePpftz(data.ID_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1)])
  }))])]), _vm._v(" "), _c('modal-catatan')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Perekaman_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7e9b500_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Perekaman_vue__ = __webpack_require__(370);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Perekaman_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7e9b500_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Perekaman_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__perekaman_Step_1__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Perekaman_Step_2__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Perekaman_Step_3__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Step1: __WEBPACK_IMPORTED_MODULE_1__perekaman_Step_1__["a" /* default */],
    Step2: __WEBPACK_IMPORTED_MODULE_2__Perekaman_Step_2__["a" /* default */],
    Step3: __WEBPACK_IMPORTED_MODULE_3__Perekaman_Step_3__["a" /* default */]
  },
  data: function data() {
    return {
      current_step: 1,
      reject: [],
      modalError: false
    };
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('barpin/getData', this.$route.params.id).then(function () {
      if (_this.$store.state.barpin.header.kd_status === 100 || _this.$store.state.barpin.header.kd_status === 190) __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', 'Status bukan perekaman', 'error').then(function () {
        return _this.$router.push('../browse');
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    save: 'barpin/saveData'
  }), {
    simpan: function simpan() {
      var _this2 = this;

      var npwpRegex = /^[0-9]{16}$/;
      if (this.$store.state.barpin.header.jns_identitas === '5' && !npwpRegex.test(this.$store.state.barpin.header.no_identitas)) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', 'NPWP harus 16 digit', 'error');
        return;
      }
      if (this.$store.state.barpin.header.jns_identitas_kuasa === '5' && this.$store.state.barpin.header.fl_kuasa && !npwpRegex.test(this.$store.state.barpin.header.no_identitas_kuasa)) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', 'NPWP Kuasa harus 16 digit', 'error');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Simpan data?',
        text: 'Anda yakin akan menyimpan?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this2.save(_this2.$route.params.id).then(function () {
              __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('success', 'Berhasil menyimpan', 'success');
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', JSON.parse(error.bodyText).message, 'error');
            });
        }
      });
    },
    saveNext: function saveNext() {
      var _this3 = this;

      var npwpRegex = /^[0-9]{16}$/;
      if (this.$store.state.barpin.header.jns_identitas === '5' && !npwpRegex.test(this.$store.state.barpin.header.no_identitas)) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', 'NPWP harus 16 digit', 'error');
        return;
      }
      if (this.$store.state.barpin.header.jns_identitas_kuasa === '5' && this.$store.state.barpin.header.fl_kuasa && !npwpRegex.test(this.$store.state.barpin.header.no_identitas_kuasa)) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', 'NPWP Kuasa harus 16 digit', 'error');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Simpan data?',
        text: 'Anda yakin akan menyimpan?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this3.save(_this3.$route.params.id).then(function () {
              __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('success', 'Berhasil menyimpan', 'success').then(function () {
                _this3.current_step++;
              });
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', JSON.parse(error.bodyText).message, 'error');
            });
        }
      });
    },
    kirim: function kirim() {
      var _this4 = this;

      var npwpRegex = /^[0-9]{16}$/;
      if (this.$store.state.barpin.header.jns_identitas === '5' && !npwpRegex.test(this.$store.state.barpin.header.no_identitas)) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', 'NPWP harus 16 digit', 'error');
        return;
      }
      if (this.$store.state.barpin.header.jns_identitas_kuasa === '5' && this.$store.state.barpin.header.fl_kuasa && !npwpRegex.test(this.$store.state.barpin.header.no_identitas_kuasa)) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', 'NPWP Kuasa harus 16 digit', 'error');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Kirim data?',
        text: 'Anda yakin akan mengirim pengajuan ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this4.$store.commit('barpin/SET_LOADING', true);
            _this4.save(_this4.$route.params.id).then(function () {
              _this4.$http.post('ppftz/send', { ID_AJU: _this4.$store.state.barpin.header.id_aju }).then(function () {
                _this4.$store.commit('barpin/SET_LOADING', false);
                __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('success', 'Berhasil menyimpan', 'success').then(function () {
                  _this4.$router.push('../browse');
                });
              }).catch(function (error) {
                console.log(error);
                if (error.status === 400) {
                  _this4.reject = error.data;
                  _this4.modalError = true;

                  return;
                }
                __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', JSON.parse(error.bodyText).message, 'error');
              });
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', JSON.parse(error.bodyText).message, 'error');
            });
        }
      });
    }
  }),
  computed: {
    currentStep: function currentStep() {
      return 'Step-' + this.current_step;
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_1_vue__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c5758f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Step_1_vue__ = __webpack_require__(347);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c5758f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Step_1_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Switch__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_3__components_Switch__["a" /* default */],
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_4_vue_search_select__["ModelListSelect"]
  },
  data: function data() {
    return {
      tes: 123165,
      pelabuhan: [],
      gudang: [],
      ref_identitas: [{ kd_id: '2', URAIAN: 'KTP' }, { kd_id: '3', URAIAN: 'Paspor' }, { kd_id: '4', URAIAN: 'Lainnya' }, { kd_id: '5', URAIAN: 'NPWP 16 Digit' }],
      file: {
        file: '',
        fileSize: '',
        fileExt: '',
        fileName: ''
      }
    };
  },
  created: function created() {
    this.getPelabuhan();
    this.getGudang();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    updateBarpin: function updateBarpin(where, event) {
      this.$store.commit('barpin/UPDATE_HEADER', { value: event, where: where });
    },
    model: function model(name) {
      return this.$store.state.barpin.header[name];
    },
    getPelabuhan: function getPelabuhan() {
      var _this = this;

      this.$http.get('ref/peldn').then(function (response) {
        _this.pelabuhan = response.data;
      });
    },
    getGudang: function getGudang() {
      var _this2 = this;

      this.$http.get('ref/idgudang').then(function (response) {
        _this2.gudang = response.data;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    upload: 'barpin/setFile'
  }), {
    fileChanged: function fileChanged(e, key) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fileReader;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fileReader = new FileReader();

                fileReader.readAsDataURL(e.target.files[0]);
                _this3.file.fileSize = e.target.files[0].size / 1024;
                _this3.file.fileExt = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
                _this3.file.fileName = e.target.files[0].name;
                fileReader.onload = function (e) {
                  _this3.file.file = e.target.result;
                  _this3.uploadFile(key);
                };

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    uploadFile: function uploadFile(key) {
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.file, {
        no_aju: this.$route.params.id,
        key_file: key
      });
      this.upload(data).then(function () {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('success', 'Berhasil meng-upload dokumen', 'success');
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('error', JSON.parse(error.bodyText.message), 'error');
      });
    }
  }),
  computed: {
    fl_kuasa: {
      get: function get() {
        return this.$store.state.barpin.header.fl_kuasa;
      },
      set: function set(value) {
        this.$store.commit('barpin/UPDATE_HEADER', {
          value: value,
          where: 'fl_kuasa'
        });
      }
    },
    alamat: {
      get: function get() {
        return this.$store.state.barpin.header.alamat;
      },
      set: function set(value) {
        this.$store.commit('barpin/UPDATE_HEADER', {
          value: value,
          where: 'alamat'
        });
      }
    },
    alamat_kuasa: {
      get: function get() {
        return this.$store.state.barpin.header.alamat_kuasa;
      },
      set: function set(value) {
        this.$store.commit('barpin/UPDATE_HEADER', {
          value: value,
          where: 'alamat_kuasa'
        });
      }
    },
    tesCurrency: {
      get: function get() {
        if (!this.tes) return 'Rp0.00';
        return 'Rp' + parseFloat(this.tes).toFixed(2);
      },
      set: function set(value) {
        this.tes = value;
      }
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.ref_identitas,
      "option-value": "kd_id",
      "option-text": "URAIAN",
      "value": _vm.model('jns_identitas'),
      "name": "Jenis Identitas",
      "placeholder": "Jenis Identitas"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('jns_identitas', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.model('jns_identitas') === '5' ? 'required|min:16' : 'required'),
      expression: " model('jns_identitas') === '5' ? 'required|min:16' : 'required' "
    }],
    class: _vm.errors.has('Nomor Identitas') ? 'is-invalid' : '',
    attrs: {
      "name": "Nomor Identitas",
      "type": "text",
      "value": _vm.model('no_identitas'),
      "placeholder": "Nomor Identitas"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_identitas', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas')),
      expression: "errors.has('Nomor Identitas')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('nama'),
      "placeholder": "Nama Pemohon"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('nama', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('alamat'),
      "placeholder": "Alamat"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('alamat', $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mx-3"
  }, [_c('p', {
    staticClass: "mr-3"
  }, [_vm._v("Menggunakan Kuasa?")]), _vm._v(" "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "primary",
      "pill": true,
      "checked": true
    },
    model: {
      value: (_vm.fl_kuasa),
      callback: function($$v) {
        _vm.fl_kuasa = $$v
      },
      expression: " fl_kuasa "
    }
  })], 1), _vm._v(" "), (_vm.fl_kuasa) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas yang dikuasakan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.ref_identitas,
      "option-value": "kd_id",
      "option-text": "URAIAN",
      "value": _vm.model('jns_identitas_kuasa'),
      "name": "Jenis Identitas",
      "placeholder": "Jenis Identitas"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('jns_identitas_kuasa', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas yang dikuasakan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.model('jns_identitas_kuasa') === '5' ? 'min:16' : ''),
      expression: " model('jns_identitas_kuasa') === '5' ? 'min:16' : '' "
    }],
    class: _vm.errors.has('Nomor Identitas yang dikuasakan') ? 'is-invalid' : '',
    attrs: {
      "name": "Nomor Identitas yang dikuasakan",
      "type": "text",
      "value": _vm.model('no_identitas_kuasa'),
      "placeholder": "Nomor Identitas yang dikuasakan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_identitas_kuasa', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas yang dikuasakan')),
      expression: "errors.has('Nomor Identitas yang dikuasakan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas yang dikuasakan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama yang dikuasakan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('nama_kuasa'),
      "placeholder": "Nama Pemohon"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('nama_kuasa', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Alamat yang dikuasakan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('alamat_kuasa'),
      "placeholder": "Alamat yang dikuasakan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('alamat_kuasa', $event)
      }
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Moda Angkutan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": [{
          id_angkutan: '1',
          nama_angkutan: 'Laut'
        },
        {
          id_angkutan: '2',
          nama_angkutan: 'Udara'
        },
        {
          id_angkutan: '3',
          nama_angkutan: 'Darat'
        }
      ],
      "option-value": "id_angkutan",
      "custom-text": function (item) { return ((item.id_angkutan) + " - " + (item.nama_angkutan)); },
      "value": _vm.model('moda_angkutan'),
      "name": "Jenis Perizinan",
      "placeholder": "Moda Angkutan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('moda_angkutan', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tempat Penimbunan (Gudang)"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.gudang,
      "option-value": "ID_GUDANG",
      "custom-text": function (item) { return ((item.ID_GUDANG) + " - " + (item.NM_GUDANG)); },
      "name": "Jenis Perizinan",
      "value": _vm.model('id_gudang'),
      "placeholder": "Tempat Penimbunan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('id_gudang', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Sarana Pengangkut / Lori"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('nama_sarkut'),
      "placeholder": "Nama Sarana Angkutan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('nama_sarkut', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Voyage / Plat Nomor Kendaraan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "value": _vm.model('no_voyage'),
      "placeholder": "Nomor Voyage / Plat Nomor Kendaraan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_voyage', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Muat"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.pelabuhan,
      "option-value": "ID_LOKASI",
      "custom-text": function (item) { return ((item.ID_LOKASI) + " - " + (item.NM_LOKASI)); },
      "value": _vm.model('pel_muat'),
      "name": "Jenis Perizinan",
      "placeholder": "Pelabuhan Muat"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('pel_muat', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Tujuan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.pelabuhan,
      "option-value": "ID_LOKASI",
      "custom-text": function (item) { return ((item.ID_LOKASI) + " - " + (item.NM_LOKASI)); },
      "name": "Jenis Perizinan",
      "value": _vm.model('pel_tujuan'),
      "placeholder": "Pelabuhan Tujuan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('pel_tujuan', $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Bruto"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "currency": "Kg",
      "currency-symbol-position": "suffix",
      "separator": ".",
      "placeholder": "Bruto Barang",
      "precision": 2,
      "value": _vm.model('bruto')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('bruto', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Netto"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "currency": "Kg",
      "currency-symbol-position": "suffix",
      "separator": ".",
      "placeholder": "Netto Barang",
      "precision": 2,
      "value": _vm.model('netto')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('netto', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Estimasi Tanggal Pengeluaran"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_pengeluaran')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_pengeluaran', $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-borderless table-responsive"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "type": "text",
      "size": "50",
      "value": _vm.model('no_identitas')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_identitas', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_identitas_penerima'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_identitas_penerima) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_identitas_penerima) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_identitas_penerima))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor STNK",
      "value": _vm.model('no_stnk'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_stnk', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_stnk')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_stnk', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_stnk'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_stnk) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_stnk) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_stnk))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor BPKB",
      "value": _vm.model('no_bpkb'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_bpkb', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_bpkb')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_bpkb', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_bpkb'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_bpkb) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_bpkb) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_bpkb))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Surat Jalan",
      "value": _vm.model('no_surat_jalan'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_jalan', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_surat_jalan')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_surat_jalan', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_surat_jalan'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_surat_jalan) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_surat_jalan) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_surat_jalan))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.fl_kuasa) ? _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "value": _vm.model('no_identitas_kuasa'),
      "disabled": "",
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_identitas_kuasa', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_identitas_pengirim'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_identitas_pengirim) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_identitas_pengirim) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_identitas_pengirim))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": " Nomor Kartu Keluarga",
      "value": _vm.model('no_kk'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_kk', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_kk'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_kk) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_kk) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_kk))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Pindah Dukcapil")]), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "disabled": this.$store.state.barpin.isDisabled,
      "placeholder": "Nomor Surat Dukcapil",
      "value": _vm.model('no_dukcapil'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_dukcapil', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_dukcapil')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_dukcapil', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_dukcapil'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_dukcapil) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_dukcapil) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_dukcapil))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "disabled": this.$store.state.barpin.isDisabled,
      "placeholder": "Nomor Surat Pindah",
      "value": _vm.model('no_surat_pindah'),
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_pindah', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_pindah')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_pindah', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_pindah'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_pindah) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pindah) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pindah))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.fl_kuasa) ? _c('tr', [_c('td', [_vm._v("Surat Kuasa")]), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Surat Kuasa",
      "type": "text",
      "value": _vm.model('no_surat_kuasa')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_kuasa', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_surat_kuasa')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_surat_kuasa', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_kuasa'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_kuasa) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_kuasa) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_kuasa))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Surat Pernyataan",
      "type": "text",
      "value": _vm.model('no_surat_pernyataan')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_pernyataan', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_surat_pernyataan')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_surat_pernyataan', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_pernyataan'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_pernyataan) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pernyataan) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pernyataan))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Rekomendasi BP")]), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Surat Pernyataan",
      "type": "text",
      "value": _vm.model('no_surat_rekombp')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_surat_rekombp', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_surat_rekombp')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_surat_rekombp', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_rekombp'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_rekombp) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_rekombp) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_rekombp))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Packing List",
      "type": "text",
      "value": _vm.model('no_pl')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_pl', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_pl')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_pl', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_pl'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_pl) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pl) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pl))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "placeholder": "Nomor Gesek Kendaraan",
      "type": "text",
      "value": _vm.model('no_bukti_gesek')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('no_bukti_gesek', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "type": "date",
      "value": _vm.model('tgl_bukti_gesek')
    },
    on: {
      "input": function($event) {
        _vm.updateBarpin('tgl_bukti_gesek', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_bukti_gesek'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_bukti_gesek) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_bukti_gesek) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_bukti_gesek))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Lain-lain")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'file_lain_lain'); }
    }
  })], 1), _vm._v(" "), _c('td', [(!this.$store.state.barpin.files.file_lain_lain) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n              Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_lain_lain) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_lain_lain))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("File Upload")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Identitas (KTP/NPWP/SIM)"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Nomor STNK"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Nomor BPKB "), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Nomor Surat Jalan"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Identitas Kuasa (KTP/NPWP/SIM)"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Kartu Keluarga"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Surat Keterangan Pindah (Surat Mutasi/Lainnya)"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Surat Pernyataan"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Packing List"), _c('code', [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Bukti Gesek Kendaraan"), _c('code', [_vm._v("*")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_2_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c98c130_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Step_2_vue__ = __webpack_require__(366);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c98c130_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Step_2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_ppftz_modal_ModalKontainer_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_ppftz_modal_ModalBarang_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_ModalEditBarang_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ppftz_modal_ModalKemasan_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ppftz_modal_ModalKemasanEdit_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalKontainer: __WEBPACK_IMPORTED_MODULE_1__views_ppftz_modal_ModalKontainer_vue__["a" /* default */], ModalBarang: __WEBPACK_IMPORTED_MODULE_2__views_ppftz_modal_ModalBarang_vue__["a" /* default */], ModalEditBarang: __WEBPACK_IMPORTED_MODULE_3__modal_ModalEditBarang_vue__["a" /* default */], ModalKemasan: __WEBPACK_IMPORTED_MODULE_4__views_ppftz_modal_ModalKemasan_vue__["a" /* default */], ModalKemasanEdit: __WEBPACK_IMPORTED_MODULE_5__views_ppftz_modal_ModalKemasanEdit_vue__["a" /* default */]
  },
  created: function created() {
    this.getKontainer(this.$store.state.barpin.header.id_aju);
    this.getBarang(this.$store.state.barpin.header.id_aju);
    this.getKemasan(this.$store.state.barpin.header.id_aju);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
    getKontainer: 'barpin/getKontainer',
    getBarang: 'barpin/getBarang',
    getDetilBarang: 'barpin/getDetilBarang',
    getKemasan: 'barpin/getKemasan',
    getDetilKemasan: 'barpin/getDetilKemasan'
  }), {
    removeBarang: function removeBarang(index) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Hapus data barang?',
        text: 'Anda yakin akan menghapus data barang ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this.$store.dispatch('barpin/removeBarang', { ID_BARANG: index, ID_AJU: _this.$store.state.barpin.header.id_aju });
        }
      });
    },
    removeKontainer: function removeKontainer(index) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Hapus Kontainer?',
        text: 'Anda yakin akan menghapus kontainer ini?',
        icon: 'error',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      }).then(function (value) {
        switch (value) {
          case 'Yes':
            _this2.$store.dispatch('barpin/removeKontainer', { ID_KONTAINER: index, ID_AJU: _this2.$store.state.barpin.header.id_aju });
        }
      });
    }
  })
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalKontainer_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee4cd8a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalKontainer_vue__ = __webpack_require__(353);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalKontainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee4cd8a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalKontainer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      kontainer: {
        no_kontainer: '',
        ukuran_kontainer: '',
        jns_kontainer: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    setKontainer: 'barpin/setKontainer'
  }), {
    addKontainer: function addKontainer() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$store.commit('barpin/SET_LOADING_MODAL', true);
          _this.setKontainer(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.kontainer, { id_aju: _this.$store.state.barpin.header.id_aju })).then(function () {
            _this.$refs['modalKontainer'].hide();
            _this.$store.commit('barpin/SET_LOADING_MODAL', false);
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('error', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(error.bodyText).errors), 'error');
            _this.$store.commit('barpin/SET_LOADING_MODAL', false);
          });
        }
      });
    }
  })
});

/***/ }),
/* 352 */,
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalKontainer",
    attrs: {
      "id": "modal-kontainer",
      "title": "Tambah Kontainer",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addKontainer($event)
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Kontainer"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:11'),
      expression: "'required|min:11'"
    }],
    class: _vm.errors.has('Nomor Kontainer') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "maxlength": "11",
      "name": "Nomor Kontainer",
      "placeholder": "Nomor Kontainer"
    },
    model: {
      value: (_vm.kontainer.no_kontainer),
      callback: function($$v) {
        _vm.kontainer.no_kontainer = $$v
      },
      expression: "kontainer.no_kontainer"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Kontainer')),
      expression: "errors.has('Nomor Kontainer')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Kontainer')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Ukuran Kontainer"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "Feet"
    }
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Ukuran Kontainer') ? 'is-invalid' : '',
    attrs: {
      "plain": true,
      "name": "Ukuran Kontainer",
      "options": ['20', '40', '45']
    },
    model: {
      value: (_vm.kontainer.ukuran_kontainer),
      callback: function($$v) {
        _vm.kontainer.ukuran_kontainer = $$v
      },
      expression: "kontainer.ukuran_kontainer"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Ukuran Kontainer')),
      expression: "errors.has('Ukuran Kontainer')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Ukuran Kontainer')) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kontainer"
    }
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jenis Kontainer') ? 'is-invalid' : '',
    attrs: {
      "plain": true,
      "name": "Jenis Kontainer",
      "options": [{
        text: 'FCL',
        value: 'F'
      }, {
        text: 'LCL',
        value: 'L'
      }]
    },
    model: {
      value: (_vm.kontainer.jns_kontainer),
      callback: function($$v) {
        _vm.kontainer.jns_kontainer = $$v
      },
      expression: "kontainer.jns_kontainer"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kontainer')),
      expression: "errors.has('Jenis Kontainer')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kontainer')) + "\n          ")])], 1)], 1)]), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah\n      ")])], {
    id: "footer"
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBarang_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d855b6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBarang_vue__ = __webpack_require__(356);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBarang_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d855b6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBarang_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      satuan: [],
      kemasan: [],
      barang: {
        uraian_barang: '',
        jml_satuan: '',
        jns_satuan: '',
        jml_kemasan: '',
        jns_kemasan: '',
        bruto: 0,
        netto: 0,
        nilai_barang: 0,
        tarif_bm: '',

        tarif_ppn: '',
        nilai_ppn: '',
        tarif_pph: '',
        nilai_pph: '',
        hs_code: ''
      }
    };
  },

  computed: {
    nilai_bm: function nilai_bm() {
      return this.barang.nilai_barang * (this.barang.tarif_bm / 100);
    },
    nilai_ppn: function nilai_ppn() {
      return (this.barang.nilai_barang + this.nilai_bm) * (this.barang.tarif_ppn / 100);
    },
    nilai_pph: function nilai_pph() {
      return (this.barang.nilai_barang + this.nilai_bm) * (this.barang.tarif_pph / 100);
    }
  },
  created: function created() {
    this.getSatuan();
    this.getKemasan();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    setBarang: 'barpin/setBarang'
  }), {
    addBarang: function addBarang() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$store.commit('barpin/SET_LOADING_MODAL', true);
          var dataSet = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.barang, {
            id_aju: _this.$store.state.barpin.header.id_aju,
            nilai_bm: _this.nilai_bm,
            nilai_ppn: _this.nilai_ppn,
            nilai_pph: _this.nilai_pph
          });
          _this.setBarang(dataSet).then(function () {
            _this.$refs['modalBarang'].hide();
            _this.$store.commit('barpin/SET_LOADING_MODAL', false);
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('error', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(error.bodyText).errors), 'error');
            _this.$store.commit('barpin/SET_LOADING_MODAL', false);
          });
        }
      });
    },
    getSatuan: function getSatuan() {
      var _this2 = this;

      this.$http.get('ref/jnsatuan').then(function (response) {
        _this2.satuan = response.data;
      });
    },
    getKemasan: function getKemasan() {
      var _this3 = this;

      this.$http.get('ref/jnskemasan').then(function (response) {
        _this3.kemasan = response.data;
      });
    }
  })
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalBarang",
    attrs: {
      "id": "modal-barang",
      "title": "Tambah Barang",
      "variant": "success",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addBarang($event)
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Uraian Barang"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Uraian Barang') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "name": "Uraian Barang",
      "placeholder": "..."
    },
    model: {
      value: (_vm.barang.uraian_barang),
      callback: function($$v) {
        _vm.barang.uraian_barang = $$v
      },
      expression: "barang.uraian_barang"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Uraian Barang')),
      expression: "errors.has('Uraian Barang')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Uraian Barang')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Satuan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jumlah Satuan') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "name": "Jumlah Satuan",
      "placeholder": "..."
    },
    model: {
      value: (_vm.barang.jml_satuan),
      callback: function($$v) {
        _vm.barang.jml_satuan = $$v
      },
      expression: "barang.jml_satuan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Satuan')),
      expression: "errors.has('Jumlah Satuan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Satuan')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Satuan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Satuan') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.satuan,
      "option-value": "JNS_SAT",
      "custom-text": function (item) { return ((item.JNS_SAT) + " - " + (item.UR_SAT)); },
      "name": "Jenis Satuan",
      "placeholder": "Jenis Satuan"
    },
    model: {
      value: (_vm.barang.jns_satuan),
      callback: function($$v) {
        _vm.barang.jns_satuan = $$v
      },
      expression: "barang.jns_satuan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Satuan')),
      expression: "errors.has('Jenis Satuan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Satuan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jumlah Kemasan') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "placeholder": "...",
      "name": "Jumlah Kemasan"
    },
    model: {
      value: (_vm.barang.jml_kemasan),
      callback: function($$v) {
        _vm.barang.jml_kemasan = $$v
      },
      expression: "barang.jml_kemasan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Kemasan')) + "\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Kemasan') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.kemasan,
      "option-value": "JNS_KMS",
      "custom-text": function (item) { return ((item.JNS_KMS) + " - " + (item.UR_KMS)); },
      "name": "Jenis Kemasan",
      "placeholder": "Jenis Kemasan"
    },
    model: {
      value: (_vm.barang.jns_kemasan),
      callback: function($$v) {
        _vm.barang.jns_kemasan = $$v
      },
      expression: "barang.jns_kemasan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kemasan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Bruto"
    }
  }, [_c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('bruto') ? 'is-invalid' : '',
    attrs: {
      "currency": "Kg",
      "currency-symbol-position": "suffix",
      "separator": ".",
      "placeholder": "Bruto Barang",
      "precision": 2,
      "name": "bruto",
      "required": ""
    },
    model: {
      value: (_vm.barang.bruto),
      callback: function($$v) {
        _vm.barang.bruto = $$v
      },
      expression: "barang.bruto"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bruto')),
      expression: "errors.has('bruto')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('bruto')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Netto"
    }
  }, [_c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "currency": "Kg",
      "currency-symbol-position": "suffix",
      "separator": ".",
      "placeholder": "Netto Barang",
      "precision": 2,
      "name": "netto",
      "required": ""
    },
    model: {
      value: (_vm.barang.netto),
      callback: function($$v) {
        _vm.barang.netto = $$v
      },
      expression: "barang.netto"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netto')),
      expression: "errors.has('netto')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('netto')))])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nilai Barang (Rp)"
    }
  }, [_c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "currency": "Rp",
      "separator": ".",
      "decimal": "0",
      "name": "Nilai Barang",
      "required": ""
    },
    model: {
      value: (_vm.barang.nilai_barang),
      callback: function($$v) {
        _vm.barang.nilai_barang = $$v
      },
      expression: "barang.nilai_barang"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nilai Barang')),
      expression: "errors.has('Nilai Barang')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nilai Barang')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "HS Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "8",
      "type": "text"
    },
    model: {
      value: (_vm.barang.hs_code),
      callback: function($$v) {
        _vm.barang.hs_code = $$v
      },
      expression: "barang.hs_code"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nilai Barang')),
      expression: "errors.has('Nilai Barang')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nilai Barang')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif Bea Masuk"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1
    },
    model: {
      value: (_vm.barang.tarif_bm),
      callback: function($$v) {
        _vm.barang.tarif_bm = $$v
      },
      expression: "barang.tarif_bm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai Bea Masuk"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_bm
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif PPN"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1
    },
    model: {
      value: (_vm.barang.tarif_ppn),
      callback: function($$v) {
        _vm.barang.tarif_ppn = $$v
      },
      expression: "barang.tarif_ppn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai PPN"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_ppn
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif PPh"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1
    },
    model: {
      value: (_vm.barang.tarif_pph),
      callback: function($$v) {
        _vm.barang.tarif_pph = $$v
      },
      expression: "barang.tarif_pph"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai PPh"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_pph
    }
  })], 1)], 1)]), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah\n      ")])], {
    id: "footer"
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEditBarang_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7b67e0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEditBarang_vue__ = __webpack_require__(359);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEditBarang_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7b67e0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEditBarang_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      satuan: [],
      kemasan: []
    };
  },

  computed: {
    nilai_bm: function nilai_bm() {
      return this.model('CIF') * (this.model('TARIF_BM') / 100);
    },
    nilai_ppn: function nilai_ppn() {
      return (this.model('CIF') + this.nilai_bm) * (this.model('TARIF_PPN') / 100);
    },
    nilai_pph: function nilai_pph() {
      return (this.model('CIF') + this.nilai_bm) * (this.model('TARIF_PPH') / 100);
    }
  },
  created: function created() {
    this.getSatuan();
    this.getKemasan();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    setBarang: 'barpin/updateBarang'
  }), {
    model: function model(name) {
      return this.$store.state.barpin.current_barang[name];
    },
    updateBarang: function updateBarang(where, event) {
      this.$store.commit('barpin/UPDATE_BARANG', { value: event, where: where });
    },
    saveBarang: function saveBarang() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$store.commit('barpin/SET_LOADING', true);
          var dataSet = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.$store.state.barpin.current_barang, {
            nilai_bm: _this.nilai_bm,
            nilai_ppn: _this.nilai_ppn,
            nilai_pph: _this.nilai_pph
          });
          console.log(dataSet);
          _this.setBarang(dataSet).then(function () {
            _this.$refs['modalEditBarang'].hide();
            _this.$store.commit('barpin/SET_LOADING', false);
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('error', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(error.bodyText).errors), 'error');
            _this.$store.commit('barpin/SET_LOADING', false);
          });
        }
      });
    },
    getSatuan: function getSatuan() {
      var _this2 = this;

      this.$http.get('ref/jnsatuan').then(function (response) {
        _this2.satuan = response.data;
      });
    },
    getKemasan: function getKemasan() {
      var _this3 = this;

      this.$http.get('ref/jnskemasan').then(function (response) {
        _this3.kemasan = response.data;
      });
    }
  })
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalEditBarang",
    attrs: {
      "id": "modal-edit-barang",
      "title": "Edit Barang",
      "variant": "success",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveBarang($event)
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Uraian Barang"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Uraian Barang') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "name": "Uraian Barang",
      "placeholder": "...",
      "value": _vm.model('URAIAN_BARANG')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('URAIAN_BARANG', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Uraian Barang')),
      expression: "errors.has('Uraian Barang')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Uraian Barang')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Satuan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jumlah Satuan') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "name": "Jumlah Satuan",
      "placeholder": "...",
      "value": _vm.model('JML_SATUAN')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('JML_SATUAN', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Satuan')),
      expression: "errors.has('Jumlah Satuan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Satuan')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Satuan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Satuan') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.satuan,
      "option-value": "JNS_SAT",
      "custom-text": function (item) { return ((item.JNS_SAT) + " - " + (item.UR_SAT)); },
      "value": _vm.model('JNS_SATUAN'),
      "name": "Jenis Satuan",
      "placeholder": "Jenis Satuan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('JNS_SATUAN', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Satuan')),
      expression: "errors.has('Jenis Satuan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Satuan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jumlah Kemasan') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "placeholder": "...",
      "value": _vm.model('JML_KEMASAN'),
      "name": "Jumlah Kemasan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('JML_KEMASAN', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Kemasan')) + "\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Kemasan') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.kemasan,
      "option-value": "JNS_KMS",
      "custom-text": function (item) { return ((item.JNS_KMS) + " - " + (item.UR_KMS)); },
      "value": _vm.model('JNS_KEMASAN'),
      "name": "Jenis Kemasan",
      "placeholder": "Jenis Kemasan"
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('JNS_KEMASAN', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kemasan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Bruto"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "...",
      "value": _vm.model('BRUTO')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('BRUTO', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Netto"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "...",
      "value": _vm.model('NETTO')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('NETTO', $event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nilai Barang (Rp)"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "currency": "Rp",
      "separator": ".",
      "decimal": "0",
      "value": _vm.model('CIF')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('CIF', $event)
      }
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "HS Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "8",
      "type": "text",
      "value": _vm.model('HS_CODE')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('HS_CODE', $event)
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v("digit only")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif Bea Masuk"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1,
      "value": _vm.model('TARIF_BM')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('TARIF_BM', $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai Bea Masuk"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_bm
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif PPN"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1,
      "value": _vm.model('TARIF_PPN')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('TARIF_PPN', $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai PPN"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_ppn
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif PPh"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1,
      "value": _vm.model('TARIF_PPH')
    },
    on: {
      "input": function($event) {
        _vm.updateBarang('TARIF_PPH', $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai PPh"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_pph
    }
  })], 1)], 1)]), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Simpan\n      ")])], {
    id: "footer"
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalKemasan_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a98f91a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalKemasan_vue__ = __webpack_require__(362);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalKemasan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a98f91a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalKemasan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      JenisKemasan: [],
      kemasan: {
        jumlahKemasan: '',
        jenisKemasan: ''
      }
    };
  },
  created: function created() {
    this.getJenisKemasan();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    setKemasan: 'barpin/setKemasan'
  }), {
    getJenisKemasan: function getJenisKemasan() {
      var _this = this;

      this.$http.get('ref/jnskemasan').then(function (response) {
        _this.JenisKemasan = response.data;
      });
    },
    submitKemasan: function submitKemasan() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.$store.commit('barpin/SET_LOADING_MODAL', true);
          _this2.setKemasan(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.kemasan, { id_aju: _this2.$store.state.barpin.header.id_aju })).then(function () {
            _this2.$refs['modalKemasan'].hide();
            _this2.$store.commit('barpin/SET_LOADING_MODAL', false);
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('error', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(error.bodyText).errors), 'error');
            _this2.$store.commit('barpin/SET_LOADING_MODAL', false);
          });
        }
      });
    }
  })
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalKemasan",
    attrs: {
      "id": "modal-kemasan",
      "title": "Tambah Kemasan",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.kemasan.jumlahKemasan),
      expression: "kemasan.jumlahKemasan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jumlah Kemasan",
      "type": "number"
    },
    domProps: {
      "value": (_vm.kemasan.jumlahKemasan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kemasan.jumlahKemasan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Kemasan')))]), _vm._v(" "), _c('small', [_vm._v("Isikan Jumlah Total Kemasan")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Kemasan",
      "list": _vm.JenisKemasan,
      "option-value": "JNS_KMS",
      "custom-text": function (item) { return ((item.JNS_KMS) + " - " + (item.UR_KMS)); },
      "placeholder": "Jenis Kemasan"
    },
    model: {
      value: (_vm.kemasan.jenisKemasan),
      callback: function($$v) {
        _vm.kemasan.jenisKemasan = $$v
      },
      expression: "kemasan.jenisKemasan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kemasan')) + " ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.submitKemasan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalKemasanEdit_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f095b1d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalKemasanEdit_vue__ = __webpack_require__(365);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalKemasanEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f095b1d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalKemasanEdit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      JenisKemasan: [],
      kemasan: {
        jumlahKemasan: '',
        jenisKemasan: ''
      }
    };
  },
  created: function created() {
    this.getJenisKemasan();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    setKemasan: 'barpin/updateKemasan'
  }), {
    model: function model(name) {
      return this.$store.state.barpin.current_kemasan[name];
    },
    getJenisKemasan: function getJenisKemasan() {
      var _this = this;

      this.$http.get('ref/jnskemasan').then(function (response) {
        _this.JenisKemasan = response.data;
      });
    },
    updateKemasan: function updateKemasan(where, event) {
      this.$store.commit('barpin/UPDATE_KEMASAN', { value: event, where: where });
    },
    saveUpdateKemasan: function saveUpdateKemasan() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.$store.commit('barpin/SET_LOADING', true);
          var dataSet = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.$store.state.barpin.current_kemasan);
          _this2.setKemasan(dataSet).then(function () {
            _this2.$refs['modalKemasanEdit'].hide();
            _this2.$store.commit('barpin/SET_LOADING', false);
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('error', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(error.bodyText).errors), 'error');
            _this2.$store.commit('barpin/SET_LOADING', false);
          });
        }
      });
    }
  })
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalKemasanEdit",
    attrs: {
      "id": "modal-kemasan-edit",
      "title": "Edit Kemasan",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": _vm.model('JML_KMS'),
      "type": "number",
      "name": "Jumlah Kemasan"
    },
    on: {
      "input": function($event) {
        _vm.updateKemasan('JML_KMS', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Kemasan')))]), _vm._v(" "), _c('small', [_vm._v("Isikan Jumlah Total Kemasan")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "value": _vm.model('JNS_KMS'),
      "list": _vm.JenisKemasan,
      "option-value": "JNS_KMS",
      "custom-text": function (item) { return ((item.JNS_KMS) + " - " + (item.UR_KMS)); }
    },
    on: {
      "input": function($event) {
        _vm.updateKemasan('JNS_KMS', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kemasan')) + " ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.saveUpdateKemasan()
      }
    }
  }, [_vm._v("Simpan")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "disabled": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "Kontainer"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-kontainer",
      modifiers: {
        "modal-kontainer": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Kontainer\n    ")]), _vm._v(" "), _c('modal-kontainer', {
    ref: "modalKontainer"
  }), _vm._v(" "), (this.$store.state.barpin.kontainer.length) ? _c('table', {
    staticClass: "table table-responsive table-sm table-striped mt-3"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nomor Kontainer")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Ukuran Kontainer")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.kontainer), function(item, index) {
    return _c('tr', {
      key: item.NO_KONTAINER
    }, [_c('td', [_vm._v(_vm._s(item.NO_KONTAINER))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((item.UKURAN_KONTAINER) + " Feet / " + (item.JNS_KONTAINER))))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removeKontainer(item.ID_KONTAINER)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Kemasan"
    }
  }, [(this.$store.state.barpin.kemasan.length < 1) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-kemasan",
      modifiers: {
        "modal-kemasan": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Kemasan\n    ")]) : _vm._e(), _vm._v(" "), (this.$store.state.barpin.kemasan.length) ? _c('table', {
    staticClass: "table table-responsive table-sm mt-3"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Jumlah Kemasan")]), _vm._v(" "), _c('th', [_vm._v("Jenis Kemasan")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.kemasan), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.JML_KMS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.JNS_KMS))]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-kemasan-edit",
        modifiers: {
          "modal-kemasan-edit": true
        }
      }],
      staticClass: "btn btn-secondary",
      on: {
        "click": function($event) {
          _vm.getDetilKemasan(item.ID_KEMASAN)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('modal-kemasan', {
    ref: "modalKemasan"
  }), _vm._v(" "), _c('modal-kemasan-edit', {
    ref: "modalKemasanEdit"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Barang"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-barang",
      modifiers: {
        "modal-barang": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Barang\n    ")]), _vm._v(" "), (this.$store.state.barpin.barang.length) ? _c('table', {
    staticClass: "table table-responsive table-striped mt-3"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nama Barang")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Jumlah Barang")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nilai Barang")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.barang), function(item, index) {
    return _c('tr', {
      key: item.URAIAN_BARANG
    }, [_c('td', [_vm._v(_vm._s(item.URAIAN_BARANG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((item.JML_SATUAN) + " " + (item.JNS_SATUAN) + " / " + (item.JML_KEMASAN) + " " + (item.JNS_KEMASAN) + " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.CIF.toLocaleString()))]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-edit-barang",
        modifiers: {
          "modal-edit-barang": true
        }
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.getDetilBarang(item.ID_BARANG)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removeBarang(item.ID_BARANG)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('modal-barang', {
    ref: "modalBarang"
  }), _vm._v(" "), _c('modal-edit-barang', {
    ref: "modalEditBarang"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_3_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca6d8b1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Step_3_vue__ = __webpack_require__(369);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca6d8b1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Step_3_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_search_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_search_select__);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_0_vue_search_select__["ModelListSelect"]
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center align-items-center border border-danger"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.$http.options.root + '/ppftz/pdf/ppftz' + '/' + _vm.$store.state.barpin.header.encoded_id,
      "width": "1200",
      "height": "800"
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('b-progress', {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.current_step - 1,
      "variant": "success",
      "max": 3,
      "show-progress": "",
      "animated": ""
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "Barpin",
    attrs: {
      "header": "Perekaman Barang Pindahan",
      "show-footer": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_step == 1),
      expression: "current_step == 1"
    }],
    slot: "header"
  }, [_c('label', {
    staticClass: "float-right mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.simpan
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Simpan\n        ")])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c(_vm.currentStep, {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between",
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_step > 1),
      expression: "current_step > 1"
    }],
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.current_step--
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Back\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_step == 1),
      expression: "current_step == 1"
    }],
    staticClass: "btn btn-secondary ml-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.current_step++
      }
    }
  }, [_vm._v("\n        Next\n        "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_step == 2),
      expression: "current_step == 2"
    }],
    staticClass: "btn btn-primary ml-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveNext
    }
  }, [_vm._v("\n        Save and Next\n        "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_step == 3),
      expression: "current_step == 3"
    }],
    staticClass: "btn btn-success ml-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.kirim
    }
  }, [_vm._v("\n        Simpan dan Kirim\n        "), _c('i', {
    staticClass: "fa fa-send"
  })])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Keterangan Gagal Kirim"
    },
    model: {
      value: (_vm.modalError),
      callback: function($$v) {
        _vm.modalError = $$v
      },
      expression: "modalError"
    }
  }, [_c('ul', _vm._l((_vm.reject), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c150c5d4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__(380);
function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c150c5d4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_epic_spinners__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_ModalRespon_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_ModalCatatan_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_ModalBilling_vue__ = __webpack_require__(377);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ppftz: [],
      pageOfItems: [],
      searchFilter: '',
      jns_aju: '',
      status: [],
      current_status: ''
    };
  },

  components: {
    HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_2_epic_spinners__["a" /* HalfCircleSpinner */],
    ModalRespon: __WEBPACK_IMPORTED_MODULE_3__modal_ModalRespon_vue__["a" /* default */],
    ModalCatatan: __WEBPACK_IMPORTED_MODULE_4__modal_ModalCatatan_vue__["a" /* default */],
    ModalBilling: __WEBPACK_IMPORTED_MODULE_5__modal_ModalBilling_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.browse();
    this.refStatus();
  },

  computed: {
    filteredData: function filteredData() {
      var _this = this;

      return this.ppftz.filter(function (items) {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(_this.searchFilter.toLowerCase()) !== -1) {
            return true;
          }
        }
        return false;
      }).filter(function (items) {
        if (_this.jns_aju === '') return true;
        if (items.JNS_AJU === _this.jns_aju) return true;
        return false;
      }).filter(function (items) {
        if (_this.current_status === '') return true;
        if (items.KD_STATUS === _this.current_status) return true;
        return false;
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getCatatan: 'barpin/getCatatan'
  }), {
    browse: function browse() {
      var _this2 = this;

      this.$store.commit('barpin/SET_LOADING', true);
      this.$http.get('ppftz').then(function (response) {
        _this2.ppftz = response.data;
        _this2.$store.commit('barpin/SET_LOADING', false);
      });
    },
    setRespon: function setRespon(encodedId, status, noAju) {
      var _this3 = this;

      this.$store.commit('barpin/SET_LOADING_MODAL', true);
      this.$store.commit('barpin/SET_RESPON', { id: encodedId, status: status });
      this.$store.dispatch('barpin/getData', noAju).then(function () {
        _this3.$store.commit('barpin/SET_LOADING_MODAL', false);
      });
    },
    setBilling: function setBilling(id, noAju) {
      this.$store.commit('barpin/SET_BILLING_ID', id);
    },
    refStatus: function refStatus() {
      var _this4 = this;

      this.$http.get('ref/status').then(function (response) {
        _this4.status = response.data.filter(function (items) {
          return items.status >= 110;
        });
      });
    },
    onChangePage: function onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    }
  })
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalRespon_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da117304_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalRespon_vue__ = __webpack_require__(376);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalRespon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da117304_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalRespon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      responses: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({}))
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalRespon",
    attrs: {
      "id": "modal-respon",
      "title": "Respon PPFTZ",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-esc": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [(_vm.$store.state.barpin.respon.status > '100') ? _c('tr', [_c('td', [_vm._v("Respon Penerimaan")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/penerimaan/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status > '100') ? _c('tr', [_c('td', [_vm._v("PPFTZ")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/ppftz/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status > '110' && this.$store.state.barpin.files.file_billing) ? _c('tr', [_c('td', [_vm._v("Kode Billing")]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_billing) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$store.state.barpin.header.no_aju) + "/" + (this.$store.state.barpin.files.file_billing))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status > '116') ? _c('tr', [_c('td', [_vm._v("SURAT PEMERIKSAAN FISIK (SPF)")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/spf/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status > '116') ? _c('tr', [_c('td', [_vm._v("Instruksi Pemeriksaan (IP)")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/ip/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status >= '150') ? _c('tr', [_c('td', [_vm._v("SPPB")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/sppb/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.respon.status == '145') ? _c('tr', [_c('td', [_vm._v("NOTA PENOLAKAN")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.root + '/ppftz/pdf/nolak/' + _vm.$store.state.barpin.respon.id
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1)])]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBilling_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_670588bc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBilling_vue__ = __webpack_require__(379);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBilling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_670588bc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBilling_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      no_ntpn: '',
      tgl_ntpn: '',
      file: {
        file: '',
        fileSize: '',
        fileExt: '',
        fileName: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    upload: 'barpin/setFile'
  }), {
    fileChanged: function fileChanged(e, key) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fileReader;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fileReader = new FileReader();

                fileReader.readAsDataURL(e.target.files[0]);
                _this.file.fileSize = e.target.files[0].size / 1024;
                _this.file.fileExt = e.target.files[0].name.substr(e.target.files[0].name.lastIndexOf('.') + 1);
                _this.file.fileName = e.target.files[0].name;
                fileReader.onload = function (e) {
                  _this.file.file = e.target.result;
                  _this.uploadFile(key);
                };

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    uploadFile: function uploadFile(key) {
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.file, {
        no_aju: this.$store.state.barpin.current_id_billing,
        key_file: key
      });
      this.upload(data).then(function () {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('success', 'Berhasil meng-upload dokumen', 'success');
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('error', JSON.parse(error.bodyText.message), 'error');
      });
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      this.$store.commit('barpin/SET_LOADING', true);
      var data = {
        NO_NTPN: this.no_ntpn,
        TGL_NTPN: this.tgl_ntpn,
        id: this.$store.state.barpin.current_id_billing
      };
      this.$http.post('ppftz/billing', data).then(function () {
        _this2.$store.commit('barpin/SET_LOADING', false);
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('success', 'Berhasil Menyimpan', 'success').then(function () {
          _this2.$refs['my-modal'].hide();
        });
      });
    }
  })
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalRespon",
    attrs: {
      "id": "modal-billing",
      "title": "Rekam Bukti Bayar",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('b-form-fieldset', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("No. NTPN / Bukti Bayar")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.no_ntpn),
      callback: function($$v) {
        _vm.no_ntpn = $$v
      },
      expression: "no_ntpn"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tanggal NTPN / Bukti Bayar")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "date",
      "required": ""
    },
    model: {
      value: (_vm.tgl_ntpn),
      callback: function($$v) {
        _vm.tgl_ntpn = $$v
      },
      expression: "tgl_ntpn"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-form-file', {
    ref: "file-input",
    staticClass: "mb-2",
    attrs: {
      "plain": true
    },
    on: {
      "change": function (e) { return _vm.fileChanged(e, 'FILE_NTPN'); }
    }
  }), _vm._v(" "), (!this.$store.state.barpin.files.FILE_NTPN) ? _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("Belum\n        Upload")]) : _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Sudah upload")])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "variant": "success"
    }
  }, [_vm._v("Simpan")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "header": "Browse PPFTZ Manual"
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 my-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pencarian"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 my-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_status),
      expression: "current_status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.current_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.status), function(item) {
    return _c('option', {
      key: item.status,
      domProps: {
        "value": item.status
      }
    }, [_vm._v(_vm._s(item.ur_status))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 my-2"
  }, [_c('b-form-fieldset', [_c('b-form-select', {
    attrs: {
      "plain": true,
      "options": [{
          text: 'Jenis Aju',
          value: ''
        },
        {
          text: 'Barang Pindahan',
          value: '1'
        },
        {
          text: 'Kendaraan Bermotor',
          value: '2'
        }
      ]
    },
    model: {
      value: (_vm.jns_aju),
      callback: function($$v) {
        _vm.jns_aju = $$v
      },
      expression: "jns_aju"
    }
  })], 1)], 1)])])]), _vm._v(" "), (!this.$store.state.barpin.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No. Aju")]), _vm._v(" "), _c('th', [_vm._v("No. Daftar")]), _vm._v(" "), _c('th', [_vm._v("Nama Penerima")]), _vm._v(" "), _c('th', [_vm._v("Jenis Pengajuan")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(data) {
    return _c('tr', {
      key: data.NO_AJU
    }, [_c('td', [_vm._v(_vm._s(data.NO_AJU))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NO_DAFTAR))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NAMA_PENERIMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.JNS_AJU == '1' ? 'Barang Pindahan' : 'Kendaraan Bermotor'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status.ur_status))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": ("browse/" + (data.NO_AJU))
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-respon",
        modifiers: {
          "modal-respon": true
        }
      }],
      attrs: {
        "variant": "success"
      },
      on: {
        "click": function($event) {
          _vm.setRespon(data.encoded_id, data.KD_STATUS, data.NO_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-catatan",
        modifiers: {
          "modal-catatan": true
        }
      }],
      attrs: {
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.getCatatan(data.ID_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bars"
    })]), _vm._v(" "), (data.KD_STATUS === '115') ? _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-billing",
        modifiers: {
          "modal-billing": true
        }
      }],
      attrs: {
        "title": "Rekam Bukti Bayar",
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.setBilling(data.NO_AJU)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e()], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "card-footer pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('modal-respon'), _vm._v(" "), _c('modal-catatan'), _vm._v(" "), _c('modal-billing')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilPpftz_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f6fdc2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilPpftz_vue__ = __webpack_require__(387);
function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17f6fdc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetilPpftz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f6fdc2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DetilPpftz_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListFilePpftz_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_ModalCatatan_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ListFilePpftz: __WEBPACK_IMPORTED_MODULE_1__ListFilePpftz_vue__["a" /* default */],
    ModalCatatan: __WEBPACK_IMPORTED_MODULE_3__modal_ModalCatatan_vue__["a" /* default */]
  },
  data: function data() {
    return {
      headers: [{ text: 'No. Pengajuan', value: 'no_aju' }, { text: 'No. Daftar', value: 'no_daftar' }, { text: 'Tgl. Daftar', value: 'tgl_daftar' }, { text: 'Jenis Pengajuan', value: 'jns_aju' }, { text: 'No. SPPB', value: 'no_sppb' }, { text: 'Tgl. SPPB', value: 'tgl_sppb' }],
      headers2: [{ text: 'Moda Angkutan', value: 'moda_angkutan' }, { text: 'Tempat Penimbunan', value: 'id_gudang' }, { text: 'Pelabuhan Muat', value: 'pel_muat' }, { text: 'Pelabuhan Tujuan', value: 'pel_tujuan' }, { text: 'Bruto', value: 'bruto' }, { text: 'Estimasi Tgl. Pengeluaran', value: 'tgl_pengeluaran' }],
      headers3: [{ text: 'Nama Pengirim', value: 'nama_kuasa' }, { text: 'Jenis Identitas Pengirim', value: 'jns_identitas_kuasa' }, { text: 'Nomor Identitas Pengirim', value: 'no_identitas_kuasa' }, { text: 'Alamat Pengirim', value: 'alamat_kuasa' }],
      headers4: [{ text: 'Nama Penerima', value: 'nama' }, { text: 'Jenis Identitas Penerima', value: 'jns_identitas' }, { text: 'Nomor Identitas Penerima', value: 'no_identitas' }, { text: 'Alamat Penerima', value: 'alamat' }]
    };
  },
  created: function created() {
    var _this = this;

    this.getData(this.$route.params.id).then(function () {
      if (_this.$store.state.barpin.header.no_aju === undefined) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('error', 'error', 'error').then(function () {
          _this.$router.push('/dashboard');
        });
      } else {
        _this.getKontainer(_this.$store.state.barpin.header.id_aju);
        _this.getBarang(_this.$store.state.barpin.header.id_aju);
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    getData: 'barpin/getData',
    getKontainer: 'barpin/getKontainer',
    getBarang: 'barpin/getBarang',
    getCatatan: 'barpin/getCatatan'
  }))
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFilePpftz_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_939c914e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListFilePpftz_vue__ = __webpack_require__(386);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFilePpftz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_939c914e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListFilePpftz_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Identitas (KTP/NPWP/SIM)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_identitas))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_identitas_penerima) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_identitas_penerima))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.fl_kuasa) ? _c('tr', [_c('td', [_vm._v("Identitas Kuasa (KTP/NPWP/SIM)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_identitas_kuasa))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_identitas_pengirim) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_identitas_pengirim))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_c('td', [_vm._v("Nomor STNK")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_stnk))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_stnk))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_stnk) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_stnk))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_c('td', [_vm._v("Nomor BPKB")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_bpkb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_bpkb))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_bpkb) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_bpkb))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Kartu Keluarga")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_kk))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_kk) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_kk))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Pindah Dukcapil")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_dukcapil))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_dukcapil))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_dukcapil) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_dukcapil))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Keterangan Mutasi/lainnya")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_surat_pindah))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_pindah))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pindah) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pindah))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.barpin.header.fl_kuasa) ? _c('tr', [_c('td', [_vm._v("Surat Kuasa")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_surat_kuasa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_surat_kuasa))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_kuasa) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_kuasa))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Surat Pernyataan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_surat_pernyataan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_surat_pernyataan))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pernyataan) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pernyataan))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '1') ? _c('tr', [_c('td', [_vm._v("Surat Rekomendasi BP")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_surat_rekombp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_surat_rekombp))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_rekombp) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_rekombp))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Packing List")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_pl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_pl))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_pl) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_pl))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.header.jns_aju === '2') ? _c('tr', [_c('td', [_vm._v("Bukti Bayar")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.no_ntpn))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.barpin.header.tgl_ntpn))]), _vm._v(" "), _c('td', [(this.$store.state.barpin.files.file_ntpn) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": ((this.$http.options.base) + "/file/ppftz/" + (this.$route.params.id) + "/" + (this.$store.state.barpin.files.file_ntpn))
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("File Upload")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header": "Detil PPFTZ"
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-catatan",
      modifiers: {
        "modal-catatan": true
      }
    }],
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.getCatatan(_vm.$store.state.barpin.header.id_aju)
      }
    }
  }, [_vm._v("\n      Catatan "), _c('i', {
    staticClass: "fa fa-bars"
  })])], 1), _vm._v(" "), _c('h3', [_vm._v("Header")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, _vm._l((this.$store.state.barpin.header), function(value, key) {
    return _c('tr', [_vm._l((_vm.headers), function(header) {
      return [(key === header.value) ? [_c('td', {
        staticClass: "bold",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(header.text))]), _vm._v(" "), _c('td', [_vm._v("\n                :\n                "), (key === 'jns_aju') ? [_vm._v("\n                  " + _vm._s(value === '1' ? 'Barang Pindahan' : (value === '2' ? 'Kendaraan Bermotor' : '')) + "\n                ")] : [_vm._v(_vm._s(value))]], 2)] : _vm._e()]
    })], 2)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, _vm._l((this.$store.state.barpin.header), function(value, key) {
    return _c('tr', [_vm._l((_vm.headers2), function(header) {
      return [(key === header.value) ? [_c('td', {
        staticClass: "bold",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(header.text))]), _vm._v(" "), _c('td', [_vm._v(": "), (key === 'pel_muat') ? [_vm._v("\n                  " + _vm._s(value + ' - ' + _vm.$store.state.barpin.header.ref_pel_muat.NM_LOKASI) + "\n                ")] : _vm._e(), _vm._v(" "), (key === 'pel_tujuan') ? [_vm._v("\n                  " + _vm._s(value + ' - ' + _vm.$store.state.barpin.header.ref_pel_tujuan.NM_LOKASI) + "\n                ")] : [_vm._v(_vm._s(value))]], 2)] : _vm._e()]
    })], 2)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, _vm._l((this.$store.state.barpin.header), function(value, key) {
    return _c('tr', [_vm._l((_vm.headers3), function(header) {
      return [(key === header.value) ? [_c('td', {
        staticClass: "bold",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(header.text))]), _vm._v(" "), _c('td', [_vm._v(": " + _vm._s(value))])] : _vm._e()]
    })], 2)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, _vm._l((this.$store.state.barpin.header), function(value, key) {
    return _c('tr', [_vm._l((_vm.headers4), function(header) {
      return [(key === header.value) ? [_c('td', {
        staticClass: "bold",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(header.text))]), _vm._v(" "), _c('td', [_vm._v(": " + _vm._s(value))])] : _vm._e()]
    })], 2)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', [_c('h3', [_vm._v("File Upload")]), _vm._v(" "), _c('ListFilePpftz')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [(_vm.$store.state.barpin.kontainer.length) ? _c('div', [_c('h3', [_vm._v("Kontainer")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nomor Kontainer")]), _vm._v(" "), _c('th', [_vm._v("Ukuran/Jenis Kontainer")])])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.kontainer), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.NO_KONTAINER))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((item.UKURAN_KONTAINER) + " / " + (item.JNS_KONTAINER))))])])
  }))])]) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.barpin.barang.length) ? _c('div', [_c('h3', [_vm._v("Barang")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-responsive mt-3"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nama Barang")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Jumlah Barang")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nilai Barang")]), _vm._v(" "), _c('th', [_vm._v("Nilai BM")]), _vm._v(" "), _c('th', [_vm._v("Nilai PPN")]), _vm._v(" "), _c('th', [_vm._v("Nilai Pph")])])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.barang), function(item, index) {
    return _c('tr', {
      key: item.URAIAN_BARANG
    }, [_c('td', [_vm._v(_vm._s(item.URAIAN_BARANG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((item.JML_SATUAN) + " " + (item.JNS_SATUAN) + " / " + (item.JML_KEMASAN) + " " + (item.JNS_KEMASAN) + " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.CIF.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.NILAI_BM == null ? '' : item.NILAI_BM.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.NILAI_PPN == null ? '' : item.NILAI_PPN.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.NILAI_PPH == null ? '' : item.NILAI_PPH.toLocaleString()))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/ppftz/browse"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Kembali\n      ")])], 1)], 1), _vm._v(" "), _c('modal-catatan')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormTransitNew_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75585bb6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_FormTransitNew_vue__ = __webpack_require__(390);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormTransitNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75585bb6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_FormTransitNew_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModelListSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["ModelListSelect"],
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      headerTransit: {
        namaPemberitahu: '',
        jenisIdPemberitahu: '',
        idPemberitahu: '',
        alamatPemberitahu: '',
        pekerjaanPemberitahu: '',
        noTelpPemberitahu: '',
        namaSponsor: '',
        jenisIdSponsor: '',
        idSponsor: '',
        alamatSponsor: '',
        pekerjaanSponsor: '',
        noTelpSponsor: '',
        jenisPemasukan: '',
        tujuanPemasukan: '',
        tujuanPemasukanLainnya: '',
        lokasiPenggunaan: '',
        asalBarang: '',
        perkiraanTanggalKeluar: '',
        namaSarkut: '',
        nomorSarkut: '',
        pelMasuk: '',
        pelKeluar: '',
        tanggalDatang: '',
        tableDetail: [],
        tableDokung: [],
        recaptchaToken: '',
        jenisTransit: 'Barang Penumpang'
      },
      detailTransit: {
        uraianBarang: '',
        typeMerk: '',
        noSeri: '',
        jumlahBarang: '',
        satuanBarang: '',
        harga: '',
        keterangan: ''
      },
      detailDokung: {
        jenisDokumen: '',
        nomorDokumen: '',
        tanggalDokumen: ''
      },
      refSarkut: [],
      tambahRefSarkut: {
        nama: ''
      },
      modalRefSarkut: false,
      refKota: [],
      editedIndex: -1,
      editedDokung: {
        jenisDokumen: '',
        nomorDokumen: '',
        tanggalDokumen: ''
      },
      modalPersetujuan: false,
      refSatuan: [],
      isLoading: false,
      sitekey: '6LfnWwIqAAAAANCiVDEj6w0E6IzsYRw7_6Kg3IZd'
    };
  },

  methods: {
    submitAll: function submitAll() {
      var _this = this;

      this.isLoading = true;
      if (this.headerTransit.recaptchaToken) {
        this.$http.post('storeTransit', this.headerTransit).then(function (response) {
          _this.isLoading = false;
          _this.$router.push('/resulttransit/' + response.data.kd_regis);
        });
      }
    },
    submitDokung: function submitDokung() {
      this.headerTransit.tableDokung.push({
        jenisDokumen: this.detailDokung.jenisDokumen,
        nomorDokumen: this.detailDokung.nomorDokumen,
        tanggalDokumen: this.detailDokung.tanggalDokumen
      });
      this.cleanFormDokung();
    },
    cleanFormDokung: function cleanFormDokung() {
      this.detailDokung.jenisDokumen = '';
      this.detailDokung.nomorDokumen = '';
      this.detailDokung.tanggalDokumen = '';
    },
    loadNamaSarkut: function loadNamaSarkut() {
      var _this2 = this;

      this.$http.get('transit/load/namaSarkut').then(function (response) {
        _this2.refSarkut = response.data;
      });
    },
    editDokung: function editDokung(index) {
      this.$refs['collapse-edit-dokumen ' + index][0].toggle();

      this.editedDokung.jenisDokumen = this.headerTransit.tableDokung[index].jenisDokumen;
      this.editedDokung.nomorDokumen = this.headerTransit.tableDokung[index].nomorDokumen;
      this.editedDokung.tanggalDokumen = this.headerTransit.tableDokung[index].tanggalDokumen;
    },
    saveEditDokung: function saveEditDokung(index) {
      if (this.editedDokung.jenisDokumen !== '') {
        this.headerTransit.tableDokung[index].jenisDokumen = this.editedDokung.jenisDokumen;
      }

      if (this.editedDokung.nomorDokumen !== '') {
        this.headerTransit.tableDokung[index].nomorDokumen = this.editedDokung.nomorDokumen;
      }

      if (this.editedDokung.tanggalDokumen !== '') {
        this.headerTransit.tableDokung[index].tanggalDokumen = this.editedDokung.tanggalDokumen;
      }
    },
    deleteDokung: function deleteDokung(index) {
      this.headerTransit.tableDokung.splice(index, 1);
    },
    deleteAllDokumen: function deleteAllDokumen(index) {
      this.headerTransit.tableDokung.splice(index);
    },
    submitGoods: function submitGoods() {
      this.headerTransit.tableDetail.push({
        uraianBarang: this.detailTransit.uraianBarang,
        typeMerk: this.detailTransit.typeMerk,
        noSeri: this.detailTransit.noSeri,
        jumlahBarang: this.detailTransit.jumlahBarang,
        satuanBarang: this.detailTransit.satuanBarang,
        harga: this.detailTransit.harga,
        keterangan: this.detailTransit.keterangan
      });
      this.clearFieldGoods();
    },
    clearFieldGoods: function clearFieldGoods() {
      this.detailTransit.uraianBarang = '';
      this.detailTransit.typeMerk = '';
      this.detailTransit.noSeri = '';
      this.detailTransit.jumlahBarang = '';
      this.detailTransit.satuanBarang = '';
      this.detailTransit.harga = '';
      this.detailTransit.keterangan = '';
    },
    deleteGood: function deleteGood(index) {
      this.headerTransit.tableDetail.splice(index, 1);
    },
    deleteAllGood: function deleteAllGood(index) {
      this.headerTransit.tableDetail.splice(index);
    },
    saveEditBarang: function saveEditBarang(index) {
      if (this.detailTransit.uraianBarang !== '') {
        this.headerTransit.tableDetail[index].uraianBarang = this.detailTransit.uraianBarang;
      }
      if (this.detailTransit.typeMerk !== '') {
        this.headerTransit.tableDetail[index].typeMerk = this.detailTransit.typeMerk;
      }
      if (this.detailTransit.noSeri !== '') {
        this.headerTransit.tableDetail[index].noSeri = this.detailTransit.noSeri;
      }
      if (this.detailTransit.jumlahBarang !== '') {
        this.headerTransit.tableDetail[index].jumlahBarang = this.detailTransit.jumlahBarang;
      }
      if (this.detailTransit.satuanBarang !== '') {
        this.headerTransit.tableDetail[index].satuanBarang = this.detailTransit.satuanBarang;
      }
      if (this.detailTransit.harga !== '') {
        this.headerTransit.tableDetail[index].harga = this.detailTransit.harga;
      }
      if (this.detailTransit.keterangan !== '') {
        this.headerTransit.tableDetail[index].keterangan = this.detailTransit.keterangan;
      }
    },
    cekSubmitAll: function cekSubmitAll() {
      var _this3 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (_this3.headerTransit.tableDetail.length > 0) {
            _this3.modalPersetujuan = true;
          } else {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', 'Barang Masih Kosong', 'error');
          }
        }
      });
    },
    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      this.headerTransit.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.headerTransit.recaptchaToken = '';
    },
    loadRefSatuan: function loadRefSatuan() {
      var _this4 = this;

      this.$http.get('transit/ref/jnsatuan').then(function (response) {
        _this4.refSatuan = response.data;
      });
    }
  },
  created: function created() {
    this.loadNamaSarkut();
    this.loadRefSatuan();
  },

  computed: {
    formattedJenisSatuan: function formattedJenisSatuan() {
      return this.refSatuan.map(function (item) {
        return {
          value: item.UR_SAT,
          text: item.JNS_SAT + ' - ' + item.UR_SAT
        };
      });
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<h3><i class='fa fa-pencil-square-o'></i> <strong>Form</strong> Pembawaan Barang Asal TLDDP</h3>"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-user'></i> Data Pemberitahu"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Lengkap"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.namaPemberitahu),
      expression: "headerTransit.namaPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nama Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.namaPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.namaPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Pemberitahu')),
      expression: "errors.has('Nama Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nama Pemberitahu')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jenisIdPemberitahu),
      expression: "headerTransit.jenisIdPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Identitas Pemberitahu",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.jenisIdPemberitahu = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NPWP"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KTP"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Paspor"
    }
  }, [_vm._v("Paspor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lainnya"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Identitas Pemberitahu')),
      expression: "errors.has('Jenis Identitas Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Identitas Pemberitahu')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.idPemberitahu),
      expression: "headerTransit.idPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.headerTransit.jenisIdPemberitahu === 'NPWP' ? 'required|min:16' : 'required'),
      expression: "headerTransit.jenisIdPemberitahu === 'NPWP' ? 'required|min:16' : 'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Identitas Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.idPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.idPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas Pemberitahu')),
      expression: "errors.has('Nomor Identitas Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas Pemberitahu')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.alamatPemberitahu),
      expression: "headerTransit.alamatPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Alamat Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.alamatPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.alamatPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat Pemberitahu')),
      expression: "errors.has('Alamat Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Alamat Pemberitahu')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pekerjaan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pekerjaanPemberitahu),
      expression: "headerTransit.pekerjaanPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Pekerjaan Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.pekerjaanPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.pekerjaanPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pekerjaan Pemberitahu')),
      expression: "errors.has('Pekerjaan Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pekerjaan Pemberitahu')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Telepon"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.noTelpPemberitahu),
      expression: "headerTransit.noTelpPemberitahu"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Telepon Pemberitahu"
    },
    domProps: {
      "value": (_vm.headerTransit.noTelpPemberitahu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.noTelpPemberitahu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Telepon Pemberitahu')),
      expression: "errors.has('Nomor Telepon Pemberitahu')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Telepon Pemberitahu')))])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-user'></i> Data Sponsor"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Lengkap"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.namaSponsor),
      expression: "headerTransit.namaSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nama Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.namaSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.namaSponsor = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jenisIdSponsor),
      expression: "headerTransit.jenisIdSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Identitas Sponsor",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.jenisIdSponsor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NPWP"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KTP"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Paspor"
    }
  }, [_vm._v("Paspor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lainnya"
    }
  }, [_vm._v("Lainnya")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.idSponsor),
      expression: "headerTransit.idSponsor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.headerTransit.jenisIdSponsor === 'NPWP' ? 'min:16' : ''),
      expression: "headerTransit.jenisIdSponsor === 'NPWP' ? 'min:16' : ''"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Identitas Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.idSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.idSponsor = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas Sponsor')),
      expression: "errors.has('Nomor Identitas Sponsor')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas Sponsor')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Alamat"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.alamatSponsor),
      expression: "headerTransit.alamatSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Alamat Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.alamatSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.alamatSponsor = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pekerjaan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pekerjaanSponsor),
      expression: "headerTransit.pekerjaanSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Pekerjaan Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.pekerjaanSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.pekerjaanSponsor = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Telepon"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.noTelpSponsor),
      expression: "headerTransit.noTelpSponsor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Telepon Sponsor"
    },
    domProps: {
      "value": (_vm.headerTransit.noTelpSponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.noTelpSponsor = $event.target.value
      }
    }
  })])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-archive'></i> Data Penggunaan Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Pemasukan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jenisPemasukan),
      expression: "headerTransit.jenisPemasukan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Pemasukan",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.jenisPemasukan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Barang Bawaan Penumpang"
    }
  }, [_vm._v("Melalui Kawasan Bebas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Barang Awak Sarana Pengangkut"
    }
  }, [_vm._v("Sementara")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Pemasukan')),
      expression: "errors.has('Jenis Pemasukan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Pemasukan')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tujuan Pemasukan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.tujuanPemasukan),
      expression: "headerTransit.tujuanPemasukan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tujuan Pemasukan",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.tujuanPemasukan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transit"
    }
  }, [_vm._v("Transit")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Perbaikan/rekondisi/pengujian/kalibrasi"
    }
  }, [_vm._v("Perbaikan/rekondisi/pengujian/kalibrasi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Sewa menyewa"
    }
  }, [_vm._v("Sewa menyewa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pameran/peragaan/demonstrasi"
    }
  }, [_vm._v("Pameran/peragaan/demonstrasi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pertunjukan umum/olah raga/perlombaan"
    }
  }, [_vm._v("Pertunjukan umum/olah raga/perlombaan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Keperluan contoh/model"
    }
  }, [_vm._v("Keperluan contoh/model")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Keperluan profesional/tenaga ahli"
    }
  }, [_vm._v("Keperluan profesional/tenaga ahli")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lainnya"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tujuan Pemasukan')),
      expression: "errors.has('Tujuan Pemasukan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Tujuan Pemasukan')))])])], 1)]), _vm._v(" "), (_vm.headerTransit.tujuanPemasukan == 'Lainnya') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tujuan Pemasukan Lainnya"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.tujuanPemasukanLainnya),
      expression: "headerTransit.tujuanPemasukanLainnya"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.headerTransit.tujuanPemasukanLainnya)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.tujuanPemasukanLainnya = $event.target.value
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Lokasi Penggunaan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.lokasiPenggunaan),
      expression: "headerTransit.lokasiPenggunaan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Lokasi Penggunaan"
    },
    domProps: {
      "value": (_vm.headerTransit.lokasiPenggunaan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.lokasiPenggunaan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Lokasi Penggunaan')),
      expression: "errors.has('Lokasi Penggunaan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Lokasi Penggunaan')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Asal Barang"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.asalBarang),
      expression: "headerTransit.asalBarang"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Asal Barang",
      "placeholder": "Contoh: Surabaya"
    },
    domProps: {
      "value": (_vm.headerTransit.asalBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.asalBarang = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Asal Barang')),
      expression: "errors.has('Asal Barang')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Asal Barang')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Perkiraan Tanggal Keluar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.perkiraanTanggalKeluar),
      expression: "headerTransit.perkiraanTanggalKeluar"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "Perkiraan Tanggal Keluar"
    },
    domProps: {
      "value": (_vm.headerTransit.perkiraanTanggalKeluar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.perkiraanTanggalKeluar = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Perkiraan Tanggal Keluar')),
      expression: "errors.has('Perkiraan Tanggal Keluar')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Perkiraan Tanggal Keluar')))])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-plane'></i> Data Pengangkut"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Sarana Pengangkut"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "list": _vm.refSarkut,
      "option-value": "nama_sarkut",
      "option-text": "nama_sarkut",
      "placeholder": "-- Pilih Nama Sarana Pengangkut --"
    },
    model: {
      value: (_vm.headerTransit.namaSarkut),
      callback: function($$v) {
        _vm.headerTransit.namaSarkut = $$v
      },
      expression: "headerTransit.namaSarkut"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Sarana Pengangkut')),
      expression: "errors.has('Nama Sarana Pengangkut')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nama Sarana Pengangkut')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Sarana Pengangkut"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.nomorSarkut),
      expression: "headerTransit.nomorSarkut"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Nomor Sarana Pengangkut"
    },
    domProps: {
      "value": (_vm.headerTransit.nomorSarkut)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.nomorSarkut = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Sarana Pengangkut')),
      expression: "errors.has('Nomor Sarana Pengangkut')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Sarana Pengangkut')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Masuk"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pelMasuk),
      expression: "headerTransit.pelMasuk"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Pelabuhan Masuk",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.pelMasuk = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batu Ampar"
    }
  }, [_vm._v("Batu Ampar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Warehouse Hang Nadim"
    }
  }, [_vm._v("Warehouse Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminal Hang Nadim"
    }
  }, [_vm._v("Terminal Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Telaga Punggur"
    }
  }, [_vm._v("Telaga Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Roro Punggur"
    }
  }, [_vm._v("Roro Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Domestik Sekupang"
    }
  }, [_vm._v("Domestik Sekupang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Harbour Bay"
    }
  }, [_vm._v("Harbour Bay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nongsa Pura"
    }
  }, [_vm._v("Nongsa Pura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batam Center"
    }
  }, [_vm._v("Batam Center")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pelabuhan Masuk')),
      expression: "errors.has('Pelabuhan Masuk')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pelabuhan Masuk')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Keluar"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pelKeluar),
      expression: "headerTransit.pelKeluar"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Pelabuhan Keluar",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.pelKeluar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batu Ampar"
    }
  }, [_vm._v("Batu Ampar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Warehouse Hang Nadim"
    }
  }, [_vm._v("Warehouse Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminal Hang Nadim"
    }
  }, [_vm._v("Terminal Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Telaga Punggur"
    }
  }, [_vm._v("Telaga Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Roro Punggur"
    }
  }, [_vm._v("Roro Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Domestik Sekupang"
    }
  }, [_vm._v("Domestik Sekupang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Harbour Bay"
    }
  }, [_vm._v("Harbour Bay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nongsa Pura"
    }
  }, [_vm._v("Nongsa Pura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batam Center"
    }
  }, [_vm._v("Batam Center")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pelabuhan Keluar')),
      expression: "errors.has('Pelabuhan Keluar')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pelabuhan Keluar')) + "\">")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Kedatangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.tanggalDatang),
      expression: "headerTransit.tanggalDatang"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "Tanggal Kedatangan"
    },
    domProps: {
      "value": (_vm.headerTransit.tanggalDatang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.tanggalDatang = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal Kedatangan')),
      expression: "errors.has('Tanggal Kedatangan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Tanggal Kedatangan')) + "\">")])])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Dokumen Pendukung"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v("List Dokumen Pendukung")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteAllDokumen
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" Delete All")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-dokumen",
      modifiers: {
        "collapse-add-dokumen": true
      }
    }],
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4 mx-2"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Jenis Dokumen")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Nomor Dokumen")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Tanggal Dokumen")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": ""
    }
  }, [_vm._v("Aksi/Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.headerTransit.tableDokung), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.jenisDokumen))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.nomorDokumen))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tanggalDokumen))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteDokung(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "edit"
      },
      on: {
        "click": function($event) {
          _vm.editDokung(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])])])
  }))])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mx-2",
    attrs: {
      "id": "collapse-add-dokumen"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-edit'></i> Tambah Dokumen Pendukung"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen Pendukung"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailDokung.jenisDokumen),
      expression: "detailDokung.jenisDokumen"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Dokumen Pendukung",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.detailDokung.jenisDokumen = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Invoice"
    }
  }, [_vm._v("Invoice")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Packing List"
    }
  }, [_vm._v("Packing List")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Purchase Order"
    }
  }, [_vm._v("Purchase Order")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kontrak"
    }
  }, [_vm._v("Kontrak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Flyer"
    }
  }, [_vm._v("Flyer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lainnya"
    }
  }, [_vm._v("Lainnya")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Dokumen"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailDokung.nomorDokumen),
      expression: "detailDokung.nomorDokumen"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailDokung.nomorDokumen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailDokung.nomorDokumen = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Dokumen"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailDokung.tanggalDokumen),
      expression: "detailDokung.tanggalDokumen"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.detailDokung.tanggalDokumen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailDokung.tanggalDokumen = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-dokumen",
      modifiers: {
        "collapse-add-dokumen": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submitDokung
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-dokumen",
      modifiers: {
        "collapse-add-dokumen": true
      }
    }],
    staticClass: "btn btn-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])])])])], 1), _vm._v(" "), _vm._l((_vm.headerTransit.tableDokung), function(data, index) {
    return _c('b-collapse', {
      key: index,
      ref: ("collapse-edit-dokumen " + index),
      refInFor: true,
      staticClass: "mx-2",
      attrs: {
        "id": ("collapse-edit-dokumen " + index)
      }
    }, [_c('b-card', {
      attrs: {
        "header": ("<i class='fa fa-edit'></i> Edit Dokumen Pendukung " + (index+1))
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Jenis Dokumen Pendukung"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editedDokung.jenisDokumen),
        expression: "editedDokung.jenisDokumen"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "Jenis Dokumen Pendukung"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.editedDokung.jenisDokumen = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Invoice"
      }
    }, [_vm._v("Invoice")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Packing List"
      }
    }, [_vm._v("Packing List")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Purchase Order"
      }
    }, [_vm._v("Purchase Order")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Kontrak"
      }
    }, [_vm._v("Kontrak")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Flyer"
      }
    }, [_vm._v("Flyer")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Lainnya"
      }
    }, [_vm._v("Lainnya")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nomor Dokumen"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editedDokung.nomorDokumen),
        expression: "editedDokung.nomorDokumen"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.editedDokung.nomorDokumen)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editedDokung.nomorDokumen = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Tanggal Dokumen"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editedDokung.tanggalDokumen),
        expression: "editedDokung.tanggalDokumen"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (_vm.editedDokung.tanggalDokumen)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editedDokung.tanggalDokumen = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row mt-2"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-dokumen " + index)),
        expression: "`collapse-edit-dokumen ${index}`"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.saveEditDokung(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save"
    }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-dokumen " + index)),
        expression: "`collapse-edit-dokumen ${index}`"
      }],
      staticClass: "btn btn-danger"
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Cancel")])])])])])], 1)
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-archive'></i> Data Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v("List Data Barang")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteAllGood
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" Delete All")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-barang",
      modifiers: {
        "collapse-add-barang": true
      }
    }],
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 mx-2"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%",
      "scope": "col"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "",
      "scope": "col"
    }
  }, [_vm._v("Uraian Barang / "), _c('i', [_vm._v("Description of Goods")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("Type/Merk / "), _c('i', [_vm._v("Type/Brand")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("Harga / "), _c('i', [_vm._v("Price")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("No. Seri / "), _c('i', [_vm._v("Serial Number")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%",
      "scope": "col"
    }
  }, [_vm._v("Jumlah / "), _c('i', [_vm._v("Amount")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%",
      "scope": "col"
    }
  }, [_vm._v("Keterangan / "), _c('i', [_vm._v("information")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "9%",
      "scope": "col"
    }
  }, [_vm._v("Aksi / "), _c('i', [_vm._v("Action")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.headerTransit.tableDetail), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.uraianBarang) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.typeMerk) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.harga) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.noSeri) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.jumlahBarang) + " " + _vm._s(data.satuanBarang) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.keterangan) + " ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteGood(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-barang " + index)),
        expression: "`collapse-edit-barang ${index}`"
      }],
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "edit"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])])])
  }))])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mx-2",
    attrs: {
      "id": "collapse-add-barang"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-edit'></i> Tambah Data Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Uraian Barang"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.uraianBarang),
      expression: "detailTransit.uraianBarang"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailTransit.uraianBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.uraianBarang = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Type/Merk"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.typeMerk),
      expression: "detailTransit.typeMerk"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailTransit.typeMerk)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.typeMerk = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Harga"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.harga),
      expression: "detailTransit.harga"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.detailTransit.harga)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.harga = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Seri"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.noSeri),
      expression: "detailTransit.noSeri"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailTransit.noSeri)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.noSeri = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Barang"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.jumlahBarang),
      expression: "detailTransit.jumlahBarang"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.detailTransit.jumlahBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.jumlahBarang = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Satuan Barang"
    }
  }, [_c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "list": _vm.formattedJenisSatuan,
      "option-value": "value",
      "option-text": "text"
    },
    model: {
      value: (_vm.detailTransit.satuanBarang),
      callback: function($$v) {
        _vm.detailTransit.satuanBarang = $$v
      },
      expression: "detailTransit.satuanBarang"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.keterangan),
      expression: "detailTransit.keterangan"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.detailTransit.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.keterangan = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-barang",
      modifiers: {
        "collapse-add-barang": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submitGoods
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add-barang",
      modifiers: {
        "collapse-add-barang": true
      }
    }],
    staticClass: "btn btn-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])])])])], 1), _vm._v(" "), _vm._l((_vm.headerTransit.tableDetail), function(data, index) {
    return _c('b-collapse', {
      key: index,
      staticClass: "mt-2",
      attrs: {
        "id": ("collapse-edit-barang " + index)
      }
    }, [_c('b-card', {
      attrs: {
        "header": ("<i class='fa fa-edit'></i> Edit Barang " + (index+1) + " ")
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Uraian Barang"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.uraianBarang),
        expression: "detailTransit.uraianBarang"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.uraianBarang
      },
      domProps: {
        "value": (_vm.detailTransit.uraianBarang)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.uraianBarang = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Type / Merk"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.typeMerk),
        expression: "detailTransit.typeMerk"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.typeMerk
      },
      domProps: {
        "value": (_vm.detailTransit.typeMerk)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.typeMerk = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Harga"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.harga),
        expression: "detailTransit.harga"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.harga,
        "min": "0",
        "type": "number"
      },
      domProps: {
        "value": (_vm.detailTransit.harga)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.harga = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row mt-3"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nomor Seri"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.noSeri),
        expression: "detailTransit.noSeri"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.noSeri
      },
      domProps: {
        "value": (_vm.detailTransit.noSeri)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.noSeri = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Jumlah Barang"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.jumlahBarang),
        expression: "detailTransit.jumlahBarang"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.jumlahBarang
      },
      domProps: {
        "value": (_vm.detailTransit.jumlahBarang)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.jumlahBarang = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Satuan Barang"
      }
    }, [_c('model-list-select', {
      staticClass: "form-control",
      attrs: {
        "list": _vm.formattedJenisSatuan,
        "option-value": "value",
        "option-text": "text",
        "placeholder": data.satuanBarang
      },
      model: {
        value: (_vm.detailTransit.satuanBarang),
        callback: function($$v) {
          _vm.detailTransit.satuanBarang = $$v
        },
        expression: "detailTransit.satuanBarang"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Keterangan"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.keterangan),
        expression: "detailTransit.keterangan"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.keterangan,
        "type": "text"
      },
      domProps: {
        "value": (_vm.detailTransit.keterangan)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.keterangan = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 pull-right"
    }, [_c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-barang " + index)),
        expression: "`collapse-edit-barang ${index}`"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.saveEditBarang(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save"
    }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit-barang " + index)),
        expression: "`collapse-edit-barang ${index}`"
      }],
      staticClass: "btn btn-danger"
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Cancel")])])])], 1)
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": '/login'
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg pull-right",
    on: {
      "click": _vm.cekSubmitAll
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v("\n                        Send")])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Persetujuan"
    },
    on: {
      "ok": function($event) {
        _vm.modalPersetujuan = false
      }
    },
    model: {
      value: (_vm.modalPersetujuan),
      callback: function($$v) {
        _vm.modalPersetujuan = $$v
      },
      expression: "modalPersetujuan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n                        Saya menyatakan bahwa data yang disampaikan adalah benar\n                        dan saya bertanggung jawab atas kebenaran data/dokumen yang disampaikan\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block btn-lg",
    on: {
      "click": function($event) {
        _vm.submitAll()
      }
    }
  }, [_vm._v("Kirim")])])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormTransitA_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27359d12_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_FormTransitA_vue__ = __webpack_require__(393);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormTransitA_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27359d12_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_FormTransitA_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headerTransit: {
        namaLengkap: '',
        noIdentitas: '',
        alamat: '',
        pekerjaan: '',
        namaSarkut: '',
        noBl: '',
        pelKedatangan: '',
        pelKeberangkatan: '',
        jenisTransit: 'Barang Kiriman',
        tglPerkiraan: '',
        jumlahKemasan: '',
        jenisKemasan: '',
        kotaAsal: '',
        kotaTujuan: '',
        namaKurir: '',
        tableDetail: []
      },
      detailTransit: {
        uraianBarang: '',
        typeMerk: '',
        noSeri: '',
        jumlahBarang: '',
        satuanBarang: '',
        berat: '',
        noSmu: '',
        namaPesawat: '',
        noPenerbangan: ''
      },
      pelTransit: [],
      dataPerusahaan: [],
      idPerusahaan: [],
      getKode: '',
      refKota: [],
      refSarkut: [],
      tambahRefSarkut: {
        nama: ''
      },
      refKemasan: [],
      modalRefSarkut: false
    };
  },
  created: function created() {
    this.loadPerusahaan();
    this.loadKota();
    this.loadNamaSarkut();
    this.loadKemasan();
  },

  methods: {
    submitAll: function submitAll() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$http.post('storeTransit', _this.headerTransit).then(function (response) {
            _this.$router.push('/resulttransit/' + response.data.kd_regis);
          });
        }
      });
    },
    submitGoods: function submitGoods() {
      this.headerTransit.tableDetail.push({
        noSmu: this.detailTransit.noSmu,
        uraianBarang: this.detailTransit.uraianBarang,
        typeMerk: this.detailTransit.typeMerk,
        noSeri: this.detailTransit.noSeri,
        jumlahBarang: this.detailTransit.jumlahBarang,
        satuanBarang: this.detailTransit.satuanBarang,
        berat: this.detailTransit.berat,
        namaPesawat: this.detailTransit.namaPesawat,
        noPenerbangan: this.detailTransit.noPenerbangan
      });
      this.clearField();
    },
    deleteGoods: function deleteGoods(index) {
      this.headerTransit.tableDetail.splice(index, 1);
    },
    deleteAll: function deleteAll(index) {
      this.headerTransit.tableDetail.splice(index);
    },
    clearField: function clearField() {
      this.detailTransit.noSmu = '';
      this.detailTransit.uraianBarang = '';
      this.detailTransit.typeMerk = '';
      this.detailTransit.noSeri = '';
      this.detailTransit.jumlahBarang = '';
      this.detailTransit.satuanBarang = '';
      this.detailTransit.berat = '';
      this.detailTransit.namaPesawat = '';
      this.detailTransit.noPenerbangan = '';
    },
    openForm: function openForm() {
      var inputs = document.getElementsByClassName('detail');
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].disabled = false;
      }
    },
    closeForm: function closeForm() {
      var inputs = document.getElementsByClassName('detail');
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].disabled = true;
      }
    },
    saveEdit: function saveEdit(index) {
      if (this.detailTransit.noSmu !== '') {
        this.headerTransit.tableDetail[index].noSmu = this.detailTransit.noSmu;
      }
      if (this.detailTransit.uraianBarang !== '') {
        this.headerTransit.tableDetail[index].uraianBarang = this.detailTransit.uraianBarang;
      }
      if (this.detailTransit.typeMerk !== '') {
        this.headerTransit.tableDetail[index].typeMerk = this.detailTransit.typeMerk;
      }
      if (this.detailTransit.noSeri !== '') {
        this.headerTransit.tableDetail[index].noSeri = this.detailTransit.noSeri;
      }
      if (this.detailTransit.jumlahBarang !== '') {
        this.headerTransit.tableDetail[index].jumlahBarang = this.detailTransit.jumlahBarang;
      }
      if (this.detailTransit.satuanBarang !== '') {
        this.headerTransit.tableDetail[index].satuanBarang = this.detailTransit.satuanBarang;
      }
      if (this.detailTransit.berat !== '') {
        this.headerTransit.tableDetail[index].berat = this.detailTransit.berat;
      }
      if (this.detailTransit.namaPesawat !== '') {
        this.headerTransit.tableDetail[index].namaPesawat = this.detailTransit.namaPesawat;
      }
      if (this.detailTransit.noPenerbangan !== '') {
        this.headerTransit.tableDetail[index].noPenerbangan = this.detailTransit.noPenerbangan;
      }
      this.clearField();
    },
    loadPelabuhan: function loadPelabuhan() {
      var _this2 = this;

      this.$http.get('pelTransit').then(function (response) {
        _this2.pelTransit = response.data;
      });
    },
    loadPerusahaan: function loadPerusahaan() {
      var _this3 = this;

      this.$http.get('transit/load/perusahaan').then(function (response) {
        _this3.dataPerusahaan = response.data;
      });
    },
    loadIdPerusahaan: function loadIdPerusahaan() {
      var _this4 = this;

      this.$http.get('transit/load/perusahaan/' + this.headerTransit.namaLengkap).then(function (response) {
        _this4.headerTransit.noIdentitas = response.data.ID_PERUSAHAAN;
        _this4.headerTransit.alamat = response.data.AL_PERUSAHAAN;
      });
    },
    loadKota: function loadKota() {
      var _this5 = this;

      this.$http.get('transit/load/kota').then(function (response) {
        _this5.refKota = response.data;
      });
    },
    loadNamaSarkut: function loadNamaSarkut() {
      var _this6 = this;

      this.$http.get('transit/load/namaSarkut').then(function (response) {
        _this6.refSarkut = response.data;
      });
    },
    addNamaSarkut: function addNamaSarkut() {
      var _this7 = this;

      if (this.tambahRefSarkut.nama !== '') {
        var data = {
          nama: this.tambahRefSarkut.nama.toUpperCase()
        };
        this.$http.post('transit/load/namaSarkut', data).then(function (response) {
          if (response) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()({
              title: 'SUCCESS',
              text: 'Data Berhasil Disimpan',
              icon: 'success',
              buttons: {
                Yes: 'Yes'
              }
            });
          }
          _this7.loadNamaSarkut();
        });
        this.modalRefSarkut = false;
        this.tambahRefSarkut.nama = '';
      } else {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()('error', 'ISIAN TIDAK BOLEH KOSONG', 'error');
      }
    },
    loadKemasan: function loadKemasan() {
      var _this8 = this;

      this.$http.get('transit/load/kemasan').then(function (response) {
        _this8.refKemasan = response.data;
      });
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "action": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b-card', [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-user'></i> Identitas Diri"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Ekspedisi"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.namaLengkap),
      expression: "headerTransit.namaLengkap"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Ekspedisi",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.namaLengkap = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadIdPerusahaan()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.dataPerusahaan), function(nama) {
    return _c('option', {
      domProps: {
        "value": nama.NAMA_PERUSAHAAN
      }
    }, [_vm._v(" " + _vm._s(nama.NAMA_PERUSAHAAN) + " ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Ekspedisi')),
      expression: "errors.has('Nama Ekspedisi')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nama Ekspedisi')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama Kurir"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.namaKurir),
      expression: "headerTransit.namaKurir"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Kurir",
      "type": "text"
    },
    domProps: {
      "value": (_vm.headerTransit.namaKurir)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.namaKurir = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Kurir')),
      expression: "errors.has('Nama Kurir')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nama Kurir')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Kota Asal"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.kotaAsal),
      expression: "headerTransit.kotaAsal"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Kota Asal",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.kotaAsal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.refKota), function(kota) {
    return _c('option', {
      domProps: {
        "value": kota.NAMA_KOTA
      }
    }, [_vm._v(" " + _vm._s(kota.NAMA_KOTA) + " ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Kota Asal')),
      expression: "errors.has('Kota Asal')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Kota Asal')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Kota Tujuan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.kotaTujuan),
      expression: "headerTransit.kotaTujuan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Kota Tujuan",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.kotaTujuan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.refKota), function(kota) {
    return _c('option', {
      domProps: {
        "value": kota.NAMA_KOTA
      }
    }, [_vm._v(" " + _vm._s(kota.NAMA_KOTA) + " ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Kota Tujuan')),
      expression: "errors.has('Kota Tujuan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Kota Tujuan')) + " ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Kedatangan"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pelKedatangan),
      expression: "headerTransit.pelKedatangan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "PelKedatanganForm",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.pelKedatangan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batu Ampar"
    }
  }, [_vm._v("Batu Ampar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Warehouse Hang Nadim"
    }
  }, [_vm._v("Warehouse Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminal Hang Nadim"
    }
  }, [_vm._v("Terminal Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Telaga Punggur"
    }
  }, [_vm._v("Telaga Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Roro Punggur"
    }
  }, [_vm._v("Roro Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Domestik Sekupang"
    }
  }, [_vm._v("Domestik Sekupang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Harbour Bay"
    }
  }, [_vm._v("Harbour Bay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nongsa Pura"
    }
  }, [_vm._v("Nongsa Pura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batam Center"
    }
  }, [_vm._v("Batam Center")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PelKedatanganForm')),
      expression: "errors.has('PelKedatanganForm')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('PelKedatanganForm')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Keberangkatan"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pelKeberangkatan),
      expression: "headerTransit.pelKeberangkatan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "PelKeberangkatanform",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.pelKeberangkatan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batu Ampar"
    }
  }, [_vm._v("Batu Ampar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Warehouse Hang Nadim"
    }
  }, [_vm._v("Warehouse Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminal Hang Nadim"
    }
  }, [_vm._v("Terminal Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Telaga Punggur"
    }
  }, [_vm._v("Telaga Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Roro Punggur"
    }
  }, [_vm._v("Roro Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Domestik Sekupang"
    }
  }, [_vm._v("Domestik Sekupang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Harbour Bay"
    }
  }, [_vm._v("Harbour Bay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nongsa Pura"
    }
  }, [_vm._v("Nongsa Pura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batam Center"
    }
  }, [_vm._v("Batam Center")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PelKeberangkatanform')),
      expression: "errors.has('PelKeberangkatanform')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('PelKeberangkatanform')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Perkiraan Pengeluaran"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.tglPerkiraan),
      expression: "headerTransit.tglPerkiraan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tanggal Perkiraan",
      "type": "date",
      "locale": "en"
    },
    domProps: {
      "value": (_vm.headerTransit.tglPerkiraan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.tglPerkiraan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal Perkiraan')),
      expression: "errors.has('Tanggal Perkiraan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Tanggal Perkiraan')) + " ")])])], 1)])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<i class='fa fa-cube'></i> Data Kemasan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jumlahKemasan),
      expression: "headerTransit.jumlahKemasan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jumlah Kemasan",
      "type": "number"
    },
    domProps: {
      "value": (_vm.headerTransit.jumlahKemasan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.jumlahKemasan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Jumlah Kemasan')) + " ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jenisKemasan),
      expression: "headerTransit.jenisKemasan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Kemasan",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.jenisKemasan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.refKemasan), function(kemasan) {
    return _c('option', {
      domProps: {
        "value": kemasan.JNS_KMS
      }
    }, [_vm._v(" " + _vm._s(kemasan.JNS_KMS) + " - " + _vm._s(kemasan.UR_KMS) + " ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Jenis Kemasan')) + " ")])])], 1)])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<i class='fa fa-cube'></i> Data Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v(" List Barang")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-left",
    on: {
      "click": _vm.deleteAll
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" Delete All")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add",
      modifiers: {
        "collapse-add": true
      }
    }],
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%",
      "scope": "col"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "",
      "scope": "col"
    }
  }, [_vm._v("Nama Pesawat")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("Nomor Penerbangan")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("Nomor SMU")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "9%",
      "scope": "col"
    }
  }, [_vm._v("Jumlah")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "9%",
      "scope": "col"
    }
  }, [_vm._v("Berat")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%%",
      "scope": "col"
    }
  }, [_vm._v("Aksi")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.headerTransit.tableDetail), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.namaPesawat) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.noPenerbangan) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.noSmu) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.jumlahBarang) + " " + _vm._s(data.satuanBarang) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.berat) + " kg ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "delete"
      },
      on: {
        "click": _vm.deleteGoods
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit " + index)),
        expression: "`collapse-edit ${index}`"
      }],
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "edit"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])])])
  }))])]), _vm._v(" "), _c('div', [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-add"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-edit'></i> Tambah Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-11"
  }, [_c('b-form-fieldset', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.namaPesawat),
      expression: "detailTransit.namaPesawat"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Sarkut",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.detailTransit.namaPesawat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nama Pesawat / Kapal")]), _vm._v(" "), _vm._l((_vm.refSarkut), function(nama) {
    return _c('option', {
      domProps: {
        "value": nama.nama_sarkut
      }
    }, [_vm._v(" " + _vm._s(nama.nama_sarkut) + " ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('b-form-fieldset', [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.tambah-kapal",
      modifiers: {
        "tambah-kapal": true
      }
    }],
    staticClass: "btn btn-success",
    attrs: {
      "title": "Tambah Nama Pesawat / Kapal"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.noPenerbangan),
      expression: "detailTransit.noPenerbangan"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nomor Penerbangan"
    },
    domProps: {
      "value": (_vm.detailTransit.noPenerbangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.noPenerbangan = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.noSmu),
      expression: "detailTransit.noSmu"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "No. SMU"
    },
    domProps: {
      "value": (_vm.detailTransit.noSmu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.noSmu = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.jumlahBarang),
      expression: "detailTransit.jumlahBarang"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Jumlah Barang"
    },
    domProps: {
      "value": (_vm.detailTransit.jumlahBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.jumlahBarang = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.satuanBarang),
      expression: "detailTransit.satuanBarang"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Satuan Barang"
    },
    domProps: {
      "value": (_vm.detailTransit.satuanBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.satuanBarang = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.berat),
      expression: "detailTransit.berat"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Berat (kg)"
    },
    domProps: {
      "value": (_vm.detailTransit.berat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.berat = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "mt-3 pull-right"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add",
      modifiers: {
        "collapse-add": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submitGoods
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add",
      modifiers: {
        "collapse-add": true
      }
    }],
    staticClass: "btn btn-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])])])])], 1)], 1), _vm._v(" "), _c('div', _vm._l((_vm.headerTransit.tableDetail), function(data, index) {
    return _c('b-collapse', {
      key: index,
      staticClass: "mt-2",
      attrs: {
        "id": ("collapse-edit " + index)
      }
    }, [_c('b-card', {
      attrs: {
        "header": ("<i class='fa fa-edit'></i> Edit Barang " + (index+1) + " ")
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nama Pesawat"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-11"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.namaPesawat),
        expression: "detailTransit.namaPesawat"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "Nama Sarkut",
        "id": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.detailTransit.namaPesawat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Nama Pesawat / Kapal")]), _vm._v(" "), _vm._l((_vm.refSarkut), function(nama) {
      return _c('option', {
        domProps: {
          "value": nama.nama_sarkut
        }
      }, [_vm._v(" " + _vm._s(nama.nama_sarkut) + " ")])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-1"
    }, [_c('b-form-fieldset', [_c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.tambah-kapal",
        modifiers: {
          "tambah-kapal": true
        }
      }],
      staticClass: "btn btn-success",
      attrs: {
        "title": "Tambah Nama Pesawat / Kapal"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])], 1)])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nomor Penerbangan"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.noPenerbangan),
        expression: "detailTransit.noPenerbangan"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": data.noPenerbangan,
        "type": "text"
      },
      domProps: {
        "value": (_vm.detailTransit.noPenerbangan)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.noPenerbangan = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row mt-3"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nomor SMU"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.noSmu),
        expression: "detailTransit.noSmu"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.noSmu
      },
      domProps: {
        "value": (_vm.detailTransit.noSmu)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.noSmu = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Jumlah Barang"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.jumlahBarang),
        expression: "detailTransit.jumlahBarang"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.jumlahBarang
      },
      domProps: {
        "value": (_vm.detailTransit.jumlahBarang)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.jumlahBarang = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Satuan Barang"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.satuanBarang),
        expression: "detailTransit.satuanBarang"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.satuanBarang,
        "type": "text"
      },
      domProps: {
        "value": (_vm.detailTransit.satuanBarang)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.satuanBarang = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Berat (kg)"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.berat),
        expression: "detailTransit.berat"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.berat
      },
      domProps: {
        "value": (_vm.detailTransit.berat)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.berat = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 pull-right"
    }, [_c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit " + index)),
        expression: "`collapse-edit ${index}`"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.saveEdit(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save"
    }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit " + index)),
        expression: "`collapse-edit ${index}`"
      }],
      staticClass: "btn btn-danger"
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Cancel")])])])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('router-link', {
    attrs: {
      "to": '/login'
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg pull-right",
    on: {
      "click": _vm.submitAll
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Send")])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "id": "tambah-kapal",
      "title": "Tambah Nama Pesawat / Kapal"
    },
    model: {
      value: (_vm.modalRefSarkut),
      callback: function($$v) {
        _vm.modalRefSarkut = $$v
      },
      expression: "modalRefSarkut"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Pesawat / Kapal"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tambahRefSarkut.nama),
      expression: "tambahRefSarkut.nama"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tambahRefSarkut.nama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tambahRefSarkut.nama = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right mt-2",
    on: {
      "click": function($event) {
        _vm.addNamaSarkut()
      }
    }
  }, [_vm._v("Tambah")])])], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "mt-2"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('strong', [_vm._v("Form")]), _vm._v(" Perizinan Barang Transit (Barang Kiriman)")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultTransit_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2e7201_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResultTransit_vue__ = __webpack_require__(396);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultTransit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2e7201_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResultTransit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      kodeRegis: ''
    };
  },

  methods: {
    getKode: function getKode() {
      var _this = this;

      this.$http.get('getKode/' + this.$route.params.id).then(function (response) {
        _this.kodeRegis = response.data;
      });
    }
  },
  created: function created() {
    this.getKode();
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "align-items-center"
  }, [_vm._v("Berikut Adalah Kode Registrasi Anda:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "align-items-center",
    staticStyle: {
      "font-family": "'Verdana'"
    }
  }, [_vm._v(" " + _vm._s(_vm.kodeRegis.kd_regis) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h6', {
    staticClass: "align-items-center"
  }, [_vm._v("Silahkan tunjukan kode diatas kepada petugas Bea dan Cukai di Terminal Kedatangan Anda")])])])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuTransit_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b522f82_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MenuTransit_vue__ = __webpack_require__(400);
function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuTransit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b522f82_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MenuTransit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      collapse: false,
      modelCollapse: '',
      kodeRegistrasi: ''
    };
  },

  methods: {
    openSearch: function openSearch() {
      if (this.collapse === true && this.modelCollapse === 'new') {
        this.collapse = true;
        this.modelCollapse = 'search';
      } else {
        this.collapse = !this.collapse;
        this.modelCollapse = 'search';
      }
    },
    openNew: function openNew() {
      if (this.collapse === true && this.modelCollapse === 'search') {
        this.collapse = true;
        this.modelCollapse = 'new';
      } else {
        this.collapse = !this.collapse;
        this.modelCollapse = 'new';
      }
    },
    routeToPenumpang: function routeToPenumpang() {
      this.$router.push('/formtransit');
    },
    getPdf: function getPdf() {
      var _this = this;

      this.$http.get('transit/getpdf/' + this.kodeRegistrasi).then(function (response) {
        if (response.data.status === 'error') {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert___default()(response.data.status, response.data.message, response.data.icon);
        } else {
          window.open(_this.$http.options.base + '/api/transit/viewpdf/' + response.data.id_transit);
        }
      });
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white",
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block mt-2",
    on: {
      "click": _vm.openSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n              Cari Permohonan\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block mt-2",
    on: {
      "click": _vm.openNew
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("\n              Ajukan Permohonan\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-collapse', {
    attrs: {
      "id": "collapse"
    },
    model: {
      value: (_vm.collapse),
      callback: function($$v) {
        _vm.collapse = $$v
      },
      expression: "collapse"
    }
  }, [(_vm.modelCollapse === 'search') ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kodeRegistrasi),
      expression: "kodeRegistrasi"
    }],
    staticClass: "form-control",
    staticStyle: {
      "font-size": "20px",
      "padding": "10px",
      "height": "50px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Masukkan Kode Registrasi"
    },
    domProps: {
      "value": (_vm.kodeRegistrasi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kodeRegistrasi = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-button"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.modelCollapse === 'new') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg btn-block",
    staticStyle: {
      "height": "100px"
    },
    on: {
      "click": _vm.routeToPenumpang
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                    Barang Bawaan Penumpang")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg btn-block",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "title": "konten belum tersedia",
      "disabled": ""
    }
  }, [_c('i', {}), _vm._v(" COMING SOON!!")])])]) : _vm._e()])], 1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\icon.jpeg",
      "width": "100%",
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Menu Transit")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2122faf4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_pengumuman_vue__ = __webpack_require__(403);
function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2122faf4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_pengumuman_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bungkus"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('a', {
    staticClass: "btn btn-block btn-info",
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.base + '/' + 'file' + '/' + 'pdf' + '/' + 'laporan2022.pdf'
    }
  }, [_vm._m(6)])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\logo-kementrian.jpeg",
      "width": "90%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 mt-5"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "color": "white"
    }
  }, [_vm._v("LAPORAN KINERJA KANTOR PELAYANAN UTAMA BEA DAN CUKAI TIPE B BATAM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\bea-cukai-squared.webp",
      "width": "90%"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\foto-kantor.jpeg",
      "width": "95%"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 justify-content-center"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "color": "white"
    }
  }, [_vm._v("UNDUH LAPORAN")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "70px"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down",
    staticStyle: {
      "color": "white"
    }
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("DOWNLOAD "), _c('i', {
    staticClass: "fa fa-download"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tfasetup_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b905392_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tfasetup_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b905392"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tfasetup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b905392_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tfasetup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      qr_code_url: '',
      otp_verification: '',
      errorMessage: null
    };
  },
  mounted: function mounted() {
    this.fetchQrCode();
  },

  methods: {
    fetchQrCode: function fetchQrCode() {
      var _this = this;

      this.$http.get('tfa/view-file-local/pj/' + localStorage.getItem('USER_NAME')).then(function (response) {
        if (response.data) {
          _this.qr_code_url = response.data.qr_code_url;
        }
      });
    },
    confirm: function confirm() {
      var _this2 = this;

      var data = {
        USER_NAME: localStorage.getItem('USER_NAME'),
        password: localStorage.getItem('password'),
        otp_verification: this.otp_verification
      };
      this.$http.post('tfa/confirm/pj', data).then(function (response) {
        if (response.data.error) {
          _this2.errorMessage = response.data.error;
        } else {
          _this2.$store.dispatch('auth/attempt', response.data.token).then(function () {
            localStorage.removeItem('USER_NAME');
            localStorage.removeItem('password');
            var nextUrl = _this2.$route.query.redirect == null ? '/dashboard' : _this2.$route.query.redirect;
            _this2.$router.push(nextUrl);
          });
        }
      });
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tfa-setup"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Verifikasi Two-Factor Authentication (2FA)")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('img', {
    staticClass: "img-fluid ",
    attrs: {
      "width": "200",
      "height": "200",
      "src": _vm.$http.options.base + _vm.qr_code_url,
      "alt": "QR CODE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "otp_verification"
    }
  }, [_vm._v("Masukkan OTP dari aplikasi Google Authenticator")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otp_verification),
      expression: "otp_verification"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "otp_verification",
      "placeholder": "Masukkan OTP",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.otp_verification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otp_verification = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {}, [_vm._v("Silahkan Scan Kode QR di bawah untuk menggunakan Two-Factor Authentication")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                      Confirm\n                    ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tfaverify_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a01db2f_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tfaverify_vue__ = __webpack_require__(411);
function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a01db2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tfaverify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a01db2f_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tfaverify_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      otp: '',
      loading: false,
      errorMessage: null,
      username: '',
      password: ''
    };
  },

  methods: {
    submitOtp: function submitOtp() {
      var _this = this;

      this.loading = true;
      this.errorMessage = null;
      var otpData = {
        otp: this.otp,
        USER_NAME: localStorage.getItem('USER_NAME'),
        password: localStorage.getItem('password')
      };

      this.$http.post('otentikasi/signin', otpData).then(function (response) {
        if (response.data.error) {
          _this.errorMessage = response.data.error;
        } else {
          _this.$store.dispatch('auth/attempt', response.data.token).then(function () {
            var nextUrl = _this.$route.query.redirect == null ? '/dashboard' : _this.$route.query.redirect;

            _this.$router.push(nextUrl);
          });
        }
      });
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tfa-verify"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Verifikasi Two-Factor Authentication (2FA)")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitOtp($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "otp"
    }
  }, [_vm._v("Masukkan OTP dari aplikasi Google Authenticator")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otp),
      expression: "otp"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "otp",
      "placeholder": "Masukkan OTP",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.otp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otp = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e()])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Verifikasi\n                ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 412 */,
/* 413 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.auth = {
    setUser: function setUser(user, pass, ppjk, npwp) {
      localStorage.setItem('user', user);
      localStorage.setItem('pass', pass);
      localStorage.setItem('ppjk', ppjk);
      localStorage.setItem('npwp', npwp);
    },
    getUser: function getUser() {
      var user = localStorage.getItem('user');
      var pass = localStorage.getItem('pass');
      var ppjk = localStorage.getItem('ppjk');
      var npwp = localStorage.getItem('npwp');

      if (!user || !pass || !ppjk || !npwp) {
        return null;
      } else {
        return user;
      }
    },
    getPass: function getPass() {
      var user = localStorage.getItem('user');
      var pass = localStorage.getItem('pass');
      var ppjk = localStorage.getItem('ppjk');
      var npwp = localStorage.getItem('npwp');

      if (!user || !pass || !ppjk || !npwp) {
        return null;
      } else {
        return pass;
      }
    },
    getPpjk: function getPpjk() {
      var user = localStorage.getItem('user');
      var pass = localStorage.getItem('pass');
      var ppjk = localStorage.getItem('ppjk');
      var npwp = localStorage.getItem('npwp');

      if (!user || !pass || !ppjk || !npwp) {
        return null;
      } else {
        return ppjk;
      }
    },
    destroyUser: function destroyUser() {
      localStorage.removeItem('user');
      localStorage.removeItem('pass');
      localStorage.removeItem('ppjk');
      localStorage.removeItem('npwp');
    },
    isLoged: function isLoged() {
      if (this.getUser()) {
        return true;
      } else {
        return false;
      }
    }
  };

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
    $auth: {
      get: function get() {
        return Vue.auth;
      }
    }
  });
});

/***/ }),
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    token: null,
    user: null,
    isLoading: false,
    loginAlert: null
  },

  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER: function SET_USER(state, user) {
      state.user = user;
    },
    SET_LOADING: function SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_LOGIN_ALERT: function SET_LOGIN_ALERT(state, alert) {
      state.loginAlert = alert;
    }
  },
  getters: {
    authenticated: function authenticated(state) {
      if (state.user && state.token) {
        return true;
      } else {
        return false;
      }
    },
    user: function user(state) {
      return state.user;
    },
    isLoading: function isLoading(state) {
      return state.isLoading;
    },
    loginAlert: function loginAlert(state) {
      return state.loginAlert;
    }
  },

  actions: {
    login: function login(_ref, credentials) {
      var _this = this;

      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('SET_LOADING', true);
                commit('SET_LOGIN_ALERT', null);

                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('otentikasi/signin', credentials);

              case 5:
                response = _context.sent;

                if (!response.data.tfa_required) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', { data: { tfa_required: true } });

              case 10:
                if (!response.data.tfa_verification_needed) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt('return', { data: { tfa_verification_needed: true } });

              case 14:
                dispatch('attempt', response.data.token);

                setTimeout(function () {
                  commit('SET_LOADING', false);
                  __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: 'dashboard' });
                }, 1000);

              case 16:
                _context.next = 23;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](2);

                __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('Error', 'Username/password tidak sesuai', 'error');
                commit('SET_LOADING', false);
                commit('SET_LOGIN_ALERT', true);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 18]]);
      }))();
    },
    attempt: function attempt(_ref2, token) {
      var _this2 = this;

      var state = _ref2.state,
          commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (token) {
                  commit('SET_TOKEN', token);
                }

                if (state.token) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('otentikasi/me').then(function (response) {
                  commit('SET_USER', response.data);
                });

              case 6:
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](3);

                commit('SET_USER', null);
                commit('SET_TOKEN', null);
                __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: 'login' });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 8]]);
      }))();
    },
    logout: function logout(_ref3) {
      var _this3 = this;

      var state = _ref3.state,
          commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (state.token == null) {
                  __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: 'login' });
                }
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('otentikasi/signout').then(function () {
                  commit('SET_USER', null);
                  commit('SET_TOKEN', null);
                }));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    header: {
      id_aju: '',
      encoded_id: '',
      no_aju: '',
      kd_status: '',
      jns_aju: '',
      tgl_aju: '',
      no_daftar: '',
      tgl_daftar: '',
      no_sppb: '',
      tgl_sppb: '',
      nama: '',
      jns_identitas: '',
      no_identitas: '',
      alamat: '',
      fl_kuasa: false,
      nama_kuasa: '',
      jns_identitas_kuasa: '',
      no_identitas_kuasa: '',
      alamat_kuasa: '',
      moda_angkutan: '',
      nama_sarkut: '',
      no_voyage: '',
      pel_muat: '',
      pel_tujuan: '',
      id_gudang: '',
      bruto: '',
      netto: '',
      tgl_pengeluaran: '',
      no_kk: '',
      tgl_kk: '',
      no_dukcapil: '',
      tgl_dukcapil: '',
      no_surat_pindah: '',
      tgl_pindah: '',
      no_surat_kuasa: '',
      tgl_surat_kuasa: '',
      no_surat_pernyataan: '',
      tgl_surat_pernyataan: '',
      no_surat_rekombp: '',
      tgl_surat_rekombp: '',
      no_pl: '',
      tgl_pl: '',
      no_bpkb: '',
      tgl_bpkb: '',
      no_stnk: '',
      tgl_stnk: '',
      no_ntpn: '',
      tgl_ntpn: '',
      kode_billing: '',
      ref_pel_muat: [],
      ref_pel_tujuan: [],
      fl_hold: false,
      no_bukti_gesek: '',
      tgl_bukti_gesek: ''
    },
    barang: [],
    current_barang: [],
    files: {
      file_identitas_penerima: null,
      file_identitas_pengirim: null,
      file_kk: null,
      file_dukcapil: null,
      file_pindah: null,
      file_kuasa: null,
      file_pernyataan: null,
      file_rekombp: null,
      file_pl: null,
      file_stnk: null,
      file_bpkb: null,
      file_ntpn: null,
      file_billing: null,
      file_lain_lain: null,
      file_bukti_gesek: null
    },
    kontainer: [],
    kemasan: [],
    current_kemasan: [],
    respon: {
      id: '',
      status: ''
    },
    catatan: [],
    isLoadingModal: false,
    current_id_billing: '',
    isLoading: false
  },
  mutations: {
    UPDATE_HEADER: function UPDATE_HEADER(state, payload) {
      state.header[payload.where] = payload.value;
    },
    UPDATE_FILE: function UPDATE_FILE(state, payload) {
      state.files[payload.where] = payload.value;
    },
    ADD_BARANG: function ADD_BARANG(state, payload) {
      state.barang.push(payload);
    },
    REMOVE_BARANG: function REMOVE_BARANG(state, payload) {
      state.barang.splice(payload, 1);
    },
    SET_BARANG: function SET_BARANG(state, payload) {
      state.barang = payload;
    },
    SET_DETIL_BARANG: function SET_DETIL_BARANG(state, payload) {
      state.current_barang = payload;
    },
    UPDATE_BARANG: function UPDATE_BARANG(state, payload) {
      state.current_barang[payload.where] = payload.value;
    },
    SET_RESPON: function SET_RESPON(state, payload) {
      state.respon.id = payload.id;
      state.respon.status = payload.status;
    },
    SET_BILLING_ID: function SET_BILLING_ID(state, payload) {
      state.current_id_billing = payload;
      state.files.file_ntpn = null;
    },
    SET_KONTAINER: function SET_KONTAINER(state, payload) {
      state.kontainer = payload;
    },
    SET_KEMASAN: function SET_KEMASAN(state, payload) {
      state.kemasan = payload;
    },
    SET_DETIL_KEMASAN: function SET_DETIL_KEMASAN(state, payload) {
      state.current_kemasan = payload;
    },
    UPDATE_KEMASAN: function UPDATE_KEMASAN(state, payload) {
      state.current_kemasan[payload.where] = payload.value;
    },
    ADD_KONTAINER: function ADD_KONTAINER(state, payload) {
      state.kontainer.push(payload);
    },
    REMOVE_KONTAINER: function REMOVE_KONTAINER(state, payload) {
      state.kontainer.splice(payload, 1);
    },
    SET_LOADING: function SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_LOADING_MODAL: function SET_LOADING_MODAL(state, payload) {
      state.isLoadingModal = payload;
    },
    SET_HEADER: function SET_HEADER(state, payload) {
      state.header.id_aju = payload.ID_AJU;
      state.header.encoded_id = payload.encoded_id;
      state.header.jns_aju = payload.JNS_AJU;
      state.header.kd_status = payload.KD_STATUS;
      state.header.no_daftar = payload.NO_DAFTAR;
      state.header.tgl_daftar = payload.TGL_DAFTAR;
      state.header.no_sppb = payload.NO_SPPB;
      state.header.tgl_sppb = payload.TGL_SPPB;
      state.header.no_aju = payload.NO_AJU;
      state.header.tgl_aju = payload.TGL_AJU;
      state.header.jns_identitas = payload.JNS_IDENTITAS_PENERIMA;
      state.header.no_identitas = payload.NO_IDENTITAS_PENERIMA;
      state.header.nama = payload.NAMA_PENERIMA;
      state.header.alamat = payload.ALAMAT_PENERIMA;
      state.header.fl_kuasa = payload.FL_KUASA === 1;
      state.header.jns_identitas_kuasa = payload.JNS_IDENTITAS_PENGIRIM;
      state.header.no_identitas_kuasa = payload.NO_IDENTITAS_PENGIRIM;
      state.header.nama_kuasa = payload.NAMA_PENGIRIM;
      state.header.alamat_kuasa = payload.ALAMAT_PENGIRIM;
      state.header.moda_angkutan = payload.MODA_ANGKUTAN;
      state.header.pel_muat = payload.KD_PEL_MUAT;
      state.header.pel_tujuan = payload.KD_PEL_TUJUAN;
      state.header.id_gudang = payload.ID_GUDANG;
      state.header.bruto = payload.BRUTO;
      state.header.netto = payload.NETTO;
      state.header.tgl_pengeluaran = payload.TGL_PENGELUARAN;
      state.header.no_surat_kuasa = payload.NO_SURAT_KUASA;
      state.header.tgl_surat_kuasa = payload.TGL_SURAT_KUASA;
      state.header.no_kk = payload.NO_KK;
      state.header.tgl_kk = payload.TGL_KK;
      state.header.no_dukcapil = payload.NO_DUKCAPIL;
      state.header.tgl_dukcapil = payload.TGL_DUKCAPIL;
      state.header.no_surat_pindah = payload.NO_SURAT_PINDAH;
      state.header.tgl_pindah = payload.TGL_PINDAH;
      state.header.no_surat_pernyataan = payload.NO_SURAT_PERNYATAAN;
      state.header.tgl_surat_pernyataan = payload.TGL_SURAT_PERNYATAAN;
      state.header.no_surat_rekombp = payload.NO_SURAT_REKOMBP;
      state.header.tgl_surat_rekombp = payload.TGL_SURAT_REKOMBP;
      state.header.no_pl = payload.NO_PL;
      state.header.tgl_pl = payload.TGL_PL;
      state.header.nama_sarkut = payload.NAMA_SARKUT;
      state.header.no_voyage = payload.NO_VOYAGE;
      state.header.no_bpkb = payload.NO_BPKB;
      state.header.tgl_bpkb = payload.TGL_BPKB;
      state.header.no_stnk = payload.NO_STNK;
      state.header.tgl_stnk = payload.TGL_STNK;
      state.header.no_ntpn = payload.NO_NTPN;
      state.header.tgl_ntpn = payload.TGL_NTPN;
      state.header.kode_billing = payload.KODE_BILLING;
      state.header.no_bukti_gesek = payload.NO_BUKTI_GESEK;
      state.header.tgl_bukti_gesek = payload.TGL_BUKTI_GESEK;
      state.header.fl_hold = payload.FL_HOLD;
      state.header.no_surat_jalan = payload.NO_SURAT_JALAN;
      state.header.tgl_surat_jalan = payload.TGL_SURAT_JALAN;

      state.files.file_identitas_penerima = payload.FILE_IDENTITAS_PENERIMA;
      state.files.file_identitas_pengirim = payload.FILE_IDENTITAS_PENGIRIM;
      state.files.file_dukcapil = payload.FILE_DUKCAPIL;
      state.files.file_pindah = payload.FILE_PINDAH;
      state.files.file_kk = payload.FILE_KK;
      state.files.file_kuasa = payload.FILE_KUASA;
      state.files.file_rekombp = payload.FILE_REKOMBP;
      state.files.file_pernyataan = payload.FILE_PERNYATAAN;
      state.files.file_pl = payload.FILE_PL;
      state.files.file_stnk = payload.FILE_STNK;
      state.files.file_bpkb = payload.FILE_BPKB;
      state.files.file_ntpn = payload.FILE_NTPN;
      state.files.file_billing = payload.FILE_BILLING;
      state.files.file_bukti_gesek = payload.FILE_BUKTI_GESEK;
      state.files.file_lain_lain = payload.FILE_LAIN_LAIN;
      state.files.file_surat_jalan = payload.FILE_SURAT_JALAN;

      state.header.ref_pel_muat = payload.pelabuhan_muat;
      state.header.ref_pel_tujuan = payload.pelabuhan_tujuan;
    },
    SET_CATATAN: function SET_CATATAN(state, payload) {
      state.catatan = payload;
    }
  },
  getters: {
    kontainer: function kontainer(state) {
      return state.kontainer;
    }
  },
  actions: {
    getData: function getData(_ref, payload) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('ppftz/' + payload).then(function (response) {
        commit('SET_HEADER', response.data);
      });
    },
    saveData: function saveData(_ref2, payload) {
      var commit = _ref2.commit,
          state = _ref2.state,
          dispatch = _ref2.dispatch;

      commit('SET_LOADING', true);
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('ppftz', state.header).then(function () {
        commit('SET_LOADING', false);
      }).then(function () {
        dispatch('getData', payload);
      });
    },
    removeData: function removeData(_ref3, payload) {
      var commit = _ref3.commit;

      commit('SET_LOADING', true);
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete('ppftz', { body: payload }).then(function () {
        commit('SET_LOADING', false);
      });
    },
    setBarang: function setBarang(_ref4, payload) {
      var dispatch = _ref4.dispatch;

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('ppftz/barang', payload).then(function () {
        dispatch('getBarang', payload.id_aju);
      });
    },
    getBarang: function getBarang(_ref5, payload) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('ppftz/barang/' + payload).then(function (response) {
        commit('SET_BARANG', response.data);
      });
    },
    getDetilBarang: function getDetilBarang(_ref6, payload) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('ppftz/barang/detil/' + payload).then(function (response) {
        commit('SET_DETIL_BARANG', response.data);
      });
    },
    removeBarang: function removeBarang(_ref7, payload) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('SET_LOADING', true);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete('ppftz/barang', { body: payload }).then(function () {
        dispatch('getBarang', payload.ID_AJU);
        commit('SET_LOADING', false);
      });
    },
    updateBarang: function updateBarang(_ref8, payload) {
      var dispatch = _ref8.dispatch,
          state = _ref8.state;

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('ppftz/barang', payload).then(function () {
        dispatch('getBarang', state.header.id_aju);
      });
    },
    setKontainer: function setKontainer(_ref9, payload) {
      var dispatch = _ref9.dispatch;

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('ppftz/kontainer', payload).then(function () {
        dispatch('getKontainer', payload.id_aju);
      });
    },
    getKontainer: function getKontainer(_ref10, payload) {
      var commit = _ref10.commit;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('ppftz/kontainer/' + payload).then(function (response) {
        commit('SET_KONTAINER', response.data);
      });
    },
    removeKontainer: function removeKontainer(_ref11, payload) {
      var commit = _ref11.commit,
          dispatch = _ref11.dispatch;

      commit('SET_LOADING', true);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete('ppftz/kontainer', { body: payload }).then(function () {
        dispatch('getKontainer', payload.ID_AJU);
        commit('SET_LOADING', false);
      });
    },
    setKemasan: function setKemasan(_ref12, payload) {
      var dispatch = _ref12.dispatch;

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('ppftz/kemasan', payload).then(function () {
        dispatch('getKemasan', payload.id_aju);
      });
    },
    getKemasan: function getKemasan(_ref13, payload) {
      var commit = _ref13.commit;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('ppftz/kemasan/' + payload).then(function (response) {
        commit('SET_KEMASAN', response.data);
      });
    },
    getDetilKemasan: function getDetilKemasan(_ref14, payload) {
      var commit = _ref14.commit;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('ppftz/kemasan/detil/' + payload).then(function (response) {
        commit('SET_DETIL_KEMASAN', response.data);
      });
    },
    updateKemasan: function updateKemasan(_ref15, payload) {
      var dispatch = _ref15.dispatch,
          state = _ref15.state;

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('ppftz/kemasan', payload).then(function () {
        dispatch('getKemasan', state.header.id_aju);
      });
    },
    setFile: function setFile(_ref16, payload) {
      var commit = _ref16.commit;

      commit('SET_LOADING', true);
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('ppftz/upload', payload).then(function (res) {
        var file = {
          where: payload.key_file,
          value: res.data.filename
        };
        commit('UPDATE_FILE', file);
        commit('SET_LOADING', false);
      });
    },
    getCatatan: function getCatatan(_ref17, payload) {
      var commit = _ref17.commit;

      commit('SET_LOADING_MODAL', true);
      var data = {
        ID_AJU: payload
      };
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('catatan', data).then(function (response) {
        commit('SET_LOADING_MODAL', false);
        commit('SET_CATATAN', response.data);
      });
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  username: '',
  password: '',
  secretKey: ''
};

var mutations = {
  setUserData: function setUserData(state, _ref) {
    var username = _ref.username,
        password = _ref.password,
        secretKey = _ref.secretKey,
        qrCodeUrl = _ref.qrCodeUrl;

    state.username = username;
    state.password = password;
    state.secret_key = secretKey;
    state.qr_code_url = qrCodeUrl;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations
});

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */,
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);




__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].subscribe(function (mutation) {
  switch (mutation.type) {
    case 'auth/SET_TOKEN':
      if (mutation.payload) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + mutation.payload;
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + mutation.payload;
        localStorage.setItem('token', mutation.payload);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['Authorization'] = null;
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.headers.common['Authorization'] = null;
        localStorage.removeItem('token');
      }
      break;
  }
});

/***/ })
]),[76]);


// WEBPACK FOOTER //
// static/js/app.f6fce63a0f9c0873aeed.js